export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `Byte` scalar type represents non-fractional whole numeric values. Byte can represent values between 0 and 255. */
  Byte: { input: any; output: any; }
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: { input: string; output: string; }
  /** The `Decimal` scalar type represents a decimal floating-point number. */
  Decimal: { input: number; output: number; }
  /** The `LocalDate` scalar type represents a ISO date string, represented as UTF-8 character sequences YYYY-MM-DD. The scalar follows the specification defined in RFC3339 */
  LocalDate: { input: any; output: any; }
  /** The LocalTime scalar type is a local time string (i.e., with no associated timezone) in 24-hr HH:mm:ss. */
  LocalTime: { input: string; output: string; }
  /** The `Long` scalar type represents non-fractional signed whole 64-bit numeric values. Long can represent values between -(2^63) and 2^63 - 1. */
  Long: { input: any; output: any; }
  /** Represents a decimal value greater than zero with two decimal places of precision (currency). */
  PositiveDecimal: { input: any; output: any; }
  /** Represents an integer greater than zero. */
  PositiveInt: { input: any; output: any; }
  /** Represents a decimal value greater than or equal to zero with two decimal places of precision (currency). */
  PositiveOrZeroDecimal: { input: any; output: any; }
  /** Represents an integer greater than or equal to zero. */
  PositiveOrZeroInt: { input: any; output: any; }
  /** Represents a string with a maximum length of 10 characters */
  String10: { input: any; output: any; }
  /** Represents a string with a maximum length of 20 characters */
  String20: { input: any; output: any; }
  /** Represents a string with a maximum length of 45 characters */
  String45: { input: any; output: any; }
  /** Represents a string with a maximum length of 50 characters */
  String50: { input: any; output: any; }
  /** Represents a string with a maximum length of 64 characters */
  String64: { input: any; output: any; }
  /** Represents a string with a maximum length of 100 characters */
  String100: { input: any; output: any; }
  /** Represents a string with a maximum length of 255 characters */
  String255: { input: any; output: any; }
  /** Represents a string with a maximum length of 500 characters */
  String500: { input: any; output: any; }
  /** Represents a string with a maximum length of 1000 characters */
  String1000: { input: any; output: any; }
  /** Represents a string with a maximum length of 4000 characters */
  String4000: { input: any; output: any; }
  /** Represents a Ulid. The input is a 26-character string that conforms to the ULID format. */
  Ulid: { input: string; output: string; }
};

export type AadeInvoiceViewModel = {
  __typename?: 'AadeInvoiceViewModel';
  aadeInvoiceId: Scalars['Ulid']['output'];
  invoiceMark?: Maybe<Scalars['String255']['output']>;
  invoiceUid?: Maybe<Scalars['String255']['output']>;
  parkingSession: ParkingSessionViewModel;
  parkingSessionId: Scalars['Ulid']['output'];
  series?: Maybe<Scalars['String255']['output']>;
};

export type ActionTypeViewModel = {
  __typename?: 'ActionTypeViewModel';
  actionTypeId?: Maybe<Scalars['PositiveInt']['output']>;
  logs: Array<LogViewModel>;
  name?: Maybe<Scalars['String255']['output']>;
};

export type ActionTypeViewModelSortInput = {
  actionTypeId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type AddressTypeViewModel = {
  __typename?: 'AddressTypeViewModel';
  addressTypeId?: Maybe<Scalars['PositiveInt']['output']>;
  customerAddresses: Array<CustomerAddressViewModel>;
  name?: Maybe<Scalars['String255']['output']>;
};

export type AddressTypeViewModelFilterInput = {
  addressTypeId?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<AddressTypeViewModelFilterInput>>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AddressTypeViewModelFilterInput>>;
};

export type AddressTypeViewModelSortInput = {
  addressTypeId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type AddressViewModel = {
  __typename?: 'AddressViewModel';
  addressId: Scalars['Ulid']['output'];
  city?: Maybe<Scalars['String255']['output']>;
  country?: Maybe<Scalars['String255']['output']>;
  customerAddresses: Array<CustomerAddressViewModel>;
  facilities: Array<FacilityViewModel>;
  postalCode?: Maybe<Scalars['String50']['output']>;
  state?: Maybe<Scalars['String255']['output']>;
  streetAddress?: Maybe<Scalars['String500']['output']>;
};

export type AddressViewModelSortInput = {
  addressId?: InputMaybe<SortEnumType>;
  city?: InputMaybe<SortEnumType>;
  country?: InputMaybe<SortEnumType>;
  postalCode?: InputMaybe<SortEnumType>;
  state?: InputMaybe<SortEnumType>;
  streetAddress?: InputMaybe<SortEnumType>;
};

export enum AlertCode {
  CapacityThreshold = 'CAPACITY_THRESHOLD',
  General = 'GENERAL',
  Maintenance = 'MAINTENANCE',
  PaymentGatewayIssue = 'PAYMENT_GATEWAY_ISSUE',
  SecurityEvent = 'SECURITY_EVENT'
}

export type AlertCodeOperationFilterInput = {
  eq?: InputMaybe<AlertCode>;
  in?: InputMaybe<Array<AlertCode>>;
  neq?: InputMaybe<AlertCode>;
  nin?: InputMaybe<Array<AlertCode>>;
};

export type AlertCreatedPayload = {
  __typename?: 'AlertCreatedPayload';
  alertId: Scalars['Ulid']['output'];
  createdAt: Scalars['DateTime']['output'];
  facilityId: Scalars['Ulid']['output'];
  message?: Maybe<Scalars['String1000']['output']>;
  relatedEntityId?: Maybe<Scalars['Ulid']['output']>;
  relatedEntityType?: Maybe<Scalars['String100']['output']>;
  severity: AlertSeverityType;
  source?: Maybe<Scalars['String255']['output']>;
  title?: Maybe<Scalars['String255']['output']>;
};

export enum AlertCriticality {
  Critical = 'CRITICAL',
  Info = 'INFO',
  Warning = 'WARNING'
}

export type AlertCriticalityOperationFilterInput = {
  eq?: InputMaybe<AlertCriticality>;
  in?: InputMaybe<Array<AlertCriticality>>;
  neq?: InputMaybe<AlertCriticality>;
  nin?: InputMaybe<Array<AlertCriticality>>;
};

export enum AlertDuration {
  LongTerm = 'LONG_TERM',
  ShortTerm = 'SHORT_TERM'
}

export type AlertDurationOperationFilterInput = {
  eq?: InputMaybe<AlertDuration>;
  in?: InputMaybe<Array<AlertDuration>>;
  neq?: InputMaybe<AlertDuration>;
  nin?: InputMaybe<Array<AlertDuration>>;
};

export enum AlertSeverityType {
  Critical = 'CRITICAL',
  Error = 'ERROR',
  Info = 'INFO',
  Warning = 'WARNING'
}

export type AlertUserReadViewModel = {
  __typename?: 'AlertUserReadViewModel';
  alert: AlertViewModel;
  alertId: Scalars['Ulid']['output'];
  alertUserReadId: Scalars['Ulid']['output'];
  facilityId: Scalars['Ulid']['output'];
  readAt: Scalars['DateTime']['output'];
  user: UserViewModel;
  userId: Scalars['Ulid']['output'];
};

export type AlertUserReadViewModelFilterInput = {
  alertId?: InputMaybe<UlidExtendedFilterInput>;
  alertUserReadId?: InputMaybe<UlidExtendedFilterInput>;
  and?: InputMaybe<Array<AlertUserReadViewModelFilterInput>>;
  facilityId?: InputMaybe<UlidExtendedFilterInput>;
  or?: InputMaybe<Array<AlertUserReadViewModelFilterInput>>;
  readAt?: InputMaybe<DateTimeOperationFilterInput>;
  userId?: InputMaybe<UlidExtendedFilterInput>;
};

export type AlertUserReadViewModelSortInput = {
  alert?: InputMaybe<AlertViewModelSortInput>;
  alertId?: InputMaybe<SortEnumType>;
  alertUserReadId?: InputMaybe<SortEnumType>;
  facilityId?: InputMaybe<SortEnumType>;
  readAt?: InputMaybe<SortEnumType>;
  user?: InputMaybe<UserViewModelSortInput>;
  userId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type AlertUserReadsConnection = {
  __typename?: 'AlertUserReadsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AlertUserReadsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AlertUserReadViewModel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AlertUserReadsEdge = {
  __typename?: 'AlertUserReadsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AlertUserReadViewModel;
};

export type AlertViewModel = {
  __typename?: 'AlertViewModel';
  alertId: Scalars['Ulid']['output'];
  code: AlertCode;
  createdAt: Scalars['DateTime']['output'];
  criticality: AlertCriticality;
  duration: AlertDuration;
  facilityId: Scalars['Ulid']['output'];
  payload?: Maybe<Scalars['String4000']['output']>;
  userReads: Array<AlertUserReadViewModel>;
};

export type AlertViewModelFilterInput = {
  alertId?: InputMaybe<UlidExtendedFilterInput>;
  and?: InputMaybe<Array<AlertViewModelFilterInput>>;
  code?: InputMaybe<AlertCodeOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  criticality?: InputMaybe<AlertCriticalityOperationFilterInput>;
  duration?: InputMaybe<AlertDurationOperationFilterInput>;
  facilityId?: InputMaybe<UlidExtendedFilterInput>;
  or?: InputMaybe<Array<AlertViewModelFilterInput>>;
  payload?: InputMaybe<StringOperationFilterInput>;
};

export type AlertViewModelSortInput = {
  alertId?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  criticality?: InputMaybe<SortEnumType>;
  duration?: InputMaybe<SortEnumType>;
  facilityId?: InputMaybe<SortEnumType>;
  payload?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type AlertsByCodeConnection = {
  __typename?: 'AlertsByCodeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AlertsByCodeEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AlertViewModel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AlertsByCodeEdge = {
  __typename?: 'AlertsByCodeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AlertViewModel;
};

/** A connection to a list of items. */
export type AlertsConnection = {
  __typename?: 'AlertsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AlertsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AlertViewModel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AlertsEdge = {
  __typename?: 'AlertsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AlertViewModel;
};

/** Defines when a policy shall be executed. */
export enum ApplyPolicy {
  /** After the resolver was executed. */
  AfterResolver = 'AFTER_RESOLVER',
  /** Before the resolver was executed. */
  BeforeResolver = 'BEFORE_RESOLVER',
  /** The policy is applied in the validation step before the execution. */
  Validation = 'VALIDATION'
}

/** A connection to a list of items. */
export type AuditLogsConnection = {
  __typename?: 'AuditLogsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AuditLogsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<LogViewModel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AuditLogsEdge = {
  __typename?: 'AuditLogsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: LogViewModel;
};

export type BankDetailsViewModel = {
  __typename?: 'BankDetailsViewModel';
  accountHolderName?: Maybe<Scalars['String255']['output']>;
  accountNumber?: Maybe<Scalars['String255']['output']>;
  accountType?: Maybe<Scalars['String255']['output']>;
  bankCode?: Maybe<Scalars['String255']['output']>;
  bankDetailsId: Scalars['Ulid']['output'];
  bankName?: Maybe<Scalars['String255']['output']>;
  branchCode?: Maybe<Scalars['String255']['output']>;
  branchName?: Maybe<Scalars['String255']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String255']['output']>;
  customer: CustomerViewModel;
  customerId: Scalars['Ulid']['output'];
  iban?: Maybe<Scalars['String255']['output']>;
  isActive: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isPrimary: Scalars['Boolean']['output'];
  isVerified: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String1000']['output']>;
  purpose?: Maybe<Scalars['String255']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  verificationMethod?: Maybe<Scalars['String255']['output']>;
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BankDetailsViewModelFilterInput = {
  accountHolderName?: InputMaybe<StringOperationFilterInput>;
  accountNumber?: InputMaybe<StringOperationFilterInput>;
  accountType?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<BankDetailsViewModelFilterInput>>;
  bankCode?: InputMaybe<StringOperationFilterInput>;
  bankDetailsId?: InputMaybe<UlidExtendedFilterInput>;
  bankName?: InputMaybe<StringOperationFilterInput>;
  branchCode?: InputMaybe<StringOperationFilterInput>;
  branchName?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  currency?: InputMaybe<StringOperationFilterInput>;
  customerId?: InputMaybe<UlidExtendedFilterInput>;
  iban?: InputMaybe<StringOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  isPrimary?: InputMaybe<BooleanOperationFilterInput>;
  isVerified?: InputMaybe<BooleanOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BankDetailsViewModelFilterInput>>;
  purpose?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  verificationMethod?: InputMaybe<StringOperationFilterInput>;
  verifiedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type BankDetailsViewModelSortInput = {
  accountHolderName?: InputMaybe<SortEnumType>;
  accountNumber?: InputMaybe<SortEnumType>;
  accountType?: InputMaybe<SortEnumType>;
  bankCode?: InputMaybe<SortEnumType>;
  bankDetailsId?: InputMaybe<SortEnumType>;
  bankName?: InputMaybe<SortEnumType>;
  branchCode?: InputMaybe<SortEnumType>;
  branchName?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  currency?: InputMaybe<SortEnumType>;
  customer?: InputMaybe<CustomerViewModelSortInput>;
  customerId?: InputMaybe<SortEnumType>;
  iban?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  isPrimary?: InputMaybe<SortEnumType>;
  isVerified?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  purpose?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  verificationMethod?: InputMaybe<SortEnumType>;
  verifiedAt?: InputMaybe<SortEnumType>;
};

export type BankViewModel = {
  __typename?: 'BankViewModel';
  bankId: Scalars['Ulid']['output'];
  code?: Maybe<Scalars['String50']['output']>;
  createdAt: Scalars['DateTime']['output'];
  facility?: Maybe<FacilityViewModel>;
  facilityId: Scalars['Ulid']['output'];
  isActive: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String255']['output']>;
  sapCode?: Maybe<Scalars['String50']['output']>;
  sortOrder?: Maybe<Scalars['PositiveInt']['output']>;
};

export type BankViewModelFilterInput = {
  and?: InputMaybe<Array<BankViewModelFilterInput>>;
  bankId?: InputMaybe<UlidExtendedFilterInput>;
  code?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  facility?: InputMaybe<FacilityViewModelFilterInput>;
  facilityId?: InputMaybe<UlidExtendedFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BankViewModelFilterInput>>;
  sapCode?: InputMaybe<StringOperationFilterInput>;
  sortOrder?: InputMaybe<IntOperationFilterInput>;
};

export type BankViewModelSortInput = {
  bankId?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  facility?: InputMaybe<FacilityViewModelSortInput>;
  facilityId?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  sapCode?: InputMaybe<SortEnumType>;
  sortOrder?: InputMaybe<SortEnumType>;
};

export type BeneficiaryDetailsViewModels = {
  __typename?: 'BeneficiaryDetailsViewModels';
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  companyRegistrationNumber?: Maybe<Scalars['String100']['output']>;
  companySize?: Maybe<Scalars['String50']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customerCategoryId: Scalars['Ulid']['output'];
  customerId: Scalars['Ulid']['output'];
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  displayName?: Maybe<Scalars['String255']['output']>;
  email?: Maybe<Scalars['String255']['output']>;
  firmName?: Maybe<Scalars['String255']['output']>;
  firstName?: Maybe<Scalars['String100']['output']>;
  fiscalNumber?: Maybe<Scalars['String50']['output']>;
  gender?: Maybe<Scalars['String50']['output']>;
  idNumber?: Maybe<Scalars['String100']['output']>;
  idType?: Maybe<Scalars['String50']['output']>;
  industry?: Maybe<Scalars['String100']['output']>;
  isActive: Scalars['Boolean']['output'];
  isCompany: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String100']['output']>;
  marketingOptIn: Scalars['Boolean']['output'];
  nationality?: Maybe<Scalars['String100']['output']>;
  notes?: Maybe<Scalars['String1000']['output']>;
  preferredLanguage?: Maybe<Scalars['String10']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type BeneficiaryDetailsViewModelsSortInput = {
  activatedAt?: InputMaybe<SortEnumType>;
  companyRegistrationNumber?: InputMaybe<SortEnumType>;
  companySize?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  customerCategoryId?: InputMaybe<SortEnumType>;
  customerId?: InputMaybe<SortEnumType>;
  dateOfBirth?: InputMaybe<SortEnumType>;
  deactivatedAt?: InputMaybe<SortEnumType>;
  displayName?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  firmName?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  fiscalNumber?: InputMaybe<SortEnumType>;
  gender?: InputMaybe<SortEnumType>;
  idNumber?: InputMaybe<SortEnumType>;
  idType?: InputMaybe<SortEnumType>;
  industry?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  isCompany?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  marketingOptIn?: InputMaybe<SortEnumType>;
  nationality?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  preferredLanguage?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

export type BillingCycleViewModel = {
  __typename?: 'BillingCycleViewModel';
  billingCycleId: Scalars['PositiveInt']['output'];
  limitPolicies: Array<LimitPolicyViewModel>;
  name: Scalars['String255']['output'];
  pricingPolicies: Array<PricingPolicyViewModel>;
};

export type BillingCycleViewModelSortInput = {
  billingCycleId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type BlacklistEntriesConnection = {
  __typename?: 'BlacklistEntriesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<BlacklistEntriesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<PlateNumberBlacklistViewModel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BlacklistEntriesEdge = {
  __typename?: 'BlacklistEntriesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PlateNumberBlacklistViewModel;
};

export type BooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ByteOperationFilterInput = {
  eq?: InputMaybe<Scalars['Byte']['input']>;
  gt?: InputMaybe<Scalars['Byte']['input']>;
  gte?: InputMaybe<Scalars['Byte']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Byte']['input']>>>;
  lt?: InputMaybe<Scalars['Byte']['input']>;
  lte?: InputMaybe<Scalars['Byte']['input']>;
  neq?: InputMaybe<Scalars['Byte']['input']>;
  ngt?: InputMaybe<Scalars['Byte']['input']>;
  ngte?: InputMaybe<Scalars['Byte']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Byte']['input']>>>;
  nlt?: InputMaybe<Scalars['Byte']['input']>;
  nlte?: InputMaybe<Scalars['Byte']['input']>;
};

export type CampaignViewModel = {
  __typename?: 'CampaignViewModel';
  campaignId: Scalars['Ulid']['output'];
  description?: Maybe<Scalars['String1000']['output']>;
  endDate: Scalars['DateTime']['output'];
  facility: FacilityViewModel;
  facilityId: Scalars['Ulid']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String255']['output'];
  startDate: Scalars['DateTime']['output'];
  vouchers: Array<VoucherViewModel>;
};

export type CampaignViewModelFilterInput = {
  and?: InputMaybe<Array<CampaignViewModelFilterInput>>;
  campaignId?: InputMaybe<UlidExtendedFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  facilityId?: InputMaybe<UlidExtendedFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CampaignViewModelFilterInput>>;
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
};

export type CampaignViewModelSortInput = {
  campaignId?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  facility?: InputMaybe<FacilityViewModelSortInput>;
  facilityId?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type CampaignsConnection = {
  __typename?: 'CampaignsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CampaignsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CampaignViewModel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CampaignsEdge = {
  __typename?: 'CampaignsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CampaignViewModel;
};

export enum CancelReason {
  DuplicateEntry = 'DUPLICATE_ENTRY',
  Unknown = 'UNKNOWN',
  VehicleBackedUp = 'VEHICLE_BACKED_UP'
}

export enum CardStatusEnum {
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED',
  Expired = 'EXPIRED',
  Lost = 'LOST',
  Replaced = 'REPLACED',
  Returned = 'RETURNED',
  Suspended = 'SUSPENDED'
}

export enum CardType {
  Barcode = 'BARCODE',
  Magnetic = 'MAGNETIC',
  Rfid = 'RFID'
}

export type CashierShiftStatusViewModel = {
  __typename?: 'CashierShiftStatusViewModel';
  cashierShiftStatusId?: Maybe<Scalars['PositiveInt']['output']>;
  cashierShifts: Array<CashierShiftViewModel>;
  name?: Maybe<Scalars['String255']['output']>;
};

export type CashierShiftStatusViewModelSortInput = {
  cashierShiftStatusId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type CashierShiftViewModel = {
  __typename?: 'CashierShiftViewModel';
  cashierShiftId: Scalars['Ulid']['output'];
  chargeLedgerEntries: Array<ChargeLedgerEntryViewModel>;
  endingCashBalance?: Maybe<Scalars['PositiveOrZeroDecimal']['output']>;
  facility: FacilityViewModel;
  facilityId: Scalars['Ulid']['output'];
  parkingSessions: Array<ParkingSessionViewModel>;
  shiftEndDateTime?: Maybe<Scalars['DateTime']['output']>;
  shiftStartDateTime: Scalars['DateTime']['output'];
  startingCashBalance?: Maybe<Scalars['PositiveOrZeroDecimal']['output']>;
  status: CashierShiftStatusViewModel;
  statusId?: Maybe<Scalars['PositiveInt']['output']>;
  user: UserViewModel;
  userId: Scalars['Ulid']['output'];
  vehicleJourneyLogs: Array<VehicleJourneyLogViewModel>;
};

export type CashierShiftViewModelSortInput = {
  cashierShiftId?: InputMaybe<SortEnumType>;
  endingCashBalance?: InputMaybe<SortEnumType>;
  facility?: InputMaybe<FacilityViewModelSortInput>;
  facilityId?: InputMaybe<SortEnumType>;
  shiftEndDateTime?: InputMaybe<SortEnumType>;
  shiftStartDateTime?: InputMaybe<SortEnumType>;
  startingCashBalance?: InputMaybe<SortEnumType>;
  status?: InputMaybe<CashierShiftStatusViewModelSortInput>;
  statusId?: InputMaybe<SortEnumType>;
  user?: InputMaybe<UserViewModelSortInput>;
  userId?: InputMaybe<SortEnumType>;
};

export enum ChangeParkingSessionError {
  ContractExpired = 'CONTRACT_EXPIRED',
  ContractNotFound = 'CONTRACT_NOT_FOUND',
  ContractSuspended = 'CONTRACT_SUSPENDED',
  ContractVehicleLimitExceeded = 'CONTRACT_VEHICLE_LIMIT_EXCEEDED',
  DatabaseError = 'DATABASE_ERROR',
  InvalidStatusTransition = 'INVALID_STATUS_TRANSITION',
  ParkingSessionNotActive = 'PARKING_SESSION_NOT_ACTIVE',
  ParkingSessionNotFound = 'PARKING_SESSION_NOT_FOUND',
  VehicleHasActiveSession = 'VEHICLE_HAS_ACTIVE_SESSION',
  VehicleNotAssociatedWithContract = 'VEHICLE_NOT_ASSOCIATED_WITH_CONTRACT'
}

export type ChangeParkingSessionInput = {
  contractId?: InputMaybe<Scalars['Ulid']['input']>;
  parkingSessionId: Scalars['Ulid']['input'];
  plateNumber?: InputMaybe<Scalars['String50']['input']>;
  status: ParkingSessionStatus;
};

export type ChargeLedgerEntryLineViewModel = {
  __typename?: 'ChargeLedgerEntryLineViewModel';
  calculatedAt: Scalars['DateTime']['output'];
  chargeLedgerEntry: ChargeLedgerEntryViewModel;
  chargeLedgerEntryId: Scalars['Ulid']['output'];
  chargeLedgerEntryLineId: Scalars['Ulid']['output'];
  description?: Maybe<Scalars['String500']['output']>;
  lineCharge?: Maybe<Scalars['PositiveOrZeroDecimal']['output']>;
  lineDataJson?: Maybe<Scalars['String']['output']>;
  lineEndDateTime?: Maybe<Scalars['DateTime']['output']>;
  lineSequence?: Maybe<Scalars['PositiveInt']['output']>;
  lineStartDateTime?: Maybe<Scalars['DateTime']['output']>;
};

export type ChargeLedgerEntryViewModel = {
  __typename?: 'ChargeLedgerEntryViewModel';
  amount: Scalars['Decimal']['output'];
  bank?: Maybe<BankViewModel>;
  bankId?: Maybe<Scalars['Ulid']['output']>;
  cashierShift?: Maybe<CashierShiftViewModel>;
  cashierShiftId?: Maybe<Scalars['Ulid']['output']>;
  chargeAfterLimits?: Maybe<Scalars['PositiveOrZeroDecimal']['output']>;
  chargeLedgerEntryId: Scalars['Ulid']['output'];
  computedCharge?: Maybe<Scalars['PositiveOrZeroDecimal']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String500']['output']>;
  facility?: Maybe<FacilityViewModel>;
  facilityId?: Maybe<Scalars['Ulid']['output']>;
  isReversed: Scalars['Boolean']['output'];
  lines: Array<ChargeLedgerEntryLineViewModel>;
  parkingSession?: Maybe<ParkingSessionViewModel>;
  parkingSessionId?: Maybe<Scalars['Ulid']['output']>;
  paymentMethod?: Maybe<PaymentMethodViewModel>;
  paymentMethodId?: Maybe<Scalars['PositiveInt']['output']>;
  relatedDataJson?: Maybe<Scalars['String']['output']>;
  relatedEntityId?: Maybe<Scalars['Ulid']['output']>;
  relatedEntityType?: Maybe<Scalars['String50']['output']>;
  reversalEntry?: Maybe<ChargeLedgerEntryViewModel>;
  reversalEntryId?: Maybe<Scalars['Ulid']['output']>;
  reversedEntries: Array<ChargeLedgerEntryViewModel>;
  transactionDateTime: Scalars['DateTime']['output'];
  transactionType: OperationsTransactionTypeViewModel;
  transactionTypeId?: Maybe<Scalars['PositiveInt']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CheckResult = {
  __typename?: 'CheckResult';
  errorCode?: Maybe<Scalars['String']['output']>;
  errorDescription?: Maybe<Scalars['String']['output']>;
  failed: Scalars['Boolean']['output'];
  isErrored: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
};

export type CheckResultEnumOfChangeParkingSessionError = {
  __typename?: 'CheckResultEnumOfChangeParkingSessionError';
  error: ErrorResultOfChangeParkingSessionError;
  errorCode?: Maybe<ChangeParkingSessionError>;
  errorDescription?: Maybe<Scalars['String']['output']>;
  failed: Scalars['Boolean']['output'];
  isErrored: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
};

export type CheckResultEnumOfCreateParkingSessionError = {
  __typename?: 'CheckResultEnumOfCreateParkingSessionError';
  error: ErrorResultOfCreateParkingSessionError;
  errorCode?: Maybe<CreateParkingSessionError>;
  errorDescription?: Maybe<Scalars['String']['output']>;
  failed: Scalars['Boolean']['output'];
  isErrored: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
};

export enum ColumnAggregationType {
  Avg = 'AVG',
  Count = 'COUNT',
  Max = 'MAX',
  Min = 'MIN',
  Sum = 'SUM'
}

export enum ColumnAlignment {
  Center = 'CENTER',
  Left = 'LEFT',
  Right = 'RIGHT'
}

export type ConditionCustomerCategoryViewModel = {
  __typename?: 'ConditionCustomerCategoryViewModel';
  condition: ConditionViewModel;
  conditionId: Scalars['Ulid']['output'];
  customerCategory: CustomerCategoryViewModel;
  customerCategoryId: Scalars['Ulid']['output'];
};

export type ConditionDayOfWeekViewModel = {
  __typename?: 'ConditionDayOfWeekViewModel';
  condition: ConditionViewModel;
  conditionId: Scalars['Ulid']['output'];
  dayOfWeek: DayOfWeekViewModel;
  dayOfWeekId: Scalars['PositiveInt']['output'];
};

export enum ConditionOperator {
  Exclude = 'EXCLUDE',
  Include = 'INCLUDE'
}

export type ConditionPaymentMethodViewModel = {
  __typename?: 'ConditionPaymentMethodViewModel';
  condition: ConditionViewModel;
  conditionId: Scalars['Ulid']['output'];
  paymentMethod: PaymentMethodViewModel;
  paymentMethodId: Scalars['PositiveInt']['output'];
};

export type ConditionVehicleTypeViewModel = {
  __typename?: 'ConditionVehicleTypeViewModel';
  condition: ConditionViewModel;
  conditionId: Scalars['Ulid']['output'];
  vehicleType: VehicleTypeViewModel;
  vehicleTypeId: Scalars['PositiveInt']['output'];
};

export type ConditionViewModel = {
  __typename?: 'ConditionViewModel';
  appliesOnHolidays: Scalars['Boolean']['output'];
  appliesToSpecificCustomerCategories: Scalars['Boolean']['output'];
  appliesToSpecificPaymentMethods: Scalars['Boolean']['output'];
  appliesToSpecificVehicleTypes: Scalars['Boolean']['output'];
  arrivingSince?: Maybe<Scalars['LocalTime']['output']>;
  arrivingUntil?: Maybe<Scalars['LocalTime']['output']>;
  conditionCustomerCategories: Array<ConditionCustomerCategoryViewModel>;
  conditionDayOfWeeks: Array<ConditionDayOfWeekViewModel>;
  conditionId: Scalars['Ulid']['output'];
  conditionPaymentMethods: Array<ConditionPaymentMethodViewModel>;
  conditionVehicleTypes: Array<ConditionVehicleTypeViewModel>;
  description: Scalars['String255']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  isContractOverstay: Scalars['Boolean']['output'];
  isOverstay: Scalars['Boolean']['output'];
  leavingSince?: Maybe<Scalars['LocalTime']['output']>;
  leavingUntil?: Maybe<Scalars['LocalTime']['output']>;
  maxStayMinutes?: Maybe<Scalars['PositiveOrZeroInt']['output']>;
  minStayMinutes?: Maybe<Scalars['PositiveOrZeroInt']['output']>;
  scenarioConditions: Array<ScenarioConditionViewModel>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  weeklyDateSet: WeeklyDateSetViewModel;
  weeklyDateSetId: Scalars['PositiveInt']['output'];
};

export type ConditionViewModelFilterInput = {
  and?: InputMaybe<Array<ConditionViewModelFilterInput>>;
  appliesOnHolidays?: InputMaybe<BooleanOperationFilterInput>;
  appliesToSpecificCustomerCategories?: InputMaybe<BooleanOperationFilterInput>;
  appliesToSpecificPaymentMethods?: InputMaybe<BooleanOperationFilterInput>;
  appliesToSpecificVehicleTypes?: InputMaybe<BooleanOperationFilterInput>;
  arrivingSince?: InputMaybe<LocalTimeOperationFilterInput>;
  arrivingUntil?: InputMaybe<LocalTimeOperationFilterInput>;
  conditionId?: InputMaybe<UlidExtendedFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  isContractOverstay?: InputMaybe<BooleanOperationFilterInput>;
  isOverstay?: InputMaybe<BooleanOperationFilterInput>;
  leavingSince?: InputMaybe<LocalTimeOperationFilterInput>;
  leavingUntil?: InputMaybe<LocalTimeOperationFilterInput>;
  maxStayMinutes?: InputMaybe<IntOperationFilterInput>;
  minStayMinutes?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ConditionViewModelFilterInput>>;
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  weeklyDateSetId?: InputMaybe<IntOperationFilterInput>;
};

export type ConditionViewModelSortInput = {
  appliesOnHolidays?: InputMaybe<SortEnumType>;
  appliesToSpecificCustomerCategories?: InputMaybe<SortEnumType>;
  appliesToSpecificPaymentMethods?: InputMaybe<SortEnumType>;
  appliesToSpecificVehicleTypes?: InputMaybe<SortEnumType>;
  arrivingSince?: InputMaybe<SortEnumType>;
  arrivingUntil?: InputMaybe<SortEnumType>;
  conditionId?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  isContractOverstay?: InputMaybe<SortEnumType>;
  isOverstay?: InputMaybe<SortEnumType>;
  leavingSince?: InputMaybe<SortEnumType>;
  leavingUntil?: InputMaybe<SortEnumType>;
  maxStayMinutes?: InputMaybe<SortEnumType>;
  minStayMinutes?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  weeklyDateSet?: InputMaybe<WeeklyDateSetViewModelSortInput>;
  weeklyDateSetId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ConditionsConnection = {
  __typename?: 'ConditionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ConditionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ConditionViewModel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ConditionsEdge = {
  __typename?: 'ConditionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ConditionViewModel;
};

export type ContactTypeViewModel = {
  __typename?: 'ContactTypeViewModel';
  contactTypeId: Scalars['Int']['output'];
  customerContacts: Array<CustomerContactViewModel>;
  description?: Maybe<Scalars['String1000']['output']>;
  isActive: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String255']['output']>;
};

export type ContactTypeViewModelFilterInput = {
  and?: InputMaybe<Array<ContactTypeViewModelFilterInput>>;
  contactTypeId?: InputMaybe<IntOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ContactTypeViewModelFilterInput>>;
};

export type ContactTypeViewModelSortInput = {
  contactTypeId?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type ContractCardInput = {
  cardKey: Scalars['String255']['input'];
  cardStatusId: CardStatusEnum;
  cardType: CardType;
  facilityId: Scalars['Ulid']['input'];
};

export type ContractCardViewModel = {
  __typename?: 'ContractCardViewModel';
  cardKey?: Maybe<Scalars['String255']['output']>;
  cardStatusId: CardStatusEnum;
  cardType: CardType;
  contract: ContractViewModel;
  contractCardId: Scalars['Ulid']['output'];
  contractId: Scalars['Ulid']['output'];
  createdAt: Scalars['DateTime']['output'];
  depositTransaction?: Maybe<GuaranteeTransactionViewModel>;
  depositTransactionId?: Maybe<Scalars['Ulid']['output']>;
  facility: FacilityViewModel;
  facilityId: Scalars['Ulid']['output'];
  guaranteeTransactions: Array<GuaranteeTransactionViewModel>;
  returnTransaction?: Maybe<GuaranteeTransactionViewModel>;
  returnTransactionId?: Maybe<Scalars['Ulid']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ContractCardViewModelSortInput = {
  cardKey?: InputMaybe<SortEnumType>;
  cardStatusId?: InputMaybe<SortEnumType>;
  cardType?: InputMaybe<SortEnumType>;
  contract?: InputMaybe<ContractViewModelSortInput>;
  contractCardId?: InputMaybe<SortEnumType>;
  contractId?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  depositTransaction?: InputMaybe<GuaranteeTransactionViewModelSortInput>;
  depositTransactionId?: InputMaybe<SortEnumType>;
  facility?: InputMaybe<FacilityViewModelSortInput>;
  facilityId?: InputMaybe<SortEnumType>;
  returnTransaction?: InputMaybe<GuaranteeTransactionViewModelSortInput>;
  returnTransactionId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

export type ContractVehicleViewModel = {
  __typename?: 'ContractVehicleViewModel';
  contract: ContractViewModel;
  contractId: Scalars['Ulid']['output'];
  vehicle: VehicleViewModel;
  vehicleId: Scalars['Ulid']['output'];
};

export type ContractViewModel = {
  __typename?: 'ContractViewModel';
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  amount?: Maybe<Scalars['PositiveDecimal']['output']>;
  beginDate: Scalars['DateTime']['output'];
  cards: Array<ContractCardViewModel>;
  contractId: Scalars['Ulid']['output'];
  contractNumber: Scalars['String']['output'];
  customer: CustomerViewModel;
  customerId: Scalars['Ulid']['output'];
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  effectiveVehicles: Array<VehicleViewModel>;
  endDate: Scalars['DateTime']['output'];
  facility: FacilityViewModel;
  facilityId: Scalars['Ulid']['output'];
  includeAllCustomerVehicles: Scalars['Boolean']['output'];
  isActive: Scalars['Boolean']['output'];
  isAutoRenewed: Scalars['Boolean']['output'];
  parkingSessions: Array<ParkingSessionViewModel>;
  preferredLanguage?: Maybe<Scalars['String10']['output']>;
  reservedParkingSlots?: Maybe<Scalars['PositiveOrZeroInt']['output']>;
  simultaneousVehicleLimit?: Maybe<Scalars['PositiveOrZeroInt']['output']>;
  vehicles: Array<ContractVehicleViewModel>;
  vipVehicles: Array<Scalars['Ulid']['output']>;
};

export type ContractViewModelFilterInput = {
  activatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  amount?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<ContractViewModelFilterInput>>;
  beginDate?: InputMaybe<DateTimeOperationFilterInput>;
  contractId?: InputMaybe<UlidExtendedFilterInput>;
  contractNumber?: InputMaybe<StringOperationFilterInput>;
  customerId?: InputMaybe<UlidExtendedFilterInput>;
  deactivatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  facilityId?: InputMaybe<UlidExtendedFilterInput>;
  includeAllCustomerVehicles?: InputMaybe<BooleanOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  isAutoRenewed?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<ContractViewModelFilterInput>>;
  preferredLanguage?: InputMaybe<StringOperationFilterInput>;
  reservedParkingSlots?: InputMaybe<IntOperationFilterInput>;
  simultaneousVehicleLimit?: InputMaybe<IntOperationFilterInput>;
};

export type ContractViewModelSortInput = {
  activatedAt?: InputMaybe<SortEnumType>;
  amount?: InputMaybe<SortEnumType>;
  beginDate?: InputMaybe<SortEnumType>;
  contractId?: InputMaybe<SortEnumType>;
  contractNumber?: InputMaybe<SortEnumType>;
  customer?: InputMaybe<CustomerViewModelSortInput>;
  customerId?: InputMaybe<SortEnumType>;
  deactivatedAt?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  facility?: InputMaybe<FacilityViewModelSortInput>;
  facilityId?: InputMaybe<SortEnumType>;
  includeAllCustomerVehicles?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  isAutoRenewed?: InputMaybe<SortEnumType>;
  preferredLanguage?: InputMaybe<SortEnumType>;
  reservedParkingSlots?: InputMaybe<SortEnumType>;
  simultaneousVehicleLimit?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ContractsConnection = {
  __typename?: 'ContractsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ContractsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ContractViewModel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ContractsEdge = {
  __typename?: 'ContractsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ContractViewModel;
};

export type CreateCampaignInput = {
  campaignId: Scalars['Ulid']['input'];
  description?: InputMaybe<Scalars['String1000']['input']>;
  endDate: Scalars['DateTime']['input'];
  isActive: Scalars['Boolean']['input'];
  name?: InputMaybe<Scalars['String255']['input']>;
  startDate: Scalars['DateTime']['input'];
};

export type CreateConditionInput = {
  appliesOnHolidays: Scalars['Boolean']['input'];
  appliesToSpecificCustomerCategories: Scalars['Boolean']['input'];
  appliesToSpecificPaymentMethods: Scalars['Boolean']['input'];
  appliesToSpecificVehicleTypes: Scalars['Boolean']['input'];
  arrivingSince?: InputMaybe<Scalars['LocalTime']['input']>;
  arrivingUntil?: InputMaybe<Scalars['LocalTime']['input']>;
  conditionCustomerCategories: Array<Scalars['Ulid']['input']>;
  conditionDayOfWeeks: Array<Scalars['PositiveInt']['input']>;
  conditionPaymentMethods: Array<Scalars['PositiveInt']['input']>;
  conditionVehicleTypes: Array<Scalars['PositiveInt']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  isContractOverstay: Scalars['Boolean']['input'];
  isOverstay: Scalars['Boolean']['input'];
  leavingSince?: InputMaybe<Scalars['LocalTime']['input']>;
  leavingUntil?: InputMaybe<Scalars['LocalTime']['input']>;
  maxStayMinutes?: InputMaybe<Scalars['PositiveOrZeroInt']['input']>;
  minStayMinutes?: InputMaybe<Scalars['PositiveOrZeroInt']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  weeklyDateSetId: Scalars['PositiveInt']['input'];
};

export type CreateContractInput = {
  amount: Scalars['PositiveDecimal']['input'];
  beginDate: Scalars['DateTime']['input'];
  cards: Array<ContractCardInput>;
  contractId: Scalars['Ulid']['input'];
  contractNumber: Scalars['String50']['input'];
  customerId: Scalars['Ulid']['input'];
  endDate: Scalars['DateTime']['input'];
  includeAllCustomerVehicles: Scalars['Boolean']['input'];
  isActive: Scalars['Boolean']['input'];
  isAutoRenewed: Scalars['Boolean']['input'];
  preferredLanguage?: InputMaybe<Scalars['String10']['input']>;
  reservedParkingSlots: Scalars['PositiveOrZeroInt']['input'];
  simultaneousVehicleLimit?: InputMaybe<Scalars['PositiveOrZeroInt']['input']>;
  vehicleIds: Array<Scalars['Ulid']['input']>;
  vipVehicleIds: Array<Scalars['Ulid']['input']>;
};

export type CreateCustomerAddressInput = {
  addressId: Scalars['Ulid']['input'];
  addressTypeId: Scalars['Int']['input'];
  city?: InputMaybe<Scalars['String255']['input']>;
  country?: InputMaybe<Scalars['String255']['input']>;
  customerAddressId: Scalars['Ulid']['input'];
  postalCode?: InputMaybe<Scalars['String50']['input']>;
  state?: InputMaybe<Scalars['String255']['input']>;
  streetAddress?: InputMaybe<Scalars['String500']['input']>;
};

export type CreateCustomerBankDetailsInput = {
  accountHolderName?: InputMaybe<Scalars['String255']['input']>;
  accountNumber?: InputMaybe<Scalars['String50']['input']>;
  accountType?: InputMaybe<Scalars['String100']['input']>;
  bankCode?: InputMaybe<Scalars['String50']['input']>;
  bankDetailsId: Scalars['Ulid']['input'];
  bankName?: InputMaybe<Scalars['String255']['input']>;
  branchCode?: InputMaybe<Scalars['String50']['input']>;
  branchName?: InputMaybe<Scalars['String255']['input']>;
  currency?: InputMaybe<Scalars['String10']['input']>;
  iban?: InputMaybe<Scalars['String50']['input']>;
  isPrimary: Scalars['Boolean']['input'];
  notes?: InputMaybe<Scalars['String1000']['input']>;
  purpose?: InputMaybe<Scalars['String255']['input']>;
};

export type CreateCustomerBeneficiaryInput = {
  beneficiaryCustomerId: Scalars['Ulid']['input'];
  customerBeneficiaryId: Scalars['Ulid']['input'];
  isActive: Scalars['Boolean']['input'];
  notes?: InputMaybe<Scalars['String1000']['input']>;
  relationshipType?: InputMaybe<Scalars['String255']['input']>;
};

export type CreateCustomerContactInput = {
  contactTypeId: Scalars['Int']['input'];
  contactValue?: InputMaybe<Scalars['String255']['input']>;
  customerContactId: Scalars['Ulid']['input'];
  isPrimary: Scalars['Boolean']['input'];
  notes?: InputMaybe<Scalars['String1000']['input']>;
};

export type CreateCustomerInput = {
  addresses: Array<CreateCustomerAddressInput>;
  bankDetails: Array<CreateCustomerBankDetailsInput>;
  beneficiaries: Array<CreateCustomerBeneficiaryInput>;
  billingCountryCode?: InputMaybe<Scalars['String10']['input']>;
  billingLegalName?: InputMaybe<Scalars['String255']['input']>;
  billingTradeName?: InputMaybe<Scalars['String255']['input']>;
  companyRegistrationNumber?: InputMaybe<Scalars['String100']['input']>;
  companySize?: InputMaybe<Scalars['String50']['input']>;
  contacts: Array<CreateCustomerContactInput>;
  customerCategoryId: Scalars['Ulid']['input'];
  customerId: Scalars['Ulid']['input'];
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String255']['input']>;
  firmName?: InputMaybe<Scalars['String255']['input']>;
  firstName?: InputMaybe<Scalars['String100']['input']>;
  fiscalNumber?: InputMaybe<Scalars['String50']['input']>;
  gender?: InputMaybe<Scalars['String50']['input']>;
  idNumber?: InputMaybe<Scalars['String100']['input']>;
  idType?: InputMaybe<Scalars['String50']['input']>;
  industry?: InputMaybe<Scalars['String100']['input']>;
  isActive: Scalars['Boolean']['input'];
  isCompany: Scalars['Boolean']['input'];
  lastName?: InputMaybe<Scalars['String100']['input']>;
  marketingOptIn: Scalars['Boolean']['input'];
  nationality?: InputMaybe<Scalars['String100']['input']>;
  notes?: InputMaybe<Scalars['String1000']['input']>;
  preferredLanguage?: InputMaybe<Scalars['String10']['input']>;
  taxOffice?: InputMaybe<Scalars['String255']['input']>;
  vehicles: Array<CreateCustomerVehicleInput>;
};

export type CreateCustomerVehicleInput = {
  color?: InputMaybe<Scalars['String100']['input']>;
  isActive: Scalars['Boolean']['input'];
  make?: InputMaybe<Scalars['String255']['input']>;
  model?: InputMaybe<Scalars['String255']['input']>;
  plateNumber?: InputMaybe<Scalars['String50']['input']>;
  vehicleId: Scalars['Ulid']['input'];
  vehicleTypeId?: InputMaybe<Scalars['PositiveInt']['input']>;
};

export type CreateGuaranteeTransactionInput = {
  appliedVatRateId?: InputMaybe<Scalars['Ulid']['input']>;
  contractCardId: Scalars['Ulid']['input'];
  documentSeriesId?: InputMaybe<Scalars['Ulid']['input']>;
  grossAmount: Scalars['PositiveOrZeroDecimal']['input'];
  guaranteeTransactionId: Scalars['Ulid']['input'];
  guaranteeTransactionTypeId: GuaranteeTransactionTypeEnum;
  idempotencyKey: Scalars['String255']['input'];
  netAmount: Scalars['PositiveOrZeroDecimal']['input'];
  notes?: InputMaybe<Scalars['String1000']['input']>;
  replacedCardId?: InputMaybe<Scalars['Ulid']['input']>;
  vatAmount: Scalars['PositiveOrZeroDecimal']['input'];
  vatPercentage: Scalars['PositiveOrZeroDecimal']['input'];
};

export type CreateLimitPolicyInput = {
  billingCycleId: Scalars['PositiveInt']['input'];
  isActive: Scalars['Boolean']['input'];
  limit: CreateLimitPolicyLimitInput;
  limitPolicyId: Scalars['Ulid']['input'];
  name: Scalars['String255']['input'];
  priority: Scalars['PositiveInt']['input'];
  scenarioId?: InputMaybe<Scalars['Ulid']['input']>;
  tariffId: Scalars['Ulid']['input'];
};

export type CreateLimitPolicyLimitInput = {
  limitId: Scalars['Ulid']['input'];
  maxAmount?: InputMaybe<Scalars['PositiveOrZeroDecimal']['input']>;
  maxStayMinutes?: InputMaybe<Scalars['PositiveOrZeroInt']['input']>;
  minAmount?: InputMaybe<Scalars['PositiveOrZeroDecimal']['input']>;
  minStayMinutes?: InputMaybe<Scalars['PositiveOrZeroInt']['input']>;
};

export enum CreateParkingSessionError {
  ContractExpired = 'CONTRACT_EXPIRED',
  ContractNotFound = 'CONTRACT_NOT_FOUND',
  ContractSuspended = 'CONTRACT_SUSPENDED',
  ContractVehicleLimitExceeded = 'CONTRACT_VEHICLE_LIMIT_EXCEEDED',
  DatabaseError = 'DATABASE_ERROR',
  FacilityAtCapacity = 'FACILITY_AT_CAPACITY',
  FacilityNotFound = 'FACILITY_NOT_FOUND',
  InvalidActorConfiguration = 'INVALID_ACTOR_CONFIGURATION',
  NoActiveCashierShift = 'NO_ACTIVE_CASHIER_SHIFT',
  SessionAlreadyExists = 'SESSION_ALREADY_EXISTS',
  TerminalNotFound = 'TERMINAL_NOT_FOUND',
  TicketAlreadyUsed = 'TICKET_ALREADY_USED',
  VehicleHasActiveSession = 'VEHICLE_HAS_ACTIVE_SESSION',
  VehicleNotAssociatedWithContract = 'VEHICLE_NOT_ASSOCIATED_WITH_CONTRACT'
}

export type CreateParkingSessionInput = {
  contractId?: InputMaybe<Scalars['Ulid']['input']>;
  parkingSessionId?: InputMaybe<Scalars['String50']['input']>;
  plateNumber?: InputMaybe<Scalars['String50']['input']>;
  ticketId?: InputMaybe<Scalars['String50']['input']>;
};

export type CreatePricingPolicyInput = {
  billingCycleId: Scalars['PositiveInt']['input'];
  isActive: Scalars['Boolean']['input'];
  limit?: InputMaybe<CreatePricingPolicyLimitInput>;
  name?: InputMaybe<Scalars['String255']['input']>;
  overstayRate?: InputMaybe<CreatePricingPolicyRateInput>;
  pricingPolicyId: Scalars['Ulid']['input'];
  priority: Scalars['PositiveInt']['input'];
  rate: CreatePricingPolicyRateInput;
  scenarioId?: InputMaybe<Scalars['Ulid']['input']>;
  tariffId: Scalars['Ulid']['input'];
};

export type CreatePricingPolicyLimitInput = {
  limitId: Scalars['Ulid']['input'];
  maxAmount?: InputMaybe<Scalars['PositiveOrZeroDecimal']['input']>;
  maxStayMinutes?: InputMaybe<Scalars['PositiveOrZeroInt']['input']>;
  minAmount?: InputMaybe<Scalars['PositiveOrZeroDecimal']['input']>;
  minStayMinutes?: InputMaybe<Scalars['PositiveOrZeroInt']['input']>;
};

export type CreatePricingPolicyRateInput = {
  flatRateAmount?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  rateId: Scalars['Ulid']['input'];
  rateSteps: Array<CreatePricingPolicyRateStepInput>;
  rateTypeEnum: RateTypeEnum;
};

export type CreatePricingPolicyRateStepInput = {
  intervalCharge: Scalars['PositiveOrZeroDecimal']['input'];
  intervalMinutes: Scalars['PositiveInt']['input'];
  maxIntervals?: InputMaybe<Scalars['PositiveInt']['input']>;
  rateStepId: Scalars['Ulid']['input'];
  stepSequence: Scalars['PositiveInt']['input'];
};

export type CreateScenarioConditionInput = {
  condition: CreateConditionInput;
  conditionId: Scalars['Ulid']['input'];
  operator: ConditionOperator;
};

export type CreateScenarioInput = {
  name: Scalars['String255']['input'];
  scenarioConditions: Array<CreateScenarioConditionInput>;
  scenarioId: Scalars['Ulid']['input'];
};

export type CreateTariffInput = {
  description?: InputMaybe<Scalars['String1000']['input']>;
  entryGracePeriodMinutes: Scalars['PositiveOrZeroInt']['input'];
  freeExitMinutes: Scalars['PositiveOrZeroInt']['input'];
  lostTicketFixedCharge?: InputMaybe<Scalars['PositiveOrZeroDecimal']['input']>;
  lostTicketRateId?: InputMaybe<Scalars['Ulid']['input']>;
  name: Scalars['String255']['input'];
  postPaymentGraceMinutes: Scalars['PositiveOrZeroInt']['input'];
  reEntryChargeRateId?: InputMaybe<Scalars['Ulid']['input']>;
  sourceTariffId?: InputMaybe<Scalars['Ulid']['input']>;
  tariffId: Scalars['Ulid']['input'];
  version?: InputMaybe<Scalars['String50']['input']>;
};

export type CreateTerminalInput = {
  gateKey?: InputMaybe<Scalars['String255']['input']>;
  ipAddress: Scalars['String45']['input'];
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String255']['input'];
  terminalId: Scalars['Ulid']['input'];
  terminalTypeId: Scalars['PositiveInt']['input'];
};

export type CreateVehicleInput = {
  color?: InputMaybe<Scalars['String100']['input']>;
  customerId?: InputMaybe<Scalars['Ulid']['input']>;
  isActive: Scalars['Boolean']['input'];
  make?: InputMaybe<Scalars['String255']['input']>;
  model?: InputMaybe<Scalars['String255']['input']>;
  plateNumber?: InputMaybe<Scalars['String50']['input']>;
  vehicleId: Scalars['Ulid']['input'];
  vehicleTypeId?: InputMaybe<Scalars['PositiveInt']['input']>;
};

export type CreateVoucherInput = {
  campaignId?: InputMaybe<Scalars['Ulid']['input']>;
  code: Scalars['String255']['input'];
  customerId?: InputMaybe<Scalars['Ulid']['input']>;
  discountValue?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  freeTimeMinutes?: InputMaybe<Scalars['PositiveInt']['input']>;
  isActive: Scalars['Boolean']['input'];
  isAdHoc: Scalars['Boolean']['input'];
  isCustomerSpecific: Scalars['Boolean']['input'];
  maxDiscountAmount?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  name?: InputMaybe<Scalars['String255']['input']>;
  rateBindingRequired: Scalars['Boolean']['input'];
  rateId?: InputMaybe<Scalars['Ulid']['input']>;
  usageLimit?: InputMaybe<Scalars['PositiveInt']['input']>;
  validUntilDate: Scalars['DateTime']['input'];
  voucherDiscountTypeEnum: VoucherDiscountTypeEnum;
  voucherId: Scalars['Ulid']['input'];
};

/** A connection to a list of items. */
export type CriticalAlertsConnection = {
  __typename?: 'CriticalAlertsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CriticalAlertsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AlertViewModel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CriticalAlertsEdge = {
  __typename?: 'CriticalAlertsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AlertViewModel;
};

export type CurrentUserPayload = {
  __typename?: 'CurrentUserPayload';
  isAuthenticated: Scalars['Boolean']['output'];
  tokenExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<UserInfo>;
};

export type CustomerAddressViewModel = {
  __typename?: 'CustomerAddressViewModel';
  address: AddressViewModel;
  addressId: Scalars['Ulid']['output'];
  addressType: AddressTypeViewModel;
  addressTypeId?: Maybe<Scalars['PositiveInt']['output']>;
  customer: CustomerViewModel;
  customerAddressId: Scalars['Ulid']['output'];
  customerId: Scalars['Ulid']['output'];
};

/** A connection to a list of items. */
export type CustomerBankDetailsConnection = {
  __typename?: 'CustomerBankDetailsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CustomerBankDetailsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<BankDetailsViewModel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomerBankDetailsEdge = {
  __typename?: 'CustomerBankDetailsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: BankDetailsViewModel;
};

/** A connection to a list of items. */
export type CustomerBeneficiariesConnection = {
  __typename?: 'CustomerBeneficiariesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CustomerBeneficiariesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CustomerBeneficiaryViewModel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomerBeneficiariesEdge = {
  __typename?: 'CustomerBeneficiariesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CustomerBeneficiaryViewModel;
};

export type CustomerBeneficiaryViewModel = {
  __typename?: 'CustomerBeneficiaryViewModel';
  benefactor: BeneficiaryDetailsViewModels;
  benefactorId: Scalars['Ulid']['output'];
  beneficiary: BeneficiaryDetailsViewModels;
  beneficiaryId: Scalars['Ulid']['output'];
  createdAt: Scalars['DateTime']['output'];
  customerBeneficiaryId: Scalars['Ulid']['output'];
  isActive: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String1000']['output']>;
  relationshipType?: Maybe<Scalars['String255']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CustomerBeneficiaryViewModelFilterInput = {
  and?: InputMaybe<Array<CustomerBeneficiaryViewModelFilterInput>>;
  benefactorId?: InputMaybe<UlidExtendedFilterInput>;
  beneficiaryId?: InputMaybe<UlidExtendedFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  customerBeneficiaryId?: InputMaybe<UlidExtendedFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CustomerBeneficiaryViewModelFilterInput>>;
  relationshipType?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type CustomerBeneficiaryViewModelSortInput = {
  benefactor?: InputMaybe<BeneficiaryDetailsViewModelsSortInput>;
  benefactorId?: InputMaybe<SortEnumType>;
  beneficiary?: InputMaybe<BeneficiaryDetailsViewModelsSortInput>;
  beneficiaryId?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  customerBeneficiaryId?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  relationshipType?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

export type CustomerCategoryViewModel = {
  __typename?: 'CustomerCategoryViewModel';
  code?: Maybe<Scalars['PositiveInt']['output']>;
  conditionCustomerCategories: Array<ConditionCustomerCategoryViewModel>;
  customerCategoryId: Scalars['Ulid']['output'];
  customers: Array<CustomerViewModel>;
  description?: Maybe<Scalars['String255']['output']>;
  simultaneousVehicleLimit?: Maybe<Scalars['PositiveOrZeroInt']['output']>;
};

export type CustomerCategoryViewModelFilterInput = {
  and?: InputMaybe<Array<CustomerCategoryViewModelFilterInput>>;
  code?: InputMaybe<IntOperationFilterInput>;
  customerCategoryId?: InputMaybe<UlidExtendedFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CustomerCategoryViewModelFilterInput>>;
  simultaneousVehicleLimit?: InputMaybe<IntOperationFilterInput>;
};

export type CustomerCategoryViewModelSortInput = {
  code?: InputMaybe<SortEnumType>;
  customerCategoryId?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  simultaneousVehicleLimit?: InputMaybe<SortEnumType>;
};

export type CustomerContactViewModel = {
  __typename?: 'CustomerContactViewModel';
  contactType: ContactTypeViewModel;
  contactTypeId: Scalars['Int']['output'];
  contactValue?: Maybe<Scalars['String255']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customer: CustomerViewModel;
  customerContactId: Scalars['Ulid']['output'];
  customerId: Scalars['Ulid']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isPrimary: Scalars['Boolean']['output'];
  isVerified: Scalars['Boolean']['output'];
  label?: Maybe<Scalars['String255']['output']>;
  notes?: Maybe<Scalars['String1000']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CustomerContactViewModelFilterInput = {
  and?: InputMaybe<Array<CustomerContactViewModelFilterInput>>;
  contactTypeId?: InputMaybe<IntOperationFilterInput>;
  contactValue?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  customerContactId?: InputMaybe<UlidExtendedFilterInput>;
  customerId?: InputMaybe<UlidExtendedFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  isPrimary?: InputMaybe<BooleanOperationFilterInput>;
  isVerified?: InputMaybe<BooleanOperationFilterInput>;
  label?: InputMaybe<StringOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CustomerContactViewModelFilterInput>>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  verifiedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type CustomerContactViewModelSortInput = {
  contactType?: InputMaybe<ContactTypeViewModelSortInput>;
  contactTypeId?: InputMaybe<SortEnumType>;
  contactValue?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  customer?: InputMaybe<CustomerViewModelSortInput>;
  customerContactId?: InputMaybe<SortEnumType>;
  customerId?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  isPrimary?: InputMaybe<SortEnumType>;
  isVerified?: InputMaybe<SortEnumType>;
  label?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  verifiedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type CustomerContactsConnection = {
  __typename?: 'CustomerContactsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CustomerContactsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CustomerContactViewModel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomerContactsEdge = {
  __typename?: 'CustomerContactsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CustomerContactViewModel;
};

export type CustomerViewModel = {
  __typename?: 'CustomerViewModel';
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  bankDetails: Array<BankDetailsViewModel>;
  billingCountryCode?: Maybe<Scalars['String10']['output']>;
  billingLegalName?: Maybe<Scalars['String255']['output']>;
  billingTradeName?: Maybe<Scalars['String255']['output']>;
  companyRegistrationNumber?: Maybe<Scalars['String100']['output']>;
  companySize?: Maybe<Scalars['String50']['output']>;
  contracts: Array<ContractViewModel>;
  createdAt: Scalars['DateTime']['output'];
  customerAddresses: Array<CustomerAddressViewModel>;
  customerBeneficiaries: Array<CustomerBeneficiaryViewModel>;
  customerCategory: CustomerCategoryViewModel;
  customerCategoryId: Scalars['Ulid']['output'];
  customerContacts: Array<CustomerContactViewModel>;
  customerId: Scalars['Ulid']['output'];
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  displayName?: Maybe<Scalars['String255']['output']>;
  email?: Maybe<Scalars['String255']['output']>;
  firmName?: Maybe<Scalars['String255']['output']>;
  firstName?: Maybe<Scalars['String100']['output']>;
  fiscalNumber?: Maybe<Scalars['String50']['output']>;
  gender?: Maybe<Scalars['String50']['output']>;
  idNumber?: Maybe<Scalars['String100']['output']>;
  idType?: Maybe<Scalars['String50']['output']>;
  industry?: Maybe<Scalars['String100']['output']>;
  isActive: Scalars['Boolean']['output'];
  isCompany: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String100']['output']>;
  marketingOptIn: Scalars['Boolean']['output'];
  nationality?: Maybe<Scalars['String100']['output']>;
  notes?: Maybe<Scalars['String1000']['output']>;
  preferredLanguage?: Maybe<Scalars['String10']['output']>;
  prepaidCards: Array<PrepaidCardViewModel>;
  reservations: Array<ReservationViewModel>;
  taxOffice?: Maybe<Scalars['String255']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  vehicles: Array<VehicleViewModel>;
  vouchers: Array<VoucherViewModel>;
};

export type CustomerViewModelFilterInput = {
  activatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  and?: InputMaybe<Array<CustomerViewModelFilterInput>>;
  billingCountryCode?: InputMaybe<StringOperationFilterInput>;
  billingLegalName?: InputMaybe<StringOperationFilterInput>;
  billingTradeName?: InputMaybe<StringOperationFilterInput>;
  companyRegistrationNumber?: InputMaybe<StringOperationFilterInput>;
  companySize?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  customerCategoryId?: InputMaybe<UlidExtendedFilterInput>;
  customerId?: InputMaybe<UlidExtendedFilterInput>;
  dateOfBirth?: InputMaybe<DateTimeOperationFilterInput>;
  deactivatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  displayName?: InputMaybe<StringOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  firmName?: InputMaybe<StringOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  fiscalNumber?: InputMaybe<StringOperationFilterInput>;
  gender?: InputMaybe<StringOperationFilterInput>;
  idNumber?: InputMaybe<StringOperationFilterInput>;
  idType?: InputMaybe<StringOperationFilterInput>;
  industry?: InputMaybe<StringOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  isCompany?: InputMaybe<BooleanOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  marketingOptIn?: InputMaybe<BooleanOperationFilterInput>;
  nationality?: InputMaybe<StringOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CustomerViewModelFilterInput>>;
  preferredLanguage?: InputMaybe<StringOperationFilterInput>;
  taxOffice?: InputMaybe<StringOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type CustomerViewModelSortInput = {
  activatedAt?: InputMaybe<SortEnumType>;
  billingCountryCode?: InputMaybe<SortEnumType>;
  billingLegalName?: InputMaybe<SortEnumType>;
  billingTradeName?: InputMaybe<SortEnumType>;
  companyRegistrationNumber?: InputMaybe<SortEnumType>;
  companySize?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  customerCategory?: InputMaybe<CustomerCategoryViewModelSortInput>;
  customerCategoryId?: InputMaybe<SortEnumType>;
  customerId?: InputMaybe<SortEnumType>;
  dateOfBirth?: InputMaybe<SortEnumType>;
  deactivatedAt?: InputMaybe<SortEnumType>;
  displayName?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  firmName?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  fiscalNumber?: InputMaybe<SortEnumType>;
  gender?: InputMaybe<SortEnumType>;
  idNumber?: InputMaybe<SortEnumType>;
  idType?: InputMaybe<SortEnumType>;
  industry?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  isCompany?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  marketingOptIn?: InputMaybe<SortEnumType>;
  nationality?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  preferredLanguage?: InputMaybe<SortEnumType>;
  taxOffice?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type CustomersConnection = {
  __typename?: 'CustomersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CustomersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CustomerViewModel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomersEdge = {
  __typename?: 'CustomersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CustomerViewModel;
};

export type DateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  ngt?: InputMaybe<Scalars['DateTime']['input']>;
  ngte?: InputMaybe<Scalars['DateTime']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  nlt?: InputMaybe<Scalars['DateTime']['input']>;
  nlte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DayOfWeekViewModel = {
  __typename?: 'DayOfWeekViewModel';
  conditionDayOfWeeks: Array<ConditionDayOfWeekViewModel>;
  dayOfWeekId?: Maybe<Scalars['PositiveInt']['output']>;
  name?: Maybe<Scalars['String20']['output']>;
};

export type DayOfWeekViewModelFilterInput = {
  and?: InputMaybe<Array<DayOfWeekViewModelFilterInput>>;
  dayOfWeekId?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DayOfWeekViewModelFilterInput>>;
};

export type DayOfWeekViewModelSortInput = {
  dayOfWeekId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type DecimalOperationFilterInput = {
  eq?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  neq?: InputMaybe<Scalars['Decimal']['input']>;
  ngt?: InputMaybe<Scalars['Decimal']['input']>;
  ngte?: InputMaybe<Scalars['Decimal']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  nlt?: InputMaybe<Scalars['Decimal']['input']>;
  nlte?: InputMaybe<Scalars['Decimal']['input']>;
};

export type DeleteCampaignInput = {
  campaignId: Scalars['Ulid']['input'];
};

export type DeleteContractInput = {
  contractId: Scalars['Ulid']['input'];
};

export type DeleteCustomerInput = {
  customerId: Scalars['Ulid']['input'];
};

export type DeleteLimitPolicyInput = {
  limitPolicyId: Scalars['Ulid']['input'];
};

export type DeletePricingPolicyInput = {
  pricingPolicyId: Scalars['Ulid']['input'];
};

export type DeleteScenarioInput = {
  scenarioId: Scalars['Ulid']['input'];
};

export type DeleteTerminalInput = {
  terminalId: Scalars['Ulid']['input'];
};

export type DeleteVehicleInput = {
  vehicleId: Scalars['Ulid']['input'];
};

export type DeleteVoucherInput = {
  voucherId: Scalars['Ulid']['input'];
};

export type ErrorResultOfChangeParkingSessionError = {
  __typename?: 'ErrorResultOfChangeParkingSessionError';
  errorCode?: Maybe<ChangeParkingSessionError>;
  errorDescription?: Maybe<Scalars['String']['output']>;
};

export type ErrorResultOfCreateParkingSessionError = {
  __typename?: 'ErrorResultOfCreateParkingSessionError';
  errorCode?: Maybe<CreateParkingSessionError>;
  errorDescription?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type FacilitiesConnection = {
  __typename?: 'FacilitiesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<FacilitiesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<FacilityViewModel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type FacilitiesEdge = {
  __typename?: 'FacilitiesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FacilityViewModel;
};

export type FacilityViewModel = {
  __typename?: 'FacilityViewModel';
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  actualCapacity?: Maybe<Scalars['PositiveInt']['output']>;
  address: AddressViewModel;
  addressId: Scalars['Ulid']['output'];
  auditLogs: Array<LogViewModel>;
  campaigns: Array<CampaignViewModel>;
  cashierShifts: Array<CashierShiftViewModel>;
  chargeLedgerEntries: Array<ChargeLedgerEntryViewModel>;
  contracts: Array<ContractViewModel>;
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  effectiveCapacity?: Maybe<Scalars['PositiveInt']['output']>;
  facilityId: Scalars['Ulid']['output'];
  floors: Array<FloorViewModel>;
  isActive: Scalars['Boolean']['output'];
  limits: Array<LimitViewModel>;
  mainTariff?: Maybe<TariffViewModel>;
  mainTariffId?: Maybe<Scalars['Ulid']['output']>;
  name?: Maybe<Scalars['String255']['output']>;
  parkingSessions: Array<ParkingSessionViewModel>;
  plateNumberBlacklists: Array<PlateNumberBlacklistViewModel>;
  pricingPolicies: Array<PricingPolicyViewModel>;
  rates: Array<RateViewModel>;
  reservations: Array<ReservationViewModel>;
  scenarios: Array<ScenarioViewModel>;
  services: Array<ServiceViewModel>;
  terminals: Array<TerminalViewModel>;
};

export type FacilityViewModelFilterInput = {
  activatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  actualCapacity?: InputMaybe<IntOperationFilterInput>;
  addressId?: InputMaybe<UlidExtendedFilterInput>;
  and?: InputMaybe<Array<FacilityViewModelFilterInput>>;
  deactivatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  effectiveCapacity?: InputMaybe<IntOperationFilterInput>;
  facilityId?: InputMaybe<UlidExtendedFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  mainTariffId?: InputMaybe<UlidExtendedFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FacilityViewModelFilterInput>>;
};

export type FacilityViewModelSortInput = {
  activatedAt?: InputMaybe<SortEnumType>;
  actualCapacity?: InputMaybe<SortEnumType>;
  address?: InputMaybe<AddressViewModelSortInput>;
  addressId?: InputMaybe<SortEnumType>;
  deactivatedAt?: InputMaybe<SortEnumType>;
  effectiveCapacity?: InputMaybe<SortEnumType>;
  facilityId?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  mainTariff?: InputMaybe<TariffViewModelSortInput>;
  mainTariffId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type FiscalDocumentViewModel = {
  __typename?: 'FiscalDocumentViewModel';
  bankId?: Maybe<Scalars['Ulid']['output']>;
  bankName?: Maybe<Scalars['String255']['output']>;
  bankSapCode?: Maybe<Scalars['String50']['output']>;
  currency?: Maybe<Scalars['String50']['output']>;
  documentSeriesId: Scalars['Ulid']['output'];
  documentTypeId: Scalars['Int']['output'];
  facilityId: Scalars['Ulid']['output'];
  fiscalDate: Scalars['LocalDate']['output'];
  fiscalDocumentId: Scalars['Ulid']['output'];
  fiscalEntityId: Scalars['Ulid']['output'];
  grossAmount: Scalars['Decimal']['output'];
  issueDateTime: Scalars['DateTime']['output'];
  netAmount: Scalars['Decimal']['output'];
  parkingSessionId?: Maybe<Scalars['Ulid']['output']>;
  providerAuthCode?: Maybe<Scalars['String255']['output']>;
  providerDocumentUid?: Maybe<Scalars['String255']['output']>;
  sequentialNumber: Scalars['Long']['output'];
  seriesPrefix?: Maybe<Scalars['String50']['output']>;
  statusId: Scalars['Int']['output'];
  vatAmount: Scalars['Decimal']['output'];
};

export type FiscalDocumentViewModelFilterInput = {
  and?: InputMaybe<Array<FiscalDocumentViewModelFilterInput>>;
  bankId?: InputMaybe<UlidExtendedFilterInput>;
  bankName?: InputMaybe<StringOperationFilterInput>;
  bankSapCode?: InputMaybe<StringOperationFilterInput>;
  currency?: InputMaybe<StringOperationFilterInput>;
  documentSeriesId?: InputMaybe<UlidExtendedFilterInput>;
  documentTypeId?: InputMaybe<IntOperationFilterInput>;
  facilityId?: InputMaybe<UlidExtendedFilterInput>;
  fiscalDate?: InputMaybe<LocalDateOperationFilterInput>;
  fiscalDocumentId?: InputMaybe<UlidExtendedFilterInput>;
  fiscalEntityId?: InputMaybe<UlidExtendedFilterInput>;
  grossAmount?: InputMaybe<DecimalOperationFilterInput>;
  issueDateTime?: InputMaybe<DateTimeOperationFilterInput>;
  netAmount?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<FiscalDocumentViewModelFilterInput>>;
  parkingSessionId?: InputMaybe<UlidExtendedFilterInput>;
  providerAuthCode?: InputMaybe<StringOperationFilterInput>;
  providerDocumentUid?: InputMaybe<StringOperationFilterInput>;
  sequentialNumber?: InputMaybe<LongOperationFilterInput>;
  seriesPrefix?: InputMaybe<StringOperationFilterInput>;
  statusId?: InputMaybe<IntOperationFilterInput>;
  vatAmount?: InputMaybe<DecimalOperationFilterInput>;
};

export type FiscalDocumentViewModelSortInput = {
  bankId?: InputMaybe<SortEnumType>;
  bankName?: InputMaybe<SortEnumType>;
  bankSapCode?: InputMaybe<SortEnumType>;
  currency?: InputMaybe<SortEnumType>;
  documentSeriesId?: InputMaybe<SortEnumType>;
  documentTypeId?: InputMaybe<SortEnumType>;
  facilityId?: InputMaybe<SortEnumType>;
  fiscalDate?: InputMaybe<SortEnumType>;
  fiscalDocumentId?: InputMaybe<SortEnumType>;
  fiscalEntityId?: InputMaybe<SortEnumType>;
  grossAmount?: InputMaybe<SortEnumType>;
  issueDateTime?: InputMaybe<SortEnumType>;
  netAmount?: InputMaybe<SortEnumType>;
  parkingSessionId?: InputMaybe<SortEnumType>;
  providerAuthCode?: InputMaybe<SortEnumType>;
  providerDocumentUid?: InputMaybe<SortEnumType>;
  sequentialNumber?: InputMaybe<SortEnumType>;
  seriesPrefix?: InputMaybe<SortEnumType>;
  statusId?: InputMaybe<SortEnumType>;
  vatAmount?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type FiscalDocumentsConnection = {
  __typename?: 'FiscalDocumentsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<FiscalDocumentsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<FiscalDocumentViewModel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type FiscalDocumentsEdge = {
  __typename?: 'FiscalDocumentsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FiscalDocumentViewModel;
};

export type FloorViewModel = {
  __typename?: 'FloorViewModel';
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  code: Scalars['Int']['output'];
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String255']['output']>;
  facility: FacilityViewModel;
  facilityId: Scalars['Ulid']['output'];
  floorId: Scalars['Ulid']['output'];
  isOperational: Scalars['Boolean']['output'];
  parkingPositions: Array<ParkingPositionViewModel>;
  positionCount?: Maybe<Scalars['PositiveInt']['output']>;
};

export type FloorViewModelFilterInput = {
  activatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  and?: InputMaybe<Array<FloorViewModelFilterInput>>;
  code?: InputMaybe<IntOperationFilterInput>;
  deactivatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  facilityId?: InputMaybe<UlidExtendedFilterInput>;
  floorId?: InputMaybe<UlidExtendedFilterInput>;
  isOperational?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<FloorViewModelFilterInput>>;
  positionCount?: InputMaybe<IntOperationFilterInput>;
};

export type FloorViewModelSortInput = {
  activatedAt?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  deactivatedAt?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  facility?: InputMaybe<FacilityViewModelSortInput>;
  facilityId?: InputMaybe<SortEnumType>;
  floorId?: InputMaybe<SortEnumType>;
  isOperational?: InputMaybe<SortEnumType>;
  positionCount?: InputMaybe<SortEnumType>;
};

export enum GuaranteeTransactionTypeEnum {
  Deposit = 'DEPOSIT',
  DepositTransfer = 'DEPOSIT_TRANSFER',
  Replacement = 'REPLACEMENT',
  Return = 'RETURN',
  Void = 'VOID'
}

export type GuaranteeTransactionTypeViewModel = {
  __typename?: 'GuaranteeTransactionTypeViewModel';
  guaranteeTransactionTypeId: Scalars['Byte']['output'];
  involvesCashMovement: Scalars['Boolean']['output'];
  isFiscal: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String255']['output']>;
};

export type GuaranteeTransactionTypeViewModelSortInput = {
  guaranteeTransactionTypeId?: InputMaybe<SortEnumType>;
  involvesCashMovement?: InputMaybe<SortEnumType>;
  isFiscal?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type GuaranteeTransactionViewModel = {
  __typename?: 'GuaranteeTransactionViewModel';
  appliedVatRateId?: Maybe<Scalars['Ulid']['output']>;
  cashierShift: CashierShiftViewModel;
  cashierShiftId: Scalars['Ulid']['output'];
  contractCard: ContractCardViewModel;
  contractCardId: Scalars['Ulid']['output'];
  createdAt: Scalars['DateTime']['output'];
  documentSeriesId?: Maybe<Scalars['Ulid']['output']>;
  facility: FacilityViewModel;
  facilityId: Scalars['Ulid']['output'];
  grossAmount?: Maybe<Scalars['PositiveOrZeroDecimal']['output']>;
  guaranteeTransactionId: Scalars['Ulid']['output'];
  guaranteeTransactionType: GuaranteeTransactionTypeViewModel;
  guaranteeTransactionTypeId: Scalars['Byte']['output'];
  idempotencyKey?: Maybe<Scalars['String255']['output']>;
  netAmount?: Maybe<Scalars['PositiveOrZeroDecimal']['output']>;
  notes?: Maybe<Scalars['String1000']['output']>;
  processedByUser: UserViewModel;
  processedByUserId: Scalars['Ulid']['output'];
  replacedCardId?: Maybe<Scalars['Ulid']['output']>;
  reversedByTransaction?: Maybe<GuaranteeTransactionViewModel>;
  reversesTransaction?: Maybe<GuaranteeTransactionViewModel>;
  reversesTransactionId?: Maybe<Scalars['Ulid']['output']>;
  sequentialNumber?: Maybe<Scalars['Long']['output']>;
  vatAmount?: Maybe<Scalars['PositiveOrZeroDecimal']['output']>;
  vatPercentage?: Maybe<Scalars['PositiveOrZeroDecimal']['output']>;
};

export type GuaranteeTransactionViewModelFilterInput = {
  and?: InputMaybe<Array<GuaranteeTransactionViewModelFilterInput>>;
  appliedVatRateId?: InputMaybe<UlidExtendedFilterInput>;
  cashierShiftId?: InputMaybe<UlidExtendedFilterInput>;
  contractCardId?: InputMaybe<UlidExtendedFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  documentSeriesId?: InputMaybe<UlidExtendedFilterInput>;
  facilityId?: InputMaybe<UlidExtendedFilterInput>;
  grossAmount?: InputMaybe<DecimalOperationFilterInput>;
  guaranteeTransactionId?: InputMaybe<UlidExtendedFilterInput>;
  guaranteeTransactionTypeId?: InputMaybe<ByteOperationFilterInput>;
  idempotencyKey?: InputMaybe<StringOperationFilterInput>;
  netAmount?: InputMaybe<DecimalOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<GuaranteeTransactionViewModelFilterInput>>;
  processedByUserId?: InputMaybe<UlidExtendedFilterInput>;
  replacedCardId?: InputMaybe<UlidExtendedFilterInput>;
  reversesTransactionId?: InputMaybe<UlidExtendedFilterInput>;
  sequentialNumber?: InputMaybe<LongOperationFilterInput>;
  vatAmount?: InputMaybe<DecimalOperationFilterInput>;
  vatPercentage?: InputMaybe<DecimalOperationFilterInput>;
};

export type GuaranteeTransactionViewModelSortInput = {
  appliedVatRateId?: InputMaybe<SortEnumType>;
  cashierShift?: InputMaybe<CashierShiftViewModelSortInput>;
  cashierShiftId?: InputMaybe<SortEnumType>;
  contractCard?: InputMaybe<ContractCardViewModelSortInput>;
  contractCardId?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  documentSeriesId?: InputMaybe<SortEnumType>;
  facility?: InputMaybe<FacilityViewModelSortInput>;
  facilityId?: InputMaybe<SortEnumType>;
  grossAmount?: InputMaybe<SortEnumType>;
  guaranteeTransactionId?: InputMaybe<SortEnumType>;
  guaranteeTransactionType?: InputMaybe<GuaranteeTransactionTypeViewModelSortInput>;
  guaranteeTransactionTypeId?: InputMaybe<SortEnumType>;
  idempotencyKey?: InputMaybe<SortEnumType>;
  netAmount?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  processedByUser?: InputMaybe<UserViewModelSortInput>;
  processedByUserId?: InputMaybe<SortEnumType>;
  replacedCardId?: InputMaybe<SortEnumType>;
  reversedByTransaction?: InputMaybe<GuaranteeTransactionViewModelSortInput>;
  reversesTransaction?: InputMaybe<GuaranteeTransactionViewModelSortInput>;
  reversesTransactionId?: InputMaybe<SortEnumType>;
  sequentialNumber?: InputMaybe<SortEnumType>;
  vatAmount?: InputMaybe<SortEnumType>;
  vatPercentage?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type GuaranteeTransactionsByContractCardConnection = {
  __typename?: 'GuaranteeTransactionsByContractCardConnection';
  /** A list of edges. */
  edges?: Maybe<Array<GuaranteeTransactionsByContractCardEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<GuaranteeTransactionViewModel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type GuaranteeTransactionsByContractCardEdge = {
  __typename?: 'GuaranteeTransactionsByContractCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: GuaranteeTransactionViewModel;
};

/** A connection to a list of items. */
export type GuaranteeTransactionsConnection = {
  __typename?: 'GuaranteeTransactionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<GuaranteeTransactionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<GuaranteeTransactionViewModel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type GuaranteeTransactionsEdge = {
  __typename?: 'GuaranteeTransactionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: GuaranteeTransactionViewModel;
};

export type IntOperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
  ngt?: InputMaybe<Scalars['Int']['input']>;
  ngte?: InputMaybe<Scalars['Int']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  nlt?: InputMaybe<Scalars['Int']['input']>;
  nlte?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of items. */
export type LimitPoliciesConnection = {
  __typename?: 'LimitPoliciesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<LimitPoliciesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<LimitPolicyViewModel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LimitPoliciesEdge = {
  __typename?: 'LimitPoliciesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: LimitPolicyViewModel;
};

export type LimitPolicyViewModel = {
  __typename?: 'LimitPolicyViewModel';
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  billingCycle: BillingCycleViewModel;
  billingCycleId: Scalars['PositiveInt']['output'];
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  facility: FacilityViewModel;
  facilityId: Scalars['Ulid']['output'];
  isActive: Scalars['Boolean']['output'];
  limit: LimitViewModel;
  limitId: Scalars['Ulid']['output'];
  limitPolicyId: Scalars['Ulid']['output'];
  name: Scalars['String255']['output'];
  priority: Scalars['PositiveInt']['output'];
  scenario?: Maybe<ScenarioViewModel>;
  scenarioId?: Maybe<Scalars['Ulid']['output']>;
  tariffId: Scalars['Ulid']['output'];
};

export type LimitPolicyViewModelFilterInput = {
  activatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  and?: InputMaybe<Array<LimitPolicyViewModelFilterInput>>;
  billingCycleId?: InputMaybe<IntOperationFilterInput>;
  deactivatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  facilityId?: InputMaybe<UlidExtendedFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  limitId?: InputMaybe<UlidExtendedFilterInput>;
  limitPolicyId?: InputMaybe<UlidExtendedFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<LimitPolicyViewModelFilterInput>>;
  priority?: InputMaybe<IntOperationFilterInput>;
  scenarioId?: InputMaybe<UlidExtendedFilterInput>;
  tariffId?: InputMaybe<UlidExtendedFilterInput>;
};

export type LimitPolicyViewModelSortInput = {
  activatedAt?: InputMaybe<SortEnumType>;
  billingCycle?: InputMaybe<BillingCycleViewModelSortInput>;
  billingCycleId?: InputMaybe<SortEnumType>;
  deactivatedAt?: InputMaybe<SortEnumType>;
  facility?: InputMaybe<FacilityViewModelSortInput>;
  facilityId?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  limit?: InputMaybe<LimitViewModelSortInput>;
  limitId?: InputMaybe<SortEnumType>;
  limitPolicyId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  priority?: InputMaybe<SortEnumType>;
  scenario?: InputMaybe<ScenarioViewModelSortInput>;
  scenarioId?: InputMaybe<SortEnumType>;
  tariffId?: InputMaybe<SortEnumType>;
};

export type LimitViewModel = {
  __typename?: 'LimitViewModel';
  facility: FacilityViewModel;
  facilityId: Scalars['Ulid']['output'];
  limitId: Scalars['Ulid']['output'];
  limitPolicies: Array<LimitPolicyViewModel>;
  maxAmount?: Maybe<Scalars['PositiveOrZeroDecimal']['output']>;
  maxStayMinutes?: Maybe<Scalars['PositiveOrZeroInt']['output']>;
  minAmount?: Maybe<Scalars['PositiveOrZeroDecimal']['output']>;
  minStayMinutes?: Maybe<Scalars['PositiveOrZeroInt']['output']>;
  pricingPolicies: Array<PricingPolicyViewModel>;
  tariffId: Scalars['Ulid']['output'];
};

export type LimitViewModelSortInput = {
  facility?: InputMaybe<FacilityViewModelSortInput>;
  facilityId?: InputMaybe<SortEnumType>;
  limitId?: InputMaybe<SortEnumType>;
  maxAmount?: InputMaybe<SortEnumType>;
  maxStayMinutes?: InputMaybe<SortEnumType>;
  minAmount?: InputMaybe<SortEnumType>;
  minStayMinutes?: InputMaybe<SortEnumType>;
  tariffId?: InputMaybe<SortEnumType>;
};

export type LocalDateOperationFilterInput = {
  eq?: InputMaybe<Scalars['LocalDate']['input']>;
  gt?: InputMaybe<Scalars['LocalDate']['input']>;
  gte?: InputMaybe<Scalars['LocalDate']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['LocalDate']['input']>>>;
  lt?: InputMaybe<Scalars['LocalDate']['input']>;
  lte?: InputMaybe<Scalars['LocalDate']['input']>;
  neq?: InputMaybe<Scalars['LocalDate']['input']>;
  ngt?: InputMaybe<Scalars['LocalDate']['input']>;
  ngte?: InputMaybe<Scalars['LocalDate']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['LocalDate']['input']>>>;
  nlt?: InputMaybe<Scalars['LocalDate']['input']>;
  nlte?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type LocalTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['LocalTime']['input']>;
  gt?: InputMaybe<Scalars['LocalTime']['input']>;
  gte?: InputMaybe<Scalars['LocalTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['LocalTime']['input']>>>;
  lt?: InputMaybe<Scalars['LocalTime']['input']>;
  lte?: InputMaybe<Scalars['LocalTime']['input']>;
  neq?: InputMaybe<Scalars['LocalTime']['input']>;
  ngt?: InputMaybe<Scalars['LocalTime']['input']>;
  ngte?: InputMaybe<Scalars['LocalTime']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['LocalTime']['input']>>>;
  nlt?: InputMaybe<Scalars['LocalTime']['input']>;
  nlte?: InputMaybe<Scalars['LocalTime']['input']>;
};

export type LogViewModel = {
  __typename?: 'LogViewModel';
  actionType: ActionTypeViewModel;
  actionTypeId?: Maybe<Scalars['PositiveInt']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  facility: FacilityViewModel;
  facilityId: Scalars['Ulid']['output'];
  logId: Scalars['Ulid']['output'];
  timestamp: Scalars['DateTime']['output'];
  user: UserViewModel;
  userId: Scalars['Ulid']['output'];
};

export type LogViewModelFilterInput = {
  actionTypeId?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<LogViewModelFilterInput>>;
  details?: InputMaybe<StringOperationFilterInput>;
  facilityId?: InputMaybe<UlidExtendedFilterInput>;
  logId?: InputMaybe<UlidExtendedFilterInput>;
  or?: InputMaybe<Array<LogViewModelFilterInput>>;
  timestamp?: InputMaybe<DateTimeOperationFilterInput>;
  userId?: InputMaybe<UlidExtendedFilterInput>;
};

export type LogViewModelSortInput = {
  actionType?: InputMaybe<ActionTypeViewModelSortInput>;
  actionTypeId?: InputMaybe<SortEnumType>;
  details?: InputMaybe<SortEnumType>;
  facility?: InputMaybe<FacilityViewModelSortInput>;
  facilityId?: InputMaybe<SortEnumType>;
  logId?: InputMaybe<SortEnumType>;
  timestamp?: InputMaybe<SortEnumType>;
  user?: InputMaybe<UserViewModelSortInput>;
  userId?: InputMaybe<SortEnumType>;
};

export type LoginPayload = {
  __typename?: 'LoginPayload';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  user?: Maybe<UserInfo>;
};

export type LogoutPayload = {
  __typename?: 'LogoutPayload';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type LongOperationFilterInput = {
  eq?: InputMaybe<Scalars['Long']['input']>;
  gt?: InputMaybe<Scalars['Long']['input']>;
  gte?: InputMaybe<Scalars['Long']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  lt?: InputMaybe<Scalars['Long']['input']>;
  lte?: InputMaybe<Scalars['Long']['input']>;
  neq?: InputMaybe<Scalars['Long']['input']>;
  ngt?: InputMaybe<Scalars['Long']['input']>;
  ngte?: InputMaybe<Scalars['Long']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  nlt?: InputMaybe<Scalars['Long']['input']>;
  nlte?: InputMaybe<Scalars['Long']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  changeParkingSession: CheckResultEnumOfChangeParkingSessionError;
  createCampaign: CheckResult;
  createContract: CheckResult;
  createCustomer: CheckResult;
  createGuaranteeTransaction: CheckResult;
  createLimitPolicy: CheckResult;
  createParkingSession: CheckResultEnumOfCreateParkingSessionError;
  createPricingPolicy: CheckResult;
  createScenario: CheckResult;
  createTariff: CheckResult;
  createTerminal: CheckResult;
  createVehicle: CheckResult;
  createVoucher: CheckResult;
  deleteCampaign: CheckResult;
  deleteContract: CheckResult;
  deleteCustomer: CheckResult;
  deleteLimitPolicy: CheckResult;
  deletePricingPolicy: CheckResult;
  deleteScenario: CheckResult;
  deleteTerminal: CheckResult;
  deleteVehicle: CheckResult;
  deleteVoucher: CheckResult;
  login: LoginPayload;
  logout: LogoutPayload;
  refreshSession: RefreshPayload;
  setMainTariff: CheckResult;
  updateCampaign: CheckResult;
  updateContract: CheckResult;
  updateCustomer: CheckResult;
  updateLimitPolicy: CheckResult;
  updatePricingPolicy: CheckResult;
  updateScenario: CheckResult;
  updateTariff: CheckResult;
  updateTerminal: CheckResult;
  updateVehicle: CheckResult;
  updateVoucher: CheckResult;
  voidGuaranteeTransaction: CheckResult;
};


export type MutationChangeParkingSessionArgs = {
  input: ChangeParkingSessionInput;
};


export type MutationCreateCampaignArgs = {
  input: CreateCampaignInput;
};


export type MutationCreateContractArgs = {
  input: CreateContractInput;
};


export type MutationCreateCustomerArgs = {
  input: CreateCustomerInput;
};


export type MutationCreateGuaranteeTransactionArgs = {
  input: CreateGuaranteeTransactionInput;
};


export type MutationCreateLimitPolicyArgs = {
  input: CreateLimitPolicyInput;
};


export type MutationCreateParkingSessionArgs = {
  input: CreateParkingSessionInput;
};


export type MutationCreatePricingPolicyArgs = {
  input: CreatePricingPolicyInput;
};


export type MutationCreateScenarioArgs = {
  input: CreateScenarioInput;
};


export type MutationCreateTariffArgs = {
  input: CreateTariffInput;
};


export type MutationCreateTerminalArgs = {
  input: CreateTerminalInput;
};


export type MutationCreateVehicleArgs = {
  input: CreateVehicleInput;
};


export type MutationCreateVoucherArgs = {
  input: CreateVoucherInput;
};


export type MutationDeleteCampaignArgs = {
  input: DeleteCampaignInput;
};


export type MutationDeleteContractArgs = {
  input: DeleteContractInput;
};


export type MutationDeleteCustomerArgs = {
  input: DeleteCustomerInput;
};


export type MutationDeleteLimitPolicyArgs = {
  input: DeleteLimitPolicyInput;
};


export type MutationDeletePricingPolicyArgs = {
  input: DeletePricingPolicyInput;
};


export type MutationDeleteScenarioArgs = {
  input: DeleteScenarioInput;
};


export type MutationDeleteTerminalArgs = {
  input: DeleteTerminalInput;
};


export type MutationDeleteVehicleArgs = {
  input: DeleteVehicleInput;
};


export type MutationDeleteVoucherArgs = {
  input: DeleteVoucherInput;
};


export type MutationLoginArgs = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationSetMainTariffArgs = {
  input: SetMainTariffInput;
};


export type MutationUpdateCampaignArgs = {
  input: UpdateCampaignInput;
};


export type MutationUpdateContractArgs = {
  input: UpdateContractInput;
};


export type MutationUpdateCustomerArgs = {
  input: UpdateCustomerInput;
};


export type MutationUpdateLimitPolicyArgs = {
  input: UpdateLimitPolicyInput;
};


export type MutationUpdatePricingPolicyArgs = {
  input: UpdatePricingPolicyInput;
};


export type MutationUpdateScenarioArgs = {
  input: UpdateScenarioInput;
};


export type MutationUpdateTariffArgs = {
  input: UpdateTariffInput;
};


export type MutationUpdateTerminalArgs = {
  input: UpdateTerminalInput;
};


export type MutationUpdateVehicleArgs = {
  input: UpdateVehicleInput;
};


export type MutationUpdateVoucherArgs = {
  input: UpdateVoucherInput;
};


export type MutationVoidGuaranteeTransactionArgs = {
  input: VoidGuaranteeTransactionInput;
};

export type NullableOfCancelReasonOperationFilterInput = {
  eq?: InputMaybe<CancelReason>;
  in?: InputMaybe<Array<InputMaybe<CancelReason>>>;
  neq?: InputMaybe<CancelReason>;
  nin?: InputMaybe<Array<InputMaybe<CancelReason>>>;
};

export type OperationsTransactionTypeViewModel = {
  __typename?: 'OperationsTransactionTypeViewModel';
  chargeLedgerEntries: Array<ChargeLedgerEntryViewModel>;
  code?: Maybe<Scalars['String50']['output']>;
  isActive: Scalars['Boolean']['output'];
  isDebit: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String255']['output']>;
  requiresPaymentMethod: Scalars['Boolean']['output'];
  transactionTypeId?: Maybe<Scalars['PositiveInt']['output']>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Indicates whether more edges exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Indicates whether more edges exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type ParkingPositionViewModel = {
  __typename?: 'ParkingPositionViewModel';
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  code?: Maybe<Scalars['String50']['output']>;
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String255']['output']>;
  floor: FloorViewModel;
  floorId: Scalars['Ulid']['output'];
  isOccupied: Scalars['Boolean']['output'];
  isOperational: Scalars['Boolean']['output'];
  parkingPositionId: Scalars['Ulid']['output'];
  parkingSessions: Array<ParkingSessionViewModel>;
};

export type ParkingPositionViewModelFilterInput = {
  activatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  and?: InputMaybe<Array<ParkingPositionViewModelFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  deactivatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  floorId?: InputMaybe<UlidExtendedFilterInput>;
  isOccupied?: InputMaybe<BooleanOperationFilterInput>;
  isOperational?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<ParkingPositionViewModelFilterInput>>;
  parkingPositionId?: InputMaybe<UlidExtendedFilterInput>;
};

export type ParkingPositionViewModelSortInput = {
  activatedAt?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  deactivatedAt?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  floor?: InputMaybe<FloorViewModelSortInput>;
  floorId?: InputMaybe<SortEnumType>;
  isOccupied?: InputMaybe<SortEnumType>;
  isOperational?: InputMaybe<SortEnumType>;
  parkingPositionId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ParkingPositionsConnection = {
  __typename?: 'ParkingPositionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ParkingPositionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ParkingPositionViewModel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ParkingPositionsEdge = {
  __typename?: 'ParkingPositionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ParkingPositionViewModel;
};

export type ParkingSessionCreatedPayload = {
  __typename?: 'ParkingSessionCreatedPayload';
  contractId?: Maybe<Scalars['Ulid']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customerId?: Maybe<Scalars['Ulid']['output']>;
  entryDateTime: Scalars['DateTime']['output'];
  facilityId: Scalars['Ulid']['output'];
  parkingSessionId: Scalars['Ulid']['output'];
  parkingSessionTypeId: Scalars['Int']['output'];
  plateNumber?: Maybe<Scalars['String50']['output']>;
  status: ParkingSessionStatus;
  ticketId: Scalars['String']['output'];
  vehicleId?: Maybe<Scalars['Ulid']['output']>;
};

export type ParkingSessionServiceViewModel = {
  __typename?: 'ParkingSessionServiceViewModel';
  parkingSession: ParkingSessionViewModel;
  parkingSessionId: Scalars['Ulid']['output'];
  parkingSessionServiceId: Scalars['Ulid']['output'];
  priceCharged?: Maybe<Scalars['PositiveDecimal']['output']>;
  service: ServiceViewModel;
  serviceId: Scalars['Ulid']['output'];
};

export enum ParkingSessionStatus {
  Canceled = 'CANCELED',
  Exited = 'EXITED',
  Inside = 'INSIDE'
}

export type ParkingSessionStatusOperationFilterInput = {
  eq?: InputMaybe<ParkingSessionStatus>;
  in?: InputMaybe<Array<ParkingSessionStatus>>;
  neq?: InputMaybe<ParkingSessionStatus>;
  nin?: InputMaybe<Array<ParkingSessionStatus>>;
};

export type ParkingSessionTypeViewModel = {
  __typename?: 'ParkingSessionTypeViewModel';
  name?: Maybe<Scalars['String255']['output']>;
  parkingSessionTypeId?: Maybe<Scalars['PositiveInt']['output']>;
  parkingSessions: Array<ParkingSessionViewModel>;
};

export type ParkingSessionTypeViewModelSortInput = {
  name?: InputMaybe<SortEnumType>;
  parkingSessionTypeId?: InputMaybe<SortEnumType>;
};

export type ParkingSessionViewModel = {
  __typename?: 'ParkingSessionViewModel';
  aadeInvoices: Array<AadeInvoiceViewModel>;
  cancelReason?: Maybe<CancelReason>;
  canceledDateTime?: Maybe<Scalars['DateTime']['output']>;
  cashierShift: CashierShiftViewModel;
  cashierShiftId: Scalars['Ulid']['output'];
  chargeLedgerEntries: Array<ChargeLedgerEntryViewModel>;
  contract?: Maybe<ContractViewModel>;
  contractId?: Maybe<Scalars['Ulid']['output']>;
  customer?: Maybe<CustomerViewModel>;
  customerId?: Maybe<Scalars['Ulid']['output']>;
  entryDateTime: Scalars['DateTime']['output'];
  exitDateTime?: Maybe<Scalars['DateTime']['output']>;
  facility: FacilityViewModel;
  facilityId: Scalars['Ulid']['output'];
  fiscalDocuments: Array<FiscalDocumentViewModel>;
  parkingPosition?: Maybe<ParkingPositionViewModel>;
  parkingPositionId?: Maybe<Scalars['Ulid']['output']>;
  parkingSessionId: Scalars['Ulid']['output'];
  parkingSessionType: ParkingSessionTypeViewModel;
  parkingSessionTypeId?: Maybe<Scalars['PositiveInt']['output']>;
  paymentAmount?: Maybe<Scalars['PositiveOrZeroDecimal']['output']>;
  paymentDateTime?: Maybe<Scalars['DateTime']['output']>;
  paymentMethod: PaymentMethodViewModel;
  paymentMethodId?: Maybe<Scalars['PositiveInt']['output']>;
  reservations: Array<ReservationViewModel>;
  services: Array<ParkingSessionServiceViewModel>;
  status: ParkingSessionStatus;
  ticketId?: Maybe<Scalars['String255']['output']>;
  totalChargeAmount?: Maybe<Scalars['PositiveOrZeroDecimal']['output']>;
  totalPaidAmount?: Maybe<Scalars['PositiveOrZeroDecimal']['output']>;
  vehicle?: Maybe<VehicleViewModel>;
  vehicleId?: Maybe<Scalars['Ulid']['output']>;
  vehicleJourneyLogs: Array<VehicleJourneyLogViewModel>;
  voucherParkingSessions: Array<VoucherParkingSessionViewModel>;
};

export type ParkingSessionViewModelFilterInput = {
  and?: InputMaybe<Array<ParkingSessionViewModelFilterInput>>;
  cancelReason?: InputMaybe<NullableOfCancelReasonOperationFilterInput>;
  canceledDateTime?: InputMaybe<DateTimeOperationFilterInput>;
  cashierShiftId?: InputMaybe<UlidExtendedFilterInput>;
  contractId?: InputMaybe<UlidExtendedFilterInput>;
  customerId?: InputMaybe<UlidExtendedFilterInput>;
  entryDateTime?: InputMaybe<DateTimeOperationFilterInput>;
  exitDateTime?: InputMaybe<DateTimeOperationFilterInput>;
  facilityId?: InputMaybe<UlidExtendedFilterInput>;
  or?: InputMaybe<Array<ParkingSessionViewModelFilterInput>>;
  parkingPositionId?: InputMaybe<UlidExtendedFilterInput>;
  parkingSessionId?: InputMaybe<UlidExtendedFilterInput>;
  parkingSessionTypeId?: InputMaybe<IntOperationFilterInput>;
  paymentAmount?: InputMaybe<DecimalOperationFilterInput>;
  paymentDateTime?: InputMaybe<DateTimeOperationFilterInput>;
  paymentMethodId?: InputMaybe<IntOperationFilterInput>;
  status?: InputMaybe<ParkingSessionStatusOperationFilterInput>;
  ticketId?: InputMaybe<StringOperationFilterInput>;
  totalChargeAmount?: InputMaybe<DecimalOperationFilterInput>;
  totalPaidAmount?: InputMaybe<DecimalOperationFilterInput>;
  vehicle?: InputMaybe<VehicleViewModelFilterInput>;
  vehicleId?: InputMaybe<UlidExtendedFilterInput>;
};

export type ParkingSessionViewModelSortInput = {
  cancelReason?: InputMaybe<SortEnumType>;
  canceledDateTime?: InputMaybe<SortEnumType>;
  cashierShift?: InputMaybe<CashierShiftViewModelSortInput>;
  cashierShiftId?: InputMaybe<SortEnumType>;
  contract?: InputMaybe<ContractViewModelSortInput>;
  contractId?: InputMaybe<SortEnumType>;
  customer?: InputMaybe<CustomerViewModelSortInput>;
  customerId?: InputMaybe<SortEnumType>;
  entryDateTime?: InputMaybe<SortEnumType>;
  exitDateTime?: InputMaybe<SortEnumType>;
  facility?: InputMaybe<FacilityViewModelSortInput>;
  facilityId?: InputMaybe<SortEnumType>;
  parkingPosition?: InputMaybe<ParkingPositionViewModelSortInput>;
  parkingPositionId?: InputMaybe<SortEnumType>;
  parkingSessionId?: InputMaybe<SortEnumType>;
  parkingSessionType?: InputMaybe<ParkingSessionTypeViewModelSortInput>;
  parkingSessionTypeId?: InputMaybe<SortEnumType>;
  paymentAmount?: InputMaybe<SortEnumType>;
  paymentDateTime?: InputMaybe<SortEnumType>;
  paymentMethod?: InputMaybe<PaymentMethodViewModelSortInput>;
  paymentMethodId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  ticketId?: InputMaybe<SortEnumType>;
  totalChargeAmount?: InputMaybe<SortEnumType>;
  totalPaidAmount?: InputMaybe<SortEnumType>;
  vehicle?: InputMaybe<VehicleViewModelSortInput>;
  vehicleId?: InputMaybe<SortEnumType>;
};

export type ParkingSessionsActiveReservationsViewModel = {
  __typename?: 'ParkingSessionsActiveReservationsViewModel';
  facilityId: Scalars['Ulid']['output'];
  itemsCount?: Maybe<Scalars['PositiveOrZeroInt']['output']>;
};

export type ParkingSessionsActiveReservationsViewModelFilterInput = {
  and?: InputMaybe<Array<ParkingSessionsActiveReservationsViewModelFilterInput>>;
  facilityId?: InputMaybe<UlidExtendedFilterInput>;
  itemsCount?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ParkingSessionsActiveReservationsViewModelFilterInput>>;
};

export type ParkingSessionsActiveReservationsViewModelSortInput = {
  facilityId?: InputMaybe<SortEnumType>;
  itemsCount?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ParkingSessionsConnection = {
  __typename?: 'ParkingSessionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ParkingSessionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ParkingSessionViewModel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ParkingSessionsEdge = {
  __typename?: 'ParkingSessionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ParkingSessionViewModel;
};

/** A connection to a list of items. */
export type ParkingSessionsEntryPerDayConnection = {
  __typename?: 'ParkingSessionsEntryPerDayConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ParkingSessionsEntryPerDayEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ParkingSessionsEntryPerDayViewModel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ParkingSessionsEntryPerDayEdge = {
  __typename?: 'ParkingSessionsEntryPerDayEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ParkingSessionsEntryPerDayViewModel;
};

export type ParkingSessionsEntryPerDayViewModel = {
  __typename?: 'ParkingSessionsEntryPerDayViewModel';
  entryDate: Scalars['DateTime']['output'];
  facilityId: Scalars['Ulid']['output'];
  itemsCount?: Maybe<Scalars['PositiveOrZeroInt']['output']>;
};

export type ParkingSessionsEntryPerDayViewModelFilterInput = {
  and?: InputMaybe<Array<ParkingSessionsEntryPerDayViewModelFilterInput>>;
  entryDate?: InputMaybe<DateTimeOperationFilterInput>;
  facilityId?: InputMaybe<UlidExtendedFilterInput>;
  itemsCount?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<ParkingSessionsEntryPerDayViewModelFilterInput>>;
};

export type ParkingSessionsEntryPerDayViewModelSortInput = {
  entryDate?: InputMaybe<SortEnumType>;
  facilityId?: InputMaybe<SortEnumType>;
  itemsCount?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ParkingSessionsExitPerDayConnection = {
  __typename?: 'ParkingSessionsExitPerDayConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ParkingSessionsExitPerDayEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ParkingSessionsExitPerDayViewModel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ParkingSessionsExitPerDayEdge = {
  __typename?: 'ParkingSessionsExitPerDayEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ParkingSessionsExitPerDayViewModel;
};

export type ParkingSessionsExitPerDayViewModel = {
  __typename?: 'ParkingSessionsExitPerDayViewModel';
  exitDate: Scalars['DateTime']['output'];
  facilityId: Scalars['Ulid']['output'];
  itemsCount?: Maybe<Scalars['PositiveOrZeroInt']['output']>;
};

export type ParkingSessionsExitPerDayViewModelFilterInput = {
  and?: InputMaybe<Array<ParkingSessionsExitPerDayViewModelFilterInput>>;
  exitDate?: InputMaybe<DateTimeOperationFilterInput>;
  facilityId?: InputMaybe<UlidExtendedFilterInput>;
  itemsCount?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<ParkingSessionsExitPerDayViewModelFilterInput>>;
};

export type ParkingSessionsExitPerDayViewModelSortInput = {
  exitDate?: InputMaybe<SortEnumType>;
  facilityId?: InputMaybe<SortEnumType>;
  itemsCount?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ParkingSessionsInsideOnContractsConnection = {
  __typename?: 'ParkingSessionsInsideOnContractsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ParkingSessionsInsideOnContractsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ParkingSessionsInsideOnContractsViewModel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ParkingSessionsInsideOnContractsEdge = {
  __typename?: 'ParkingSessionsInsideOnContractsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ParkingSessionsInsideOnContractsViewModel;
};

export type ParkingSessionsInsideOnContractsViewModel = {
  __typename?: 'ParkingSessionsInsideOnContractsViewModel';
  entryDate: Scalars['DateTime']['output'];
  facilityId: Scalars['Ulid']['output'];
  itemsCount?: Maybe<Scalars['PositiveOrZeroInt']['output']>;
};

export type ParkingSessionsInsideOnContractsViewModelFilterInput = {
  and?: InputMaybe<Array<ParkingSessionsInsideOnContractsViewModelFilterInput>>;
  entryDate?: InputMaybe<DateTimeOperationFilterInput>;
  facilityId?: InputMaybe<UlidExtendedFilterInput>;
  itemsCount?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<ParkingSessionsInsideOnContractsViewModelFilterInput>>;
};

export type ParkingSessionsInsideOnContractsViewModelSortInput = {
  entryDate?: InputMaybe<SortEnumType>;
  facilityId?: InputMaybe<SortEnumType>;
  itemsCount?: InputMaybe<SortEnumType>;
};

export type ParkingSessionsInsideOnReservationsViewModel = {
  __typename?: 'ParkingSessionsInsideOnReservationsViewModel';
  facilityId: Scalars['Ulid']['output'];
  itemsCount?: Maybe<Scalars['PositiveOrZeroInt']['output']>;
};

export type ParkingSessionsInsideOnReservationsViewModelFilterInput = {
  and?: InputMaybe<Array<ParkingSessionsInsideOnReservationsViewModelFilterInput>>;
  facilityId?: InputMaybe<UlidExtendedFilterInput>;
  itemsCount?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ParkingSessionsInsideOnReservationsViewModelFilterInput>>;
};

export type ParkingSessionsInsideOnReservationsViewModelSortInput = {
  facilityId?: InputMaybe<SortEnumType>;
  itemsCount?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ParkingSessionsOnContractsConnection = {
  __typename?: 'ParkingSessionsOnContractsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ParkingSessionsOnContractsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ParkingSessionsOnContractsViewModel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ParkingSessionsOnContractsEdge = {
  __typename?: 'ParkingSessionsOnContractsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ParkingSessionsOnContractsViewModel;
};

export type ParkingSessionsOnContractsViewModel = {
  __typename?: 'ParkingSessionsOnContractsViewModel';
  entryDate: Scalars['DateTime']['output'];
  facilityId: Scalars['Ulid']['output'];
  itemsCount?: Maybe<Scalars['PositiveOrZeroInt']['output']>;
};

export type ParkingSessionsOnContractsViewModelFilterInput = {
  and?: InputMaybe<Array<ParkingSessionsOnContractsViewModelFilterInput>>;
  entryDate?: InputMaybe<DateTimeOperationFilterInput>;
  facilityId?: InputMaybe<UlidExtendedFilterInput>;
  itemsCount?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<ParkingSessionsOnContractsViewModelFilterInput>>;
};

export type ParkingSessionsOnContractsViewModelSortInput = {
  entryDate?: InputMaybe<SortEnumType>;
  facilityId?: InputMaybe<SortEnumType>;
  itemsCount?: InputMaybe<SortEnumType>;
};

export type ParkingSessionsPerStatusViewModel = {
  __typename?: 'ParkingSessionsPerStatusViewModel';
  facilityId: Scalars['Ulid']['output'];
  itemsCount?: Maybe<Scalars['PositiveOrZeroInt']['output']>;
  status: ParkingSessionStatus;
};

export type ParkingSessionsPerStatusViewModelFilterInput = {
  and?: InputMaybe<Array<ParkingSessionsPerStatusViewModelFilterInput>>;
  facilityId?: InputMaybe<UlidExtendedFilterInput>;
  itemsCount?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<ParkingSessionsPerStatusViewModelFilterInput>>;
  status?: InputMaybe<ParkingSessionStatusOperationFilterInput>;
};

export type ParkingSessionsPerStatusViewModelSortInput = {
  facilityId?: InputMaybe<SortEnumType>;
  itemsCount?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
};

export type PaymentMethodViewModel = {
  __typename?: 'PaymentMethodViewModel';
  conditionPaymentMethods: Array<ConditionPaymentMethodViewModel>;
  name?: Maybe<Scalars['String255']['output']>;
  parkingSessions: Array<ParkingSessionViewModel>;
  paymentMethodId?: Maybe<Scalars['PositiveInt']['output']>;
};

export type PaymentMethodViewModelSortInput = {
  name?: InputMaybe<SortEnumType>;
  paymentMethodId?: InputMaybe<SortEnumType>;
};

export type PermissionViewModel = {
  __typename?: 'PermissionViewModel';
  description?: Maybe<Scalars['String1000']['output']>;
  name?: Maybe<Scalars['String255']['output']>;
  permissionId?: Maybe<Scalars['PositiveInt']['output']>;
  rolePermissions: Array<RolePermissionViewModel>;
};

export type PlateNumberBlacklistViewModel = {
  __typename?: 'PlateNumberBlacklistViewModel';
  facility: FacilityViewModel;
  facilityId: Scalars['Ulid']['output'];
  plateNumber?: Maybe<Scalars['String50']['output']>;
  reason?: Maybe<Scalars['String1000']['output']>;
};

export type PlateNumberBlacklistViewModelFilterInput = {
  and?: InputMaybe<Array<PlateNumberBlacklistViewModelFilterInput>>;
  facilityId?: InputMaybe<UlidExtendedFilterInput>;
  or?: InputMaybe<Array<PlateNumberBlacklistViewModelFilterInput>>;
  plateNumber?: InputMaybe<StringOperationFilterInput>;
  reason?: InputMaybe<StringOperationFilterInput>;
};

export type PlateNumberBlacklistViewModelSortInput = {
  facility?: InputMaybe<FacilityViewModelSortInput>;
  facilityId?: InputMaybe<SortEnumType>;
  plateNumber?: InputMaybe<SortEnumType>;
  reason?: InputMaybe<SortEnumType>;
};

export type PrepaidCardTransactionViewModel = {
  __typename?: 'PrepaidCardTransactionViewModel';
  amount: Scalars['Decimal']['output'];
  parkingSession: ParkingSessionViewModel;
  parkingSessionId: Scalars['Ulid']['output'];
  prepaidCard: PrepaidCardViewModel;
  prepaidCardId: Scalars['Ulid']['output'];
  prepaidCardTransactionId: Scalars['Ulid']['output'];
  prepaidCardVehicle: PrepaidCardVehicleViewModel;
  prepaidCardVehicleId: Scalars['Ulid']['output'];
  transactionDate: Scalars['DateTime']['output'];
  transactionType: TransactionTypeViewModel;
  transactionTypeId: Scalars['Int']['output'];
};

export type PrepaidCardVehicleViewModel = {
  __typename?: 'PrepaidCardVehicleViewModel';
  prepaidCard: PrepaidCardViewModel;
  prepaidCardId: Scalars['Ulid']['output'];
  prepaidCardTransactions: Array<PrepaidCardTransactionViewModel>;
  prepaidCardVehicleId: Scalars['Ulid']['output'];
  rate: RateViewModel;
  rateId: Scalars['Ulid']['output'];
  vehicle: VehicleViewModel;
  vehicleId: Scalars['Ulid']['output'];
};

export type PrepaidCardViewModel = {
  __typename?: 'PrepaidCardViewModel';
  amount: Scalars['PositiveOrZeroDecimal']['output'];
  customer: CustomerViewModel;
  customerId: Scalars['Ulid']['output'];
  defaultRate: RateViewModel;
  defaultRateId: Scalars['Ulid']['output'];
  endDate: Scalars['DateTime']['output'];
  isActive: Scalars['Boolean']['output'];
  prepaidCardId: Scalars['Ulid']['output'];
  prepaidCardTransactions: Array<PrepaidCardTransactionViewModel>;
  prepaidCardVehicles: Array<PrepaidCardVehicleViewModel>;
  prepaidCode: Scalars['String255']['output'];
};

export type PrepaidCardViewModelFilterInput = {
  amount?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<PrepaidCardViewModelFilterInput>>;
  customerId?: InputMaybe<UlidExtendedFilterInput>;
  defaultRateId?: InputMaybe<UlidExtendedFilterInput>;
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<PrepaidCardViewModelFilterInput>>;
  prepaidCardId?: InputMaybe<UlidExtendedFilterInput>;
  prepaidCode?: InputMaybe<StringOperationFilterInput>;
};

export type PrepaidCardViewModelSortInput = {
  amount?: InputMaybe<SortEnumType>;
  customer?: InputMaybe<CustomerViewModelSortInput>;
  customerId?: InputMaybe<SortEnumType>;
  defaultRate?: InputMaybe<RateViewModelSortInput>;
  defaultRateId?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  prepaidCardId?: InputMaybe<SortEnumType>;
  prepaidCode?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type PrepaidCardsByCustomerConnection = {
  __typename?: 'PrepaidCardsByCustomerConnection';
  /** A list of edges. */
  edges?: Maybe<Array<PrepaidCardsByCustomerEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<PrepaidCardViewModel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PrepaidCardsByCustomerEdge = {
  __typename?: 'PrepaidCardsByCustomerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PrepaidCardViewModel;
};

/** A connection to a list of items. */
export type PrepaidCardsConnection = {
  __typename?: 'PrepaidCardsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<PrepaidCardsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<PrepaidCardViewModel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PrepaidCardsEdge = {
  __typename?: 'PrepaidCardsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PrepaidCardViewModel;
};

/** A connection to a list of items. */
export type PricingPoliciesConnection = {
  __typename?: 'PricingPoliciesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<PricingPoliciesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<PricingPolicyViewModel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PricingPoliciesEdge = {
  __typename?: 'PricingPoliciesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PricingPolicyViewModel;
};

export type PricingPolicyViewModel = {
  __typename?: 'PricingPolicyViewModel';
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  billingCycle: BillingCycleViewModel;
  billingCycleId: Scalars['PositiveInt']['output'];
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  facility: FacilityViewModel;
  facilityId: Scalars['Ulid']['output'];
  isActive: Scalars['Boolean']['output'];
  limit?: Maybe<LimitViewModel>;
  limitId?: Maybe<Scalars['Ulid']['output']>;
  name: Scalars['String255']['output'];
  overstayRate?: Maybe<RateViewModel>;
  overstayRateId?: Maybe<Scalars['Ulid']['output']>;
  pricingPolicyId: Scalars['Ulid']['output'];
  priority: Scalars['PositiveInt']['output'];
  rate: RateViewModel;
  rateId: Scalars['Ulid']['output'];
  scenario?: Maybe<ScenarioViewModel>;
  scenarioId?: Maybe<Scalars['Ulid']['output']>;
  tariffId: Scalars['Ulid']['output'];
};

export type PricingPolicyViewModelFilterInput = {
  activatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  and?: InputMaybe<Array<PricingPolicyViewModelFilterInput>>;
  billingCycleId?: InputMaybe<IntOperationFilterInput>;
  deactivatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  facilityId?: InputMaybe<UlidExtendedFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  limitId?: InputMaybe<UlidExtendedFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PricingPolicyViewModelFilterInput>>;
  overstayRateId?: InputMaybe<UlidExtendedFilterInput>;
  pricingPolicyId?: InputMaybe<UlidExtendedFilterInput>;
  priority?: InputMaybe<IntOperationFilterInput>;
  rateId?: InputMaybe<UlidExtendedFilterInput>;
  scenarioId?: InputMaybe<UlidExtendedFilterInput>;
  tariffId?: InputMaybe<UlidExtendedFilterInput>;
};

export type PricingPolicyViewModelSortInput = {
  activatedAt?: InputMaybe<SortEnumType>;
  billingCycle?: InputMaybe<BillingCycleViewModelSortInput>;
  billingCycleId?: InputMaybe<SortEnumType>;
  deactivatedAt?: InputMaybe<SortEnumType>;
  facility?: InputMaybe<FacilityViewModelSortInput>;
  facilityId?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  limit?: InputMaybe<LimitViewModelSortInput>;
  limitId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  overstayRate?: InputMaybe<RateViewModelSortInput>;
  overstayRateId?: InputMaybe<SortEnumType>;
  pricingPolicyId?: InputMaybe<SortEnumType>;
  priority?: InputMaybe<SortEnumType>;
  rate?: InputMaybe<RateViewModelSortInput>;
  rateId?: InputMaybe<SortEnumType>;
  scenario?: InputMaybe<ScenarioViewModelSortInput>;
  scenarioId?: InputMaybe<SortEnumType>;
  tariffId?: InputMaybe<SortEnumType>;
};

export type Query = {
  __typename?: 'Query';
  actionTypes: Array<ActionTypeViewModel>;
  addressTypes: Array<AddressTypeViewModel>;
  alert?: Maybe<AlertViewModel>;
  alertUserReads?: Maybe<AlertUserReadsConnection>;
  alerts?: Maybe<AlertsConnection>;
  alertsByCode?: Maybe<AlertsByCodeConnection>;
  allAssociatedVehicles: Array<VehicleViewModel>;
  auditLogs?: Maybe<AuditLogsConnection>;
  banks: Array<BankViewModel>;
  billingCycles: Array<BillingCycleViewModel>;
  blacklistEntries?: Maybe<BlacklistEntriesConnection>;
  campaign?: Maybe<CampaignViewModel>;
  campaigns?: Maybe<CampaignsConnection>;
  cashierShiftStatuses: Array<CashierShiftStatusViewModel>;
  chargeLedgerEntries: Array<ChargeLedgerEntryViewModel>;
  condition?: Maybe<ConditionViewModel>;
  conditions?: Maybe<ConditionsConnection>;
  contactType?: Maybe<ContactTypeViewModel>;
  contactTypes: Array<ContactTypeViewModel>;
  contract?: Maybe<ContractViewModel>;
  contracts?: Maybe<ContractsConnection>;
  criticalAlerts?: Maybe<CriticalAlertsConnection>;
  currentUser: CurrentUserPayload;
  customer?: Maybe<CustomerViewModel>;
  customerBankDetails?: Maybe<CustomerBankDetailsConnection>;
  customerBeneficiaries?: Maybe<CustomerBeneficiariesConnection>;
  customerCategories: Array<CustomerCategoryViewModel>;
  customerContacts?: Maybe<CustomerContactsConnection>;
  customers?: Maybe<CustomersConnection>;
  dayOfWeeks: Array<DayOfWeekViewModel>;
  facilities?: Maybe<FacilitiesConnection>;
  fiscalDocument?: Maybe<FiscalDocumentViewModel>;
  fiscalDocumentByParkingSession?: Maybe<FiscalDocumentViewModel>;
  fiscalDocuments?: Maybe<FiscalDocumentsConnection>;
  floors: Array<FloorViewModel>;
  guaranteeTransaction?: Maybe<GuaranteeTransactionViewModel>;
  guaranteeTransactionTypes: Array<GuaranteeTransactionTypeViewModel>;
  guaranteeTransactions?: Maybe<GuaranteeTransactionsConnection>;
  guaranteeTransactionsByContractCard?: Maybe<GuaranteeTransactionsByContractCardConnection>;
  invoiceByParkingSession?: Maybe<AadeInvoiceViewModel>;
  limitPolicies?: Maybe<LimitPoliciesConnection>;
  limitPolicy?: Maybe<LimitPolicyViewModel>;
  operationsTransactionTypes: Array<OperationsTransactionTypeViewModel>;
  parkingPositions?: Maybe<ParkingPositionsConnection>;
  parkingSession?: Maybe<ParkingSessionViewModel>;
  parkingSessionTypes: Array<ParkingSessionTypeViewModel>;
  parkingSessions?: Maybe<ParkingSessionsConnection>;
  parkingSessionsActiveReservations: Array<ParkingSessionsActiveReservationsViewModel>;
  parkingSessionsEntryPerDay?: Maybe<ParkingSessionsEntryPerDayConnection>;
  parkingSessionsExitPerDay?: Maybe<ParkingSessionsExitPerDayConnection>;
  parkingSessionsInsideOnContracts?: Maybe<ParkingSessionsInsideOnContractsConnection>;
  parkingSessionsInsideOnReservations: Array<ParkingSessionsInsideOnReservationsViewModel>;
  parkingSessionsOnContracts?: Maybe<ParkingSessionsOnContractsConnection>;
  parkingSessionsPerStatus: Array<ParkingSessionsPerStatusViewModel>;
  paymentMethods: Array<PaymentMethodViewModel>;
  prepaidCard?: Maybe<PrepaidCardViewModel>;
  prepaidCards?: Maybe<PrepaidCardsConnection>;
  prepaidCardsByCustomer?: Maybe<PrepaidCardsByCustomerConnection>;
  pricingPolicies?: Maybe<PricingPoliciesConnection>;
  pricingPolicy?: Maybe<PricingPolicyViewModel>;
  rateTypes: Array<RateTypeViewModel>;
  /** Returns the reports catalog grouped for menu rendering. */
  reportCatalog: Array<ReportGroupViewModel>;
  /** Returns one report definition including columns, filters, groupings and the GraphQL query template. */
  reportDefinition?: Maybe<ReportDefinitionViewModel>;
  reservation?: Maybe<ReservationViewModel>;
  reservationStatuses: Array<ReservationStatusViewModel>;
  reservations?: Maybe<ReservationsConnection>;
  scenario?: Maybe<ScenarioViewModel>;
  scenarios?: Maybe<ScenariosConnection>;
  tariff?: Maybe<TariffViewModel>;
  tariffs?: Maybe<TariffsConnection>;
  terminal?: Maybe<TerminalViewModel>;
  terminalTypes: Array<TerminalTypeViewModel>;
  terminals?: Maybe<TerminalsConnection>;
  transactionTypes: Array<TransactionTypeViewModel>;
  unreadAlerts?: Maybe<UnreadAlertsConnection>;
  user?: Maybe<UserViewModel>;
  users?: Maybe<UsersConnection>;
  vehicle?: Maybe<VehicleViewModel>;
  vehicleJourneyEventTypes: Array<VehicleJourneyEventTypeViewModel>;
  vehicleJourneyLogs?: Maybe<VehicleJourneyLogsConnection>;
  vehicleTypes: Array<VehicleTypeViewModel>;
  vehicles?: Maybe<VehiclesConnection>;
  voucher?: Maybe<VoucherViewModel>;
  voucherByCode?: Maybe<VoucherViewModel>;
  vouchers?: Maybe<VouchersConnection>;
  weeklyDateSets: Array<WeeklyDateSetViewModel>;
};


export type QueryAddressTypesArgs = {
  order?: InputMaybe<Array<AddressTypeViewModelSortInput>>;
};


export type QueryAlertArgs = {
  alertId: Scalars['Ulid']['input'];
};


export type QueryAlertUserReadsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AlertUserReadViewModelSortInput>>;
  userId: Scalars['Ulid']['input'];
  where?: InputMaybe<AlertUserReadViewModelFilterInput>;
};


export type QueryAlertsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AlertViewModelSortInput>>;
  where?: InputMaybe<AlertViewModelFilterInput>;
};


export type QueryAlertsByCodeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  code: AlertCode;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AlertViewModelSortInput>>;
};


export type QueryAllAssociatedVehiclesArgs = {
  customerId: Scalars['Ulid']['input'];
};


export type QueryAuditLogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<LogViewModelSortInput>>;
  where?: InputMaybe<LogViewModelFilterInput>;
};


export type QueryBanksArgs = {
  order?: InputMaybe<Array<BankViewModelSortInput>>;
  where?: InputMaybe<BankViewModelFilterInput>;
};


export type QueryBlacklistEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PlateNumberBlacklistViewModelSortInput>>;
  where?: InputMaybe<PlateNumberBlacklistViewModelFilterInput>;
};


export type QueryCampaignArgs = {
  campaignId: Scalars['Ulid']['input'];
};


export type QueryCampaignsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CampaignViewModelSortInput>>;
  where?: InputMaybe<CampaignViewModelFilterInput>;
};


export type QueryConditionArgs = {
  id: Scalars['Ulid']['input'];
};


export type QueryConditionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ConditionViewModelSortInput>>;
  where?: InputMaybe<ConditionViewModelFilterInput>;
};


export type QueryContactTypeArgs = {
  contactTypeId: Scalars['Int']['input'];
};


export type QueryContactTypesArgs = {
  order?: InputMaybe<Array<ContactTypeViewModelSortInput>>;
};


export type QueryContractArgs = {
  contractId: Scalars['Ulid']['input'];
};


export type QueryContractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ContractViewModelSortInput>>;
  where?: InputMaybe<ContractViewModelFilterInput>;
};


export type QueryCriticalAlertsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AlertViewModelSortInput>>;
};


export type QueryCustomerArgs = {
  customerId: Scalars['Ulid']['input'];
};


export type QueryCustomerBankDetailsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<BankDetailsViewModelSortInput>>;
  where?: InputMaybe<BankDetailsViewModelFilterInput>;
};


export type QueryCustomerBeneficiariesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CustomerBeneficiaryViewModelSortInput>>;
  where?: InputMaybe<CustomerBeneficiaryViewModelFilterInput>;
};


export type QueryCustomerCategoriesArgs = {
  order?: InputMaybe<Array<CustomerCategoryViewModelSortInput>>;
};


export type QueryCustomerContactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CustomerContactViewModelSortInput>>;
  where?: InputMaybe<CustomerContactViewModelFilterInput>;
};


export type QueryCustomersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CustomerViewModelSortInput>>;
  where?: InputMaybe<CustomerViewModelFilterInput>;
};


export type QueryDayOfWeeksArgs = {
  order?: InputMaybe<Array<DayOfWeekViewModelSortInput>>;
};


export type QueryFacilitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<FacilityViewModelSortInput>>;
  where?: InputMaybe<FacilityViewModelFilterInput>;
};


export type QueryFiscalDocumentArgs = {
  fiscalDocumentId: Scalars['Ulid']['input'];
};


export type QueryFiscalDocumentByParkingSessionArgs = {
  parkingSessionId: Scalars['Ulid']['input'];
};


export type QueryFiscalDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<FiscalDocumentViewModelSortInput>>;
  where?: InputMaybe<FiscalDocumentViewModelFilterInput>;
};


export type QueryFloorsArgs = {
  order?: InputMaybe<Array<FloorViewModelSortInput>>;
  where?: InputMaybe<FloorViewModelFilterInput>;
};


export type QueryGuaranteeTransactionArgs = {
  guaranteeTransactionId: Scalars['Ulid']['input'];
};


export type QueryGuaranteeTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<GuaranteeTransactionViewModelSortInput>>;
  where?: InputMaybe<GuaranteeTransactionViewModelFilterInput>;
};


export type QueryGuaranteeTransactionsByContractCardArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contractCardId: Scalars['Ulid']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<GuaranteeTransactionViewModelSortInput>>;
  where?: InputMaybe<GuaranteeTransactionViewModelFilterInput>;
};


export type QueryInvoiceByParkingSessionArgs = {
  parkingSessionId: Scalars['Ulid']['input'];
};


export type QueryLimitPoliciesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<LimitPolicyViewModelSortInput>>;
  where?: InputMaybe<LimitPolicyViewModelFilterInput>;
};


export type QueryLimitPolicyArgs = {
  limitPolicyId: Scalars['Ulid']['input'];
};


export type QueryParkingPositionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ParkingPositionViewModelSortInput>>;
  where?: InputMaybe<ParkingPositionViewModelFilterInput>;
};


export type QueryParkingSessionArgs = {
  parkingSessionId: Scalars['Ulid']['input'];
};


export type QueryParkingSessionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ParkingSessionViewModelSortInput>>;
  where?: InputMaybe<ParkingSessionViewModelFilterInput>;
};


export type QueryParkingSessionsActiveReservationsArgs = {
  facilityId?: InputMaybe<Scalars['Ulid']['input']>;
  order?: InputMaybe<Array<ParkingSessionsActiveReservationsViewModelSortInput>>;
  where?: InputMaybe<ParkingSessionsActiveReservationsViewModelFilterInput>;
};


export type QueryParkingSessionsEntryPerDayArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  facilityId?: InputMaybe<Scalars['Ulid']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ParkingSessionsEntryPerDayViewModelSortInput>>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
  where?: InputMaybe<ParkingSessionsEntryPerDayViewModelFilterInput>;
};


export type QueryParkingSessionsExitPerDayArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  facilityId?: InputMaybe<Scalars['Ulid']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ParkingSessionsExitPerDayViewModelSortInput>>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
  where?: InputMaybe<ParkingSessionsExitPerDayViewModelFilterInput>;
};


export type QueryParkingSessionsInsideOnContractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  facilityId?: InputMaybe<Scalars['Ulid']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ParkingSessionsInsideOnContractsViewModelSortInput>>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
  where?: InputMaybe<ParkingSessionsInsideOnContractsViewModelFilterInput>;
};


export type QueryParkingSessionsInsideOnReservationsArgs = {
  facilityId?: InputMaybe<Scalars['Ulid']['input']>;
  order?: InputMaybe<Array<ParkingSessionsInsideOnReservationsViewModelSortInput>>;
  where?: InputMaybe<ParkingSessionsInsideOnReservationsViewModelFilterInput>;
};


export type QueryParkingSessionsOnContractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  facilityId?: InputMaybe<Scalars['Ulid']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ParkingSessionsOnContractsViewModelSortInput>>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
  where?: InputMaybe<ParkingSessionsOnContractsViewModelFilterInput>;
};


export type QueryParkingSessionsPerStatusArgs = {
  facilityId?: InputMaybe<Scalars['Ulid']['input']>;
  order?: InputMaybe<Array<ParkingSessionsPerStatusViewModelSortInput>>;
  where?: InputMaybe<ParkingSessionsPerStatusViewModelFilterInput>;
};


export type QueryPrepaidCardArgs = {
  prepaidCardId: Scalars['Ulid']['input'];
};


export type QueryPrepaidCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PrepaidCardViewModelSortInput>>;
  where?: InputMaybe<PrepaidCardViewModelFilterInput>;
};


export type QueryPrepaidCardsByCustomerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['Ulid']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PrepaidCardViewModelSortInput>>;
  where?: InputMaybe<PrepaidCardViewModelFilterInput>;
};


export type QueryPricingPoliciesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PricingPolicyViewModelSortInput>>;
  where?: InputMaybe<PricingPolicyViewModelFilterInput>;
};


export type QueryPricingPolicyArgs = {
  pricingPolicyId: Scalars['Ulid']['input'];
};


export type QueryReportDefinitionArgs = {
  reportKey: Scalars['String']['input'];
};


export type QueryReservationArgs = {
  reservationId: Scalars['Ulid']['input'];
};


export type QueryReservationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ReservationViewModelSortInput>>;
  where?: InputMaybe<ReservationViewModelFilterInput>;
};


export type QueryScenarioArgs = {
  id: Scalars['Ulid']['input'];
};


export type QueryScenariosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ScenarioViewModelSortInput>>;
  where?: InputMaybe<ScenarioViewModelFilterInput>;
};


export type QueryTariffArgs = {
  tariffId: Scalars['Ulid']['input'];
};


export type QueryTariffsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TariffViewModelSortInput>>;
  where?: InputMaybe<TariffViewModelFilterInput>;
};


export type QueryTerminalArgs = {
  terminalId: Scalars['Ulid']['input'];
};


export type QueryTerminalsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TerminalViewModelSortInput>>;
  where?: InputMaybe<TerminalViewModelFilterInput>;
};


export type QueryUnreadAlertsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AlertViewModelSortInput>>;
  userId: Scalars['Ulid']['input'];
  where?: InputMaybe<AlertViewModelFilterInput>;
};


export type QueryUserArgs = {
  id: Scalars['Ulid']['input'];
};


export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<UserViewModelSortInput>>;
  where?: InputMaybe<UserViewModelFilterInput>;
};


export type QueryVehicleArgs = {
  vehicleId: Scalars['Ulid']['input'];
};


export type QueryVehicleJourneyLogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<VehicleJourneyLogViewModelSortInput>>;
  where?: InputMaybe<VehicleJourneyLogViewModelFilterInput>;
};


export type QueryVehiclesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<VehicleViewModelSortInput>>;
  where?: InputMaybe<VehicleViewModelFilterInput>;
};


export type QueryVoucherArgs = {
  voucherId: Scalars['Ulid']['input'];
};


export type QueryVoucherByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryVouchersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<VoucherViewModelSortInput>>;
  where?: InputMaybe<VoucherViewModelFilterInput>;
};

export type RateStepViewModel = {
  __typename?: 'RateStepViewModel';
  intervalCharge: Scalars['PositiveOrZeroDecimal']['output'];
  intervalMinutes: Scalars['PositiveInt']['output'];
  maxIntervals?: Maybe<Scalars['PositiveInt']['output']>;
  rate: RateViewModel;
  rateId: Scalars['Ulid']['output'];
  rateStepId: Scalars['Ulid']['output'];
  stepSequence: Scalars['PositiveInt']['output'];
};

export enum RateTypeEnum {
  FlatRate = 'FLAT_RATE',
  Tiered = 'TIERED'
}

export type RateTypeViewModel = {
  __typename?: 'RateTypeViewModel';
  name: Scalars['String50']['output'];
  rateTypeId: Scalars['PositiveInt']['output'];
  rates: Array<RateViewModel>;
};

export type RateViewModel = {
  __typename?: 'RateViewModel';
  facility: FacilityViewModel;
  facilityId: Scalars['Ulid']['output'];
  flatRateAmount?: Maybe<Scalars['PositiveDecimal']['output']>;
  rateId: Scalars['Ulid']['output'];
  rateSteps: Array<RateStepViewModel>;
  rateTypeEnum: RateTypeEnum;
  tariffId: Scalars['Ulid']['output'];
};

export type RateViewModelSortInput = {
  facility?: InputMaybe<FacilityViewModelSortInput>;
  facilityId?: InputMaybe<SortEnumType>;
  flatRateAmount?: InputMaybe<SortEnumType>;
  rateId?: InputMaybe<SortEnumType>;
  rateTypeEnum?: InputMaybe<SortEnumType>;
  tariffId?: InputMaybe<SortEnumType>;
};

export type RefreshPayload = {
  __typename?: 'RefreshPayload';
  error?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ReportColumnViewModel = {
  __typename?: 'ReportColumnViewModel';
  aggregationType?: Maybe<ColumnAggregationType>;
  alignment: ColumnAlignment;
  conditionalFormatJson?: Maybe<Scalars['String']['output']>;
  dataType: Scalars['String']['output'];
  filterable: Scalars['Boolean']['output'];
  format?: Maybe<Scalars['String']['output']>;
  graphQlFieldPath: Scalars['String']['output'];
  groupable: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  reportColumnId: Scalars['Ulid']['output'];
  sortOrder: Scalars['Int']['output'];
  sortable: Scalars['Boolean']['output'];
  visibleByDefault: Scalars['Boolean']['output'];
  width?: Maybe<Scalars['String']['output']>;
};

export type ReportDefinitionViewModel = {
  __typename?: 'ReportDefinitionViewModel';
  columns: Array<ReportColumnViewModel>;
  defaultSorts: Array<ReportSortViewModel>;
  description: Scalars['String']['output'];
  exportFormats: Array<Scalars['String']['output']>;
  filters: Array<ReportFilterViewModel>;
  graphQlQuery?: Maybe<Scalars['String']['output']>;
  graphQlVariablesJson?: Maybe<Scalars['String']['output']>;
  groupings: Array<ReportGroupingViewModel>;
  isAvailableToAllFacilities: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  reportDefinitionId: Scalars['Ulid']['output'];
  reportGroupId: Scalars['Ulid']['output'];
  requiredPermission?: Maybe<Scalars['String']['output']>;
  resultArrayPath: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type ReportFilterOptionViewModel = {
  __typename?: 'ReportFilterOptionViewModel';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ReportFilterViewModel = {
  __typename?: 'ReportFilterViewModel';
  defaultValue?: Maybe<Scalars['String']['output']>;
  dependsOnFilterKey?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  operators: Array<Scalars['String']['output']>;
  options: Array<ReportFilterOptionViewModel>;
  optionsSourceJson?: Maybe<Scalars['String']['output']>;
  reportFilterId: Scalars['Ulid']['output'];
  required: Scalars['Boolean']['output'];
  sortOrder: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type ReportGroupViewModel = {
  __typename?: 'ReportGroupViewModel';
  icon?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  reportGroupId: Scalars['Ulid']['output'];
  reports: Array<ReportDefinitionViewModel>;
  sortOrder: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type ReportGroupingViewModel = {
  __typename?: 'ReportGroupingViewModel';
  columnKeys: Array<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  reportGroupingId: Scalars['Ulid']['output'];
  sortOrder: Scalars['Int']['output'];
};

export type ReportSortViewModel = {
  __typename?: 'ReportSortViewModel';
  columnKey: Scalars['String']['output'];
  direction: Scalars['String']['output'];
  reportSortId: Scalars['Ulid']['output'];
  sortOrder: Scalars['Int']['output'];
};

export type ReservationStatusViewModel = {
  __typename?: 'ReservationStatusViewModel';
  name?: Maybe<Scalars['String255']['output']>;
  reservationStatusId?: Maybe<Scalars['PositiveInt']['output']>;
  reservations: Array<ReservationViewModel>;
};

export type ReservationStatusViewModelSortInput = {
  name?: InputMaybe<SortEnumType>;
  reservationStatusId?: InputMaybe<SortEnumType>;
};

export type ReservationViewModel = {
  __typename?: 'ReservationViewModel';
  createdAt: Scalars['DateTime']['output'];
  customer: CustomerViewModel;
  customerId: Scalars['Ulid']['output'];
  facility: FacilityViewModel;
  facilityId: Scalars['Ulid']['output'];
  parkingSession: ParkingSessionViewModel;
  parkingSessionId: Scalars['Ulid']['output'];
  reservationEndTime: Scalars['DateTime']['output'];
  reservationId: Scalars['Ulid']['output'];
  reservationStartTime: Scalars['DateTime']['output'];
  reservationStatus: ReservationStatusViewModel;
  reservationStatusId?: Maybe<Scalars['PositiveInt']['output']>;
  vehicle: VehicleViewModel;
  vehicleId: Scalars['Ulid']['output'];
};

export type ReservationViewModelFilterInput = {
  and?: InputMaybe<Array<ReservationViewModelFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  customerId?: InputMaybe<UlidExtendedFilterInput>;
  facilityId?: InputMaybe<UlidExtendedFilterInput>;
  or?: InputMaybe<Array<ReservationViewModelFilterInput>>;
  parkingSessionId?: InputMaybe<UlidExtendedFilterInput>;
  reservationEndTime?: InputMaybe<DateTimeOperationFilterInput>;
  reservationId?: InputMaybe<UlidExtendedFilterInput>;
  reservationStartTime?: InputMaybe<DateTimeOperationFilterInput>;
  reservationStatusId?: InputMaybe<IntOperationFilterInput>;
  vehicleId?: InputMaybe<UlidExtendedFilterInput>;
};

export type ReservationViewModelSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  customer?: InputMaybe<CustomerViewModelSortInput>;
  customerId?: InputMaybe<SortEnumType>;
  facility?: InputMaybe<FacilityViewModelSortInput>;
  facilityId?: InputMaybe<SortEnumType>;
  parkingSession?: InputMaybe<ParkingSessionViewModelSortInput>;
  parkingSessionId?: InputMaybe<SortEnumType>;
  reservationEndTime?: InputMaybe<SortEnumType>;
  reservationId?: InputMaybe<SortEnumType>;
  reservationStartTime?: InputMaybe<SortEnumType>;
  reservationStatus?: InputMaybe<ReservationStatusViewModelSortInput>;
  reservationStatusId?: InputMaybe<SortEnumType>;
  vehicle?: InputMaybe<VehicleViewModelSortInput>;
  vehicleId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ReservationsConnection = {
  __typename?: 'ReservationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ReservationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ReservationViewModel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ReservationsEdge = {
  __typename?: 'ReservationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ReservationViewModel;
};

export type RolePermissionViewModel = {
  __typename?: 'RolePermissionViewModel';
  permission: PermissionViewModel;
  permissionId?: Maybe<Scalars['PositiveInt']['output']>;
  role: RoleViewModel;
  roleId?: Maybe<Scalars['PositiveInt']['output']>;
};

export type RoleViewModel = {
  __typename?: 'RoleViewModel';
  description?: Maybe<Scalars['String1000']['output']>;
  name?: Maybe<Scalars['String255']['output']>;
  roleId?: Maybe<Scalars['PositiveInt']['output']>;
  rolePermissions: Array<RolePermissionViewModel>;
  userRoles: Array<UserRoleViewModel>;
};

export type ScenarioConditionViewModel = {
  __typename?: 'ScenarioConditionViewModel';
  condition: ConditionViewModel;
  conditionId: Scalars['Ulid']['output'];
  operator: ConditionOperator;
  scenario: ScenarioViewModel;
  scenarioId: Scalars['Ulid']['output'];
};

export type ScenarioViewModel = {
  __typename?: 'ScenarioViewModel';
  facility: FacilityViewModel;
  facilityId: Scalars['Ulid']['output'];
  limitPolicies: Array<LimitPolicyViewModel>;
  name: Scalars['String255']['output'];
  pricingPolicies: Array<PricingPolicyViewModel>;
  scenarioConditions: Array<ScenarioConditionViewModel>;
  scenarioId: Scalars['Ulid']['output'];
};

export type ScenarioViewModelFilterInput = {
  and?: InputMaybe<Array<ScenarioViewModelFilterInput>>;
  facilityId?: InputMaybe<UlidExtendedFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ScenarioViewModelFilterInput>>;
  scenarioId?: InputMaybe<UlidExtendedFilterInput>;
};

export type ScenarioViewModelSortInput = {
  facility?: InputMaybe<FacilityViewModelSortInput>;
  facilityId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  scenarioId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ScenariosConnection = {
  __typename?: 'ScenariosConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ScenariosEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ScenarioViewModel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ScenariosEdge = {
  __typename?: 'ScenariosEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ScenarioViewModel;
};

export type ServiceViewModel = {
  __typename?: 'ServiceViewModel';
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  code?: Maybe<Scalars['String50']['output']>;
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String255']['output']>;
  facility: FacilityViewModel;
  facilityId: Scalars['Ulid']['output'];
  freeParkingMinutes?: Maybe<Scalars['PositiveOrZeroInt']['output']>;
  isActive: Scalars['Boolean']['output'];
  parkingSessionServices: Array<ParkingSessionServiceViewModel>;
  price?: Maybe<Scalars['PositiveDecimal']['output']>;
  serviceId: Scalars['Ulid']['output'];
};

export type SetMainTariffInput = {
  tariffId: Scalars['Ulid']['input'];
};

export enum SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ncontains?: InputMaybe<Scalars['String']['input']>;
  nendsWith?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nstartsWith?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  onAlertCreated: AlertCreatedPayload;
  onParkingSessionCreated: ParkingSessionCreatedPayload;
};

export type TariffViewModel = {
  __typename?: 'TariffViewModel';
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdByUser: UserViewModel;
  createdByUserId: Scalars['Ulid']['output'];
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  derivedTariffs: Array<TariffViewModel>;
  description?: Maybe<Scalars['String1000']['output']>;
  entryGracePeriodMinutes: Scalars['PositiveOrZeroInt']['output'];
  facility: FacilityViewModel;
  facilityId: Scalars['Ulid']['output'];
  freeExitMinutes: Scalars['PositiveOrZeroInt']['output'];
  limitPolicies: Array<LimitPolicyViewModel>;
  limits: Array<LimitViewModel>;
  lostTicketFixedCharge?: Maybe<Scalars['PositiveOrZeroDecimal']['output']>;
  lostTicketRate?: Maybe<RateViewModel>;
  lostTicketRateId?: Maybe<Scalars['Ulid']['output']>;
  mainInFacility?: Maybe<FacilityViewModel>;
  name: Scalars['String255']['output'];
  needsVerification: Scalars['Boolean']['output'];
  postPaymentGraceMinutes: Scalars['PositiveOrZeroInt']['output'];
  pricingPolicies: Array<PricingPolicyViewModel>;
  rates: Array<RateViewModel>;
  reEntryChargeRate?: Maybe<RateViewModel>;
  reEntryChargeRateId?: Maybe<Scalars['Ulid']['output']>;
  sourceTariff?: Maybe<TariffViewModel>;
  sourceTariffId?: Maybe<Scalars['Ulid']['output']>;
  status: Scalars['Byte']['output'];
  tariffId: Scalars['Ulid']['output'];
  updatedAt: Scalars['DateTime']['output'];
  verificationFlaggedAt?: Maybe<Scalars['DateTime']['output']>;
  verificationReason?: Maybe<Scalars['String500']['output']>;
  version?: Maybe<Scalars['String50']['output']>;
};

export type TariffViewModelFilterInput = {
  activatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  and?: InputMaybe<Array<TariffViewModelFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  createdByUserId?: InputMaybe<UlidExtendedFilterInput>;
  deactivatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  entryGracePeriodMinutes?: InputMaybe<IntOperationFilterInput>;
  facilityId?: InputMaybe<UlidExtendedFilterInput>;
  freeExitMinutes?: InputMaybe<IntOperationFilterInput>;
  lostTicketFixedCharge?: InputMaybe<DecimalOperationFilterInput>;
  lostTicketRateId?: InputMaybe<UlidExtendedFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  needsVerification?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<TariffViewModelFilterInput>>;
  postPaymentGraceMinutes?: InputMaybe<IntOperationFilterInput>;
  reEntryChargeRateId?: InputMaybe<UlidExtendedFilterInput>;
  sourceTariffId?: InputMaybe<UlidExtendedFilterInput>;
  status?: InputMaybe<ByteOperationFilterInput>;
  tariffId?: InputMaybe<UlidExtendedFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  verificationFlaggedAt?: InputMaybe<DateTimeOperationFilterInput>;
  verificationReason?: InputMaybe<StringOperationFilterInput>;
  version?: InputMaybe<StringOperationFilterInput>;
};

export type TariffViewModelSortInput = {
  activatedAt?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  createdByUser?: InputMaybe<UserViewModelSortInput>;
  createdByUserId?: InputMaybe<SortEnumType>;
  deactivatedAt?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  entryGracePeriodMinutes?: InputMaybe<SortEnumType>;
  facility?: InputMaybe<FacilityViewModelSortInput>;
  facilityId?: InputMaybe<SortEnumType>;
  freeExitMinutes?: InputMaybe<SortEnumType>;
  lostTicketFixedCharge?: InputMaybe<SortEnumType>;
  lostTicketRate?: InputMaybe<RateViewModelSortInput>;
  lostTicketRateId?: InputMaybe<SortEnumType>;
  mainInFacility?: InputMaybe<FacilityViewModelSortInput>;
  name?: InputMaybe<SortEnumType>;
  needsVerification?: InputMaybe<SortEnumType>;
  postPaymentGraceMinutes?: InputMaybe<SortEnumType>;
  reEntryChargeRate?: InputMaybe<RateViewModelSortInput>;
  reEntryChargeRateId?: InputMaybe<SortEnumType>;
  sourceTariff?: InputMaybe<TariffViewModelSortInput>;
  sourceTariffId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tariffId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  verificationFlaggedAt?: InputMaybe<SortEnumType>;
  verificationReason?: InputMaybe<SortEnumType>;
  version?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type TariffsConnection = {
  __typename?: 'TariffsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<TariffsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<TariffViewModel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TariffsEdge = {
  __typename?: 'TariffsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TariffViewModel;
};

export type TerminalTypeViewModel = {
  __typename?: 'TerminalTypeViewModel';
  name?: Maybe<Scalars['String255']['output']>;
  terminalTypeId?: Maybe<Scalars['PositiveInt']['output']>;
  terminals: Array<TerminalViewModel>;
};

export type TerminalTypeViewModelSortInput = {
  name?: InputMaybe<SortEnumType>;
  terminalTypeId?: InputMaybe<SortEnumType>;
};

export type TerminalViewModel = {
  __typename?: 'TerminalViewModel';
  facility: FacilityViewModel;
  facilityId: Scalars['Ulid']['output'];
  gateKey?: Maybe<Scalars['String255']['output']>;
  ipAddress?: Maybe<Scalars['String45']['output']>;
  isActive: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String255']['output']>;
  terminalId: Scalars['Ulid']['output'];
  terminalType: TerminalTypeViewModel;
  terminalTypeId?: Maybe<Scalars['PositiveInt']['output']>;
  vehicleJourneyLogs: Array<VehicleJourneyLogViewModel>;
};

export type TerminalViewModelFilterInput = {
  and?: InputMaybe<Array<TerminalViewModelFilterInput>>;
  facilityId?: InputMaybe<UlidExtendedFilterInput>;
  gateKey?: InputMaybe<StringOperationFilterInput>;
  ipAddress?: InputMaybe<StringOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TerminalViewModelFilterInput>>;
  terminalId?: InputMaybe<UlidExtendedFilterInput>;
  terminalTypeId?: InputMaybe<IntOperationFilterInput>;
};

export type TerminalViewModelSortInput = {
  facility?: InputMaybe<FacilityViewModelSortInput>;
  facilityId?: InputMaybe<SortEnumType>;
  gateKey?: InputMaybe<SortEnumType>;
  ipAddress?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  terminalId?: InputMaybe<SortEnumType>;
  terminalType?: InputMaybe<TerminalTypeViewModelSortInput>;
  terminalTypeId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type TerminalsConnection = {
  __typename?: 'TerminalsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<TerminalsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<TerminalViewModel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TerminalsEdge = {
  __typename?: 'TerminalsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TerminalViewModel;
};

export type TransactionTypeViewModel = {
  __typename?: 'TransactionTypeViewModel';
  name: Scalars['String255']['output'];
  prepaidCardTransactions: Array<PrepaidCardTransactionViewModel>;
  transactionTypeId: Scalars['PositiveInt']['output'];
};

export type UlidExtendedFilterInput = {
  eq?: InputMaybe<Scalars['Ulid']['input']>;
  gt?: InputMaybe<Scalars['Ulid']['input']>;
  gte?: InputMaybe<Scalars['Ulid']['input']>;
  in?: InputMaybe<Array<Scalars['Ulid']['input']>>;
  lt?: InputMaybe<Scalars['Ulid']['input']>;
  lte?: InputMaybe<Scalars['Ulid']['input']>;
  neq?: InputMaybe<Scalars['Ulid']['input']>;
  ngt?: InputMaybe<Scalars['Ulid']['input']>;
  ngte?: InputMaybe<Scalars['Ulid']['input']>;
  nin?: InputMaybe<Array<Scalars['Ulid']['input']>>;
  nlt?: InputMaybe<Scalars['Ulid']['input']>;
  nlte?: InputMaybe<Scalars['Ulid']['input']>;
};

/** A connection to a list of items. */
export type UnreadAlertsConnection = {
  __typename?: 'UnreadAlertsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<UnreadAlertsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AlertViewModel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UnreadAlertsEdge = {
  __typename?: 'UnreadAlertsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AlertViewModel;
};

export type UpdateCampaignInput = {
  campaignId: Scalars['Ulid']['input'];
  description?: InputMaybe<Scalars['String1000']['input']>;
  endDate: Scalars['DateTime']['input'];
  isActive: Scalars['Boolean']['input'];
  name?: InputMaybe<Scalars['String255']['input']>;
  startDate: Scalars['DateTime']['input'];
};

export type UpdateConditionInput = {
  appliesOnHolidays: Scalars['Boolean']['input'];
  appliesToSpecificCustomerCategories: Scalars['Boolean']['input'];
  appliesToSpecificVehicleTypes: Scalars['Boolean']['input'];
  arrivingSince?: InputMaybe<Scalars['LocalTime']['input']>;
  arrivingUntil?: InputMaybe<Scalars['LocalTime']['input']>;
  conditionCustomerCategories: Array<Scalars['Ulid']['input']>;
  conditionDayOfWeeks: Array<Scalars['PositiveInt']['input']>;
  conditionVehicleTypes: Array<Scalars['PositiveInt']['input']>;
  description: Scalars['String255']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  isContractOverstay: Scalars['Boolean']['input'];
  isOverstay: Scalars['Boolean']['input'];
  leavingSince?: InputMaybe<Scalars['LocalTime']['input']>;
  leavingUntil?: InputMaybe<Scalars['LocalTime']['input']>;
  maxStayMinutes?: InputMaybe<Scalars['PositiveOrZeroInt']['input']>;
  minStayMinutes?: InputMaybe<Scalars['PositiveOrZeroInt']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  weeklyDateSetId: Scalars['PositiveInt']['input'];
};

export type UpdateContractInput = {
  amount: Scalars['PositiveDecimal']['input'];
  beginDate: Scalars['DateTime']['input'];
  cards: Array<ContractCardInput>;
  contractId: Scalars['Ulid']['input'];
  contractNumber: Scalars['String50']['input'];
  customerId: Scalars['Ulid']['input'];
  endDate: Scalars['DateTime']['input'];
  includeAllCustomerVehicles: Scalars['Boolean']['input'];
  isActive: Scalars['Boolean']['input'];
  isAutoRenewed: Scalars['Boolean']['input'];
  preferredLanguage?: InputMaybe<Scalars['String10']['input']>;
  reservedParkingSlots: Scalars['PositiveOrZeroInt']['input'];
  simultaneousVehicleLimit?: InputMaybe<Scalars['PositiveOrZeroInt']['input']>;
  vehicleIds: Array<Scalars['Ulid']['input']>;
  vipVehicleIds: Array<Scalars['Ulid']['input']>;
};

export type UpdateCustomerAddressInput = {
  addressId: Scalars['Ulid']['input'];
  addressTypeId: Scalars['Int']['input'];
  city?: InputMaybe<Scalars['String255']['input']>;
  country?: InputMaybe<Scalars['String255']['input']>;
  customerAddressId: Scalars['Ulid']['input'];
  postalCode?: InputMaybe<Scalars['String50']['input']>;
  state?: InputMaybe<Scalars['String255']['input']>;
  streetAddress?: InputMaybe<Scalars['String500']['input']>;
};

export type UpdateCustomerBankDetailsInput = {
  accountHolderName?: InputMaybe<Scalars['String255']['input']>;
  accountNumber?: InputMaybe<Scalars['String50']['input']>;
  accountType?: InputMaybe<Scalars['String100']['input']>;
  bankCode?: InputMaybe<Scalars['String50']['input']>;
  bankDetailsId: Scalars['Ulid']['input'];
  bankName?: InputMaybe<Scalars['String255']['input']>;
  branchCode?: InputMaybe<Scalars['String50']['input']>;
  branchName?: InputMaybe<Scalars['String255']['input']>;
  currency?: InputMaybe<Scalars['String10']['input']>;
  iban?: InputMaybe<Scalars['String50']['input']>;
  isPrimary: Scalars['Boolean']['input'];
  notes?: InputMaybe<Scalars['String1000']['input']>;
  purpose?: InputMaybe<Scalars['String255']['input']>;
};

export type UpdateCustomerBeneficiaryInput = {
  beneficiaryCustomerId: Scalars['Ulid']['input'];
  customerBeneficiaryId: Scalars['Ulid']['input'];
  isActive: Scalars['Boolean']['input'];
  notes?: InputMaybe<Scalars['String1000']['input']>;
  relationshipType?: InputMaybe<Scalars['String255']['input']>;
};

export type UpdateCustomerContactInput = {
  contactTypeId: Scalars['Int']['input'];
  contactValue?: InputMaybe<Scalars['String255']['input']>;
  customerContactId: Scalars['Ulid']['input'];
  isPrimary: Scalars['Boolean']['input'];
  notes?: InputMaybe<Scalars['String1000']['input']>;
};

export type UpdateCustomerInput = {
  addresses: Array<UpdateCustomerAddressInput>;
  bankDetails: Array<UpdateCustomerBankDetailsInput>;
  beneficiaries: Array<UpdateCustomerBeneficiaryInput>;
  billingCountryCode?: InputMaybe<Scalars['String10']['input']>;
  billingLegalName?: InputMaybe<Scalars['String255']['input']>;
  billingTradeName?: InputMaybe<Scalars['String255']['input']>;
  companyRegistrationNumber?: InputMaybe<Scalars['String100']['input']>;
  companySize?: InputMaybe<Scalars['String50']['input']>;
  contacts: Array<UpdateCustomerContactInput>;
  customerCategoryId: Scalars['Ulid']['input'];
  customerId: Scalars['Ulid']['input'];
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String255']['input']>;
  firmName?: InputMaybe<Scalars['String255']['input']>;
  firstName?: InputMaybe<Scalars['String100']['input']>;
  fiscalNumber?: InputMaybe<Scalars['String50']['input']>;
  gender?: InputMaybe<Scalars['String50']['input']>;
  idNumber?: InputMaybe<Scalars['String100']['input']>;
  idType?: InputMaybe<Scalars['String50']['input']>;
  industry?: InputMaybe<Scalars['String100']['input']>;
  isActive: Scalars['Boolean']['input'];
  lastName?: InputMaybe<Scalars['String100']['input']>;
  marketingOptIn: Scalars['Boolean']['input'];
  nationality?: InputMaybe<Scalars['String100']['input']>;
  notes?: InputMaybe<Scalars['String1000']['input']>;
  preferredLanguage?: InputMaybe<Scalars['String10']['input']>;
  taxOffice?: InputMaybe<Scalars['String255']['input']>;
  vehicles: Array<UpdateCustomerVehicleInput>;
};

export type UpdateCustomerVehicleInput = {
  color?: InputMaybe<Scalars['String100']['input']>;
  isActive: Scalars['Boolean']['input'];
  make?: InputMaybe<Scalars['String255']['input']>;
  model?: InputMaybe<Scalars['String255']['input']>;
  plateNumber?: InputMaybe<Scalars['String50']['input']>;
  vehicleId: Scalars['Ulid']['input'];
  vehicleTypeId?: InputMaybe<Scalars['PositiveInt']['input']>;
};

export type UpdateLimitPolicyInput = {
  billingCycleId: Scalars['PositiveInt']['input'];
  isActive: Scalars['Boolean']['input'];
  limit: UpdateLimitPolicyLimitInput;
  limitPolicyId: Scalars['Ulid']['input'];
  name: Scalars['String255']['input'];
  priority: Scalars['PositiveInt']['input'];
  scenarioId?: InputMaybe<Scalars['Ulid']['input']>;
  tariffId: Scalars['Ulid']['input'];
};

export type UpdateLimitPolicyLimitInput = {
  limitId: Scalars['Ulid']['input'];
  maxAmount?: InputMaybe<Scalars['PositiveOrZeroDecimal']['input']>;
  maxStayMinutes?: InputMaybe<Scalars['PositiveOrZeroInt']['input']>;
  minAmount?: InputMaybe<Scalars['PositiveOrZeroDecimal']['input']>;
  minStayMinutes?: InputMaybe<Scalars['PositiveOrZeroInt']['input']>;
};

export type UpdatePricingPolicyInput = {
  billingCycleId: Scalars['PositiveInt']['input'];
  isActive: Scalars['Boolean']['input'];
  limit?: InputMaybe<UpdatePricingPolicyLimitInput>;
  name: Scalars['String255']['input'];
  overstayRate?: InputMaybe<UpdatePricingPolicyRateInput>;
  pricingPolicyId: Scalars['Ulid']['input'];
  priority: Scalars['PositiveInt']['input'];
  rate: UpdatePricingPolicyRateInput;
  scenarioId?: InputMaybe<Scalars['Ulid']['input']>;
  tariffId: Scalars['Ulid']['input'];
};

export type UpdatePricingPolicyLimitInput = {
  limitId: Scalars['Ulid']['input'];
  maxAmount?: InputMaybe<Scalars['PositiveOrZeroDecimal']['input']>;
  maxStayMinutes?: InputMaybe<Scalars['PositiveOrZeroInt']['input']>;
  minAmount?: InputMaybe<Scalars['PositiveOrZeroDecimal']['input']>;
  minStayMinutes?: InputMaybe<Scalars['PositiveOrZeroInt']['input']>;
};

export type UpdatePricingPolicyRateInput = {
  flatRateAmount?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  rateId: Scalars['Ulid']['input'];
  rateSteps: Array<UpdatePricingPolicyRateStepInput>;
  rateTypeEnum: RateTypeEnum;
};

export type UpdatePricingPolicyRateStepInput = {
  intervalCharge: Scalars['PositiveOrZeroDecimal']['input'];
  intervalMinutes: Scalars['PositiveInt']['input'];
  maxIntervals?: InputMaybe<Scalars['PositiveInt']['input']>;
  rateStepId: Scalars['Ulid']['input'];
  stepSequence: Scalars['PositiveInt']['input'];
};

export type UpdateScenarioConditionInput = {
  condition: UpdateConditionInput;
  conditionId: Scalars['Ulid']['input'];
  operator: ConditionOperator;
};

export type UpdateScenarioInput = {
  name: Scalars['String255']['input'];
  scenarioConditions: Array<UpdateScenarioConditionInput>;
  scenarioId: Scalars['Ulid']['input'];
};

export type UpdateTariffInput = {
  description?: InputMaybe<Scalars['String1000']['input']>;
  entryGracePeriodMinutes: Scalars['PositiveOrZeroInt']['input'];
  freeExitMinutes: Scalars['PositiveOrZeroInt']['input'];
  lostTicketFixedCharge?: InputMaybe<Scalars['PositiveOrZeroDecimal']['input']>;
  lostTicketRateId?: InputMaybe<Scalars['Ulid']['input']>;
  name: Scalars['String255']['input'];
  postPaymentGraceMinutes: Scalars['PositiveOrZeroInt']['input'];
  reEntryChargeRateId?: InputMaybe<Scalars['Ulid']['input']>;
  status: Scalars['Byte']['input'];
  tariffId: Scalars['Ulid']['input'];
  version?: InputMaybe<Scalars['String50']['input']>;
};

export type UpdateTerminalInput = {
  gateKey?: InputMaybe<Scalars['String255']['input']>;
  ipAddress: Scalars['String45']['input'];
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String255']['input'];
  terminalId: Scalars['Ulid']['input'];
  terminalTypeId: Scalars['PositiveInt']['input'];
};

export type UpdateVehicleInput = {
  color?: InputMaybe<Scalars['String100']['input']>;
  customerId?: InputMaybe<Scalars['Ulid']['input']>;
  isActive: Scalars['Boolean']['input'];
  make?: InputMaybe<Scalars['String255']['input']>;
  model?: InputMaybe<Scalars['String255']['input']>;
  plateNumber?: InputMaybe<Scalars['String50']['input']>;
  vehicleId: Scalars['Ulid']['input'];
  vehicleTypeId?: InputMaybe<Scalars['PositiveInt']['input']>;
};

export type UpdateVoucherInput = {
  campaignId?: InputMaybe<Scalars['Ulid']['input']>;
  code: Scalars['String255']['input'];
  customerId?: InputMaybe<Scalars['Ulid']['input']>;
  discountValue?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  freeTimeMinutes?: InputMaybe<Scalars['PositiveInt']['input']>;
  isActive: Scalars['Boolean']['input'];
  isAdHoc: Scalars['Boolean']['input'];
  isCustomerSpecific: Scalars['Boolean']['input'];
  maxDiscountAmount?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  name?: InputMaybe<Scalars['String255']['input']>;
  rateBindingRequired: Scalars['Boolean']['input'];
  rateId?: InputMaybe<Scalars['Ulid']['input']>;
  usageLimit?: InputMaybe<Scalars['PositiveInt']['input']>;
  validUntilDate: Scalars['DateTime']['input'];
  voucherDiscountTypeEnum: VoucherDiscountTypeEnum;
  voucherId: Scalars['Ulid']['input'];
};

export type UserFacility = {
  __typename?: 'UserFacility';
  facilityId: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type UserFacilitySummaryViewModel = {
  __typename?: 'UserFacilitySummaryViewModel';
  facilityId: Scalars['Ulid']['output'];
  name?: Maybe<Scalars['String255']['output']>;
};

export type UserInfo = {
  __typename?: 'UserInfo';
  email?: Maybe<Scalars['String']['output']>;
  facilities: Array<UserFacility>;
  roles: Array<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type UserPreferenceViewModel = {
  __typename?: 'UserPreferenceViewModel';
  settingsJson: Scalars['String']['output'];
  user: UserViewModel;
  userId: Scalars['Ulid']['output'];
  userPreferenceId: Scalars['Ulid']['output'];
};

export type UserRoleViewModel = {
  __typename?: 'UserRoleViewModel';
  role: RoleViewModel;
  roleId?: Maybe<Scalars['PositiveInt']['output']>;
  user: UserViewModel;
  userId: Scalars['Ulid']['output'];
};

export type UserViewModel = {
  __typename?: 'UserViewModel';
  auditLogs: Array<LogViewModel>;
  cashierShifts: Array<CashierShiftViewModel>;
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String255']['output']>;
  facilities: Array<UserFacilitySummaryViewModel>;
  firstName?: Maybe<Scalars['String255']['output']>;
  isActive: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String255']['output']>;
  passwordHash?: Maybe<Scalars['String255']['output']>;
  userId: Scalars['Ulid']['output'];
  userPreferences: Array<UserPreferenceViewModel>;
  userRoles: Array<UserRoleViewModel>;
  username?: Maybe<Scalars['String255']['output']>;
};

export type UserViewModelFilterInput = {
  and?: InputMaybe<Array<UserViewModelFilterInput>>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<UserViewModelFilterInput>>;
  passwordHash?: InputMaybe<StringOperationFilterInput>;
  userId?: InputMaybe<UlidExtendedFilterInput>;
  username?: InputMaybe<StringOperationFilterInput>;
};

export type UserViewModelSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  passwordHash?: InputMaybe<SortEnumType>;
  userId?: InputMaybe<SortEnumType>;
  username?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type UsersConnection = {
  __typename?: 'UsersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<UsersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<UserViewModel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UsersEdge = {
  __typename?: 'UsersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: UserViewModel;
};

export type VehicleJourneyEventTypeViewModel = {
  __typename?: 'VehicleJourneyEventTypeViewModel';
  description?: Maybe<Scalars['String255']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String50']['output']>;
  vehicleJourneyEventTypeId?: Maybe<Scalars['PositiveInt']['output']>;
  vehicleJourneyLogs: Array<VehicleJourneyLogViewModel>;
};

export type VehicleJourneyEventTypeViewModelSortInput = {
  description?: InputMaybe<SortEnumType>;
  isEnabled?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  vehicleJourneyEventTypeId?: InputMaybe<SortEnumType>;
};

export type VehicleJourneyLogViewModel = {
  __typename?: 'VehicleJourneyLogViewModel';
  additionalData?: Maybe<Scalars['String']['output']>;
  cashierShift: CashierShiftViewModel;
  cashierShiftId: Scalars['Ulid']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  eventTime: Scalars['DateTime']['output'];
  externalEventId: Scalars['String']['output'];
  parkingSession: ParkingSessionViewModel;
  parkingSessionId: Scalars['Ulid']['output'];
  terminal?: Maybe<TerminalViewModel>;
  terminalId?: Maybe<Scalars['Ulid']['output']>;
  user?: Maybe<UserViewModel>;
  userId?: Maybe<Scalars['Ulid']['output']>;
  vehicleJourneyEventType: VehicleJourneyEventTypeViewModel;
  vehicleJourneyEventTypeId?: Maybe<Scalars['PositiveInt']['output']>;
  vehicleJourneyLogId: Scalars['Ulid']['output'];
};

export type VehicleJourneyLogViewModelFilterInput = {
  additionalData?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<VehicleJourneyLogViewModelFilterInput>>;
  cashierShiftId?: InputMaybe<UlidExtendedFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  eventTime?: InputMaybe<DateTimeOperationFilterInput>;
  externalEventId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<VehicleJourneyLogViewModelFilterInput>>;
  parkingSessionId?: InputMaybe<UlidExtendedFilterInput>;
  terminalId?: InputMaybe<UlidExtendedFilterInput>;
  userId?: InputMaybe<UlidExtendedFilterInput>;
  vehicleJourneyEventTypeId?: InputMaybe<IntOperationFilterInput>;
  vehicleJourneyLogId?: InputMaybe<UlidExtendedFilterInput>;
};

export type VehicleJourneyLogViewModelSortInput = {
  additionalData?: InputMaybe<SortEnumType>;
  cashierShift?: InputMaybe<CashierShiftViewModelSortInput>;
  cashierShiftId?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  eventTime?: InputMaybe<SortEnumType>;
  externalEventId?: InputMaybe<SortEnumType>;
  parkingSession?: InputMaybe<ParkingSessionViewModelSortInput>;
  parkingSessionId?: InputMaybe<SortEnumType>;
  terminal?: InputMaybe<TerminalViewModelSortInput>;
  terminalId?: InputMaybe<SortEnumType>;
  user?: InputMaybe<UserViewModelSortInput>;
  userId?: InputMaybe<SortEnumType>;
  vehicleJourneyEventType?: InputMaybe<VehicleJourneyEventTypeViewModelSortInput>;
  vehicleJourneyEventTypeId?: InputMaybe<SortEnumType>;
  vehicleJourneyLogId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type VehicleJourneyLogsConnection = {
  __typename?: 'VehicleJourneyLogsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<VehicleJourneyLogsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<VehicleJourneyLogViewModel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type VehicleJourneyLogsEdge = {
  __typename?: 'VehicleJourneyLogsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: VehicleJourneyLogViewModel;
};

export type VehicleTypeViewModel = {
  __typename?: 'VehicleTypeViewModel';
  conditionVehicleTypes: Array<ConditionVehicleTypeViewModel>;
  name: Scalars['String255']['output'];
  rateMultiplier: Scalars['PositiveDecimal']['output'];
  vehicleTypeId: Scalars['PositiveInt']['output'];
  vehicles: Array<VehicleViewModel>;
};

export type VehicleTypeViewModelSortInput = {
  name?: InputMaybe<SortEnumType>;
  rateMultiplier?: InputMaybe<SortEnumType>;
  vehicleTypeId?: InputMaybe<SortEnumType>;
};

export type VehicleViewModel = {
  __typename?: 'VehicleViewModel';
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  color?: Maybe<Scalars['String100']['output']>;
  contractVehicles: Array<ContractVehicleViewModel>;
  createdAt: Scalars['DateTime']['output'];
  customer?: Maybe<CustomerViewModel>;
  customerId?: Maybe<Scalars['Ulid']['output']>;
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  isActive: Scalars['Boolean']['output'];
  make?: Maybe<Scalars['String255']['output']>;
  model?: Maybe<Scalars['String255']['output']>;
  parkingSessions: Array<ParkingSessionViewModel>;
  plateNumber?: Maybe<Scalars['String50']['output']>;
  prepaidCardVehicles: Array<PrepaidCardVehicleViewModel>;
  reservations: Array<ReservationViewModel>;
  vehicleId: Scalars['Ulid']['output'];
  vehicleType: VehicleTypeViewModel;
  vehicleTypeId?: Maybe<Scalars['PositiveInt']['output']>;
};

export type VehicleViewModelFilterInput = {
  activatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  and?: InputMaybe<Array<VehicleViewModelFilterInput>>;
  color?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  customerId?: InputMaybe<UlidExtendedFilterInput>;
  deactivatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  make?: InputMaybe<StringOperationFilterInput>;
  model?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<VehicleViewModelFilterInput>>;
  plateNumber?: InputMaybe<StringOperationFilterInput>;
  vehicleId?: InputMaybe<UlidExtendedFilterInput>;
  vehicleTypeId?: InputMaybe<IntOperationFilterInput>;
};

export type VehicleViewModelSortInput = {
  activatedAt?: InputMaybe<SortEnumType>;
  color?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  customer?: InputMaybe<CustomerViewModelSortInput>;
  customerId?: InputMaybe<SortEnumType>;
  deactivatedAt?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  make?: InputMaybe<SortEnumType>;
  model?: InputMaybe<SortEnumType>;
  plateNumber?: InputMaybe<SortEnumType>;
  vehicleId?: InputMaybe<SortEnumType>;
  vehicleType?: InputMaybe<VehicleTypeViewModelSortInput>;
  vehicleTypeId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type VehiclesConnection = {
  __typename?: 'VehiclesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<VehiclesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<VehicleViewModel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type VehiclesEdge = {
  __typename?: 'VehiclesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: VehicleViewModel;
};

export type VoidGuaranteeTransactionInput = {
  guaranteeTransactionId: Scalars['Ulid']['input'];
  idempotencyKey: Scalars['String255']['input'];
  notes?: InputMaybe<Scalars['String1000']['input']>;
  reversesTransactionId: Scalars['Ulid']['input'];
};

export enum VoucherDiscountTypeEnum {
  FixedAmount = 'FIXED_AMOUNT',
  FreeTime = 'FREE_TIME',
  PercentageDiscount = 'PERCENTAGE_DISCOUNT',
  TariffReplacement = 'TARIFF_REPLACEMENT'
}

export type VoucherDiscountTypeEnumOperationFilterInput = {
  eq?: InputMaybe<VoucherDiscountTypeEnum>;
  in?: InputMaybe<Array<VoucherDiscountTypeEnum>>;
  neq?: InputMaybe<VoucherDiscountTypeEnum>;
  nin?: InputMaybe<Array<VoucherDiscountTypeEnum>>;
};

export type VoucherDiscountTypeViewModel = {
  __typename?: 'VoucherDiscountTypeViewModel';
  description?: Maybe<Scalars['String255']['output']>;
  name: Scalars['String50']['output'];
  voucherDiscountTypeId: Scalars['PositiveInt']['output'];
  vouchers: Array<VoucherViewModel>;
};

export type VoucherDiscountTypeViewModelSortInput = {
  description?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  voucherDiscountTypeId?: InputMaybe<SortEnumType>;
};

export type VoucherParkingSessionViewModel = {
  __typename?: 'VoucherParkingSessionViewModel';
  appliedAmount?: Maybe<Scalars['PositiveOrZeroDecimal']['output']>;
  parkingSession: ParkingSessionViewModel;
  parkingSessionId: Scalars['Ulid']['output'];
  redeemedAt: Scalars['DateTime']['output'];
  voucher: VoucherViewModel;
  voucherId: Scalars['Ulid']['output'];
  voucherParkingSessionId: Scalars['Ulid']['output'];
};

export type VoucherViewModel = {
  __typename?: 'VoucherViewModel';
  campaign?: Maybe<CampaignViewModel>;
  campaignId?: Maybe<Scalars['Ulid']['output']>;
  code: Scalars['String255']['output'];
  currentUsageCount: Scalars['PositiveOrZeroInt']['output'];
  customer?: Maybe<CustomerViewModel>;
  customerId?: Maybe<Scalars['Ulid']['output']>;
  dateUsed?: Maybe<Scalars['DateTime']['output']>;
  discountValue?: Maybe<Scalars['Decimal']['output']>;
  facility?: Maybe<FacilityViewModel>;
  facilityId?: Maybe<Scalars['Ulid']['output']>;
  freeTimeMinutes?: Maybe<Scalars['PositiveInt']['output']>;
  isActive: Scalars['Boolean']['output'];
  isAdHoc: Scalars['Boolean']['output'];
  isCustomerSpecific: Scalars['Boolean']['output'];
  maxDiscountAmount?: Maybe<Scalars['Decimal']['output']>;
  name?: Maybe<Scalars['String255']['output']>;
  rate?: Maybe<RateViewModel>;
  rateBindingRequired: Scalars['Boolean']['output'];
  rateId?: Maybe<Scalars['Ulid']['output']>;
  usageLimit?: Maybe<Scalars['PositiveInt']['output']>;
  validUntilDate: Scalars['DateTime']['output'];
  voucherDiscountType: VoucherDiscountTypeViewModel;
  voucherDiscountTypeEnum: VoucherDiscountTypeEnum;
  voucherId: Scalars['Ulid']['output'];
  voucherParkingSessions: Array<VoucherParkingSessionViewModel>;
};

export type VoucherViewModelFilterInput = {
  and?: InputMaybe<Array<VoucherViewModelFilterInput>>;
  campaignId?: InputMaybe<UlidExtendedFilterInput>;
  code?: InputMaybe<StringOperationFilterInput>;
  currentUsageCount?: InputMaybe<IntOperationFilterInput>;
  customerId?: InputMaybe<UlidExtendedFilterInput>;
  dateUsed?: InputMaybe<DateTimeOperationFilterInput>;
  discountValue?: InputMaybe<DecimalOperationFilterInput>;
  facilityId?: InputMaybe<UlidExtendedFilterInput>;
  freeTimeMinutes?: InputMaybe<IntOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  isAdHoc?: InputMaybe<BooleanOperationFilterInput>;
  isCustomerSpecific?: InputMaybe<BooleanOperationFilterInput>;
  maxDiscountAmount?: InputMaybe<DecimalOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<VoucherViewModelFilterInput>>;
  rateBindingRequired?: InputMaybe<BooleanOperationFilterInput>;
  rateId?: InputMaybe<UlidExtendedFilterInput>;
  usageLimit?: InputMaybe<IntOperationFilterInput>;
  validUntilDate?: InputMaybe<DateTimeOperationFilterInput>;
  voucherDiscountTypeEnum?: InputMaybe<VoucherDiscountTypeEnumOperationFilterInput>;
  voucherId?: InputMaybe<UlidExtendedFilterInput>;
};

export type VoucherViewModelSortInput = {
  campaign?: InputMaybe<CampaignViewModelSortInput>;
  campaignId?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  currentUsageCount?: InputMaybe<SortEnumType>;
  customer?: InputMaybe<CustomerViewModelSortInput>;
  customerId?: InputMaybe<SortEnumType>;
  dateUsed?: InputMaybe<SortEnumType>;
  discountValue?: InputMaybe<SortEnumType>;
  facility?: InputMaybe<FacilityViewModelSortInput>;
  facilityId?: InputMaybe<SortEnumType>;
  freeTimeMinutes?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  isAdHoc?: InputMaybe<SortEnumType>;
  isCustomerSpecific?: InputMaybe<SortEnumType>;
  maxDiscountAmount?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  rate?: InputMaybe<RateViewModelSortInput>;
  rateBindingRequired?: InputMaybe<SortEnumType>;
  rateId?: InputMaybe<SortEnumType>;
  usageLimit?: InputMaybe<SortEnumType>;
  validUntilDate?: InputMaybe<SortEnumType>;
  voucherDiscountType?: InputMaybe<VoucherDiscountTypeViewModelSortInput>;
  voucherDiscountTypeEnum?: InputMaybe<SortEnumType>;
  voucherId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type VouchersConnection = {
  __typename?: 'VouchersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<VouchersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<VoucherViewModel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type VouchersEdge = {
  __typename?: 'VouchersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: VoucherViewModel;
};

export type WeeklyDateSetViewModel = {
  __typename?: 'WeeklyDateSetViewModel';
  conditions: Array<ConditionViewModel>;
  name: Scalars['String50']['output'];
  weeklyDateSetId: Scalars['PositiveInt']['output'];
};

export type WeeklyDateSetViewModelSortInput = {
  name?: InputMaybe<SortEnumType>;
  weeklyDateSetId?: InputMaybe<SortEnumType>;
};

export type LoginMutationVariables = Exact<{
  username: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'LoginPayload', success: boolean, error?: string | null | undefined, user?: { __typename?: 'UserInfo', userId?: string | null | undefined, username?: string | null | undefined, email?: string | null | undefined, roles: Array<string>, facilities: Array<{ __typename?: 'UserFacility', facilityId: string, name: string }> } | null | undefined } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: { __typename?: 'LogoutPayload', success: boolean, message: string } };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'CurrentUserPayload', isAuthenticated: boolean, tokenExpiresAt?: string | null | undefined, user?: { __typename?: 'UserInfo', userId?: string | null | undefined, username?: string | null | undefined, email?: string | null | undefined, roles: Array<string>, facilities: Array<{ __typename?: 'UserFacility', facilityId: string, name: string }> } | null | undefined } };

export type ContractsListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ContractsListQuery = { __typename?: 'Query', contracts?: { __typename?: 'ContractsConnection', nodes?: Array<{ __typename?: 'ContractViewModel', contractId: string, contractNumber: string, beginDate: string, endDate: string, amount?: any | null | undefined, simultaneousVehicleLimit?: any | null | undefined, reservedParkingSlots?: any | null | undefined, isActive: boolean, isAutoRenewed: boolean, preferredLanguage?: any | null | undefined, includeAllCustomerVehicles: boolean, vipVehicles: Array<string>, customer: { __typename?: 'CustomerViewModel', customerId: string, firmName?: any | null | undefined, firstName?: any | null | undefined, lastName?: any | null | undefined, isCompany: boolean, customerCategory: { __typename?: 'CustomerCategoryViewModel', description?: any | null | undefined, simultaneousVehicleLimit?: any | null | undefined } }, vehicles: Array<{ __typename?: 'ContractVehicleViewModel', contractId: string, vehicleId: string, vehicle: { __typename?: 'VehicleViewModel', vehicleId: string, plateNumber?: any | null | undefined, make?: any | null | undefined, model?: any | null | undefined, color?: any | null | undefined } }>, cards: Array<{ __typename?: 'ContractCardViewModel', contractCardId: string, facilityId: string, cardType: CardType, cardKey?: any | null | undefined, cardStatusId: CardStatusEnum, depositTransactionId?: string | null | undefined, returnTransactionId?: string | null | undefined }>, parkingSessions: Array<{ __typename?: 'ParkingSessionViewModel', parkingSessionId: string, entryDateTime: string, exitDateTime?: string | null | undefined, status: ParkingSessionStatus }> }> | null | undefined, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null | undefined } } | null | undefined };

export type ContractListItemQueryVariables = Exact<{
  contractId: Scalars['Ulid']['input'];
}>;


export type ContractListItemQuery = { __typename?: 'Query', contract?: { __typename?: 'ContractViewModel', contractId: string, contractNumber: string, beginDate: string, endDate: string, amount?: any | null | undefined, simultaneousVehicleLimit?: any | null | undefined, reservedParkingSlots?: any | null | undefined, isActive: boolean, isAutoRenewed: boolean, preferredLanguage?: any | null | undefined, includeAllCustomerVehicles: boolean, vipVehicles: Array<string>, customer: { __typename?: 'CustomerViewModel', customerId: string, firmName?: any | null | undefined, firstName?: any | null | undefined, lastName?: any | null | undefined, isCompany: boolean, customerCategory: { __typename?: 'CustomerCategoryViewModel', description?: any | null | undefined, simultaneousVehicleLimit?: any | null | undefined }, vehicles: Array<{ __typename?: 'VehicleViewModel', vehicleId: string, plateNumber?: any | null | undefined, make?: any | null | undefined, model?: any | null | undefined, color?: any | null | undefined, vehicleType: { __typename?: 'VehicleTypeViewModel', name: any } }> }, vehicles: Array<{ __typename?: 'ContractVehicleViewModel', contractId: string, vehicleId: string, vehicle: { __typename?: 'VehicleViewModel', vehicleId: string, plateNumber?: any | null | undefined, make?: any | null | undefined, model?: any | null | undefined, color?: any | null | undefined } }>, cards: Array<{ __typename?: 'ContractCardViewModel', contractCardId: string, facilityId: string, cardType: CardType, cardKey?: any | null | undefined, cardStatusId: CardStatusEnum, depositTransactionId?: string | null | undefined, returnTransactionId?: string | null | undefined }>, parkingSessions: Array<{ __typename?: 'ParkingSessionViewModel', parkingSessionId: string, entryDateTime: string, exitDateTime?: string | null | undefined, status: ParkingSessionStatus }> } | null | undefined };

export type ContractDetailQueryVariables = Exact<{
  contractId: Scalars['Ulid']['input'];
}>;


export type ContractDetailQuery = { __typename?: 'Query', contract?: { __typename?: 'ContractViewModel', contractId: string, contractNumber: string, beginDate: string, endDate: string, amount?: any | null | undefined, isAutoRenewed: boolean, simultaneousVehicleLimit?: any | null | undefined, reservedParkingSlots?: any | null | undefined, isActive: boolean, preferredLanguage?: any | null | undefined, includeAllCustomerVehicles: boolean, vipVehicles: Array<string>, customer: { __typename?: 'CustomerViewModel', customerId: string, firmName?: any | null | undefined, firstName?: any | null | undefined, lastName?: any | null | undefined, isCompany: boolean, customerCategory: { __typename?: 'CustomerCategoryViewModel', description?: any | null | undefined, simultaneousVehicleLimit?: any | null | undefined }, vehicles: Array<{ __typename?: 'VehicleViewModel', vehicleId: string, plateNumber?: any | null | undefined, make?: any | null | undefined, model?: any | null | undefined, color?: any | null | undefined, vehicleType: { __typename?: 'VehicleTypeViewModel', name: any } }> }, vehicles: Array<{ __typename?: 'ContractVehicleViewModel', contractId: string, vehicleId: string, vehicle: { __typename?: 'VehicleViewModel', plateNumber?: any | null | undefined, make?: any | null | undefined, model?: any | null | undefined, color?: any | null | undefined, vehicleType: { __typename?: 'VehicleTypeViewModel', name: any } } }>, cards: Array<{ __typename?: 'ContractCardViewModel', contractCardId: string, facilityId: string, cardType: CardType, cardKey?: any | null | undefined, cardStatusId: CardStatusEnum, depositTransactionId?: string | null | undefined, returnTransactionId?: string | null | undefined, depositTransaction?: { __typename?: 'GuaranteeTransactionViewModel', grossAmount?: any | null | undefined } | null | undefined }>, parkingSessions: Array<{ __typename?: 'ParkingSessionViewModel', parkingSessionId: string, entryDateTime: string, exitDateTime?: string | null | undefined, status: ParkingSessionStatus }> } | null | undefined };

export type ContractsPanelByCustomerQueryVariables = Exact<{
  customerId: Scalars['Ulid']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ContractsPanelByCustomerQuery = { __typename?: 'Query', contracts?: { __typename?: 'ContractsConnection', nodes?: Array<{ __typename?: 'ContractViewModel', contractId: string, contractNumber: string, customerId: string, beginDate: string, endDate: string, amount?: any | null | undefined, simultaneousVehicleLimit?: any | null | undefined, isActive: boolean }> | null | undefined, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null | undefined } } | null | undefined };

export type ContractsPanelByVehicleQueryVariables = Exact<{
  vehicleId: Scalars['Ulid']['input'];
}>;


export type ContractsPanelByVehicleQuery = { __typename?: 'Query', vehicle?: { __typename?: 'VehicleViewModel', vehicleId: string, contractVehicles: Array<{ __typename?: 'ContractVehicleViewModel', contractId: string, vehicleId: string, contract: { __typename?: 'ContractViewModel', contractId: string, contractNumber: string, beginDate: string, endDate: string, amount?: any | null | undefined, simultaneousVehicleLimit?: any | null | undefined, isActive: boolean } }> } | null | undefined };

export type CreateContractMutationVariables = Exact<{
  input: CreateContractInput;
}>;


export type CreateContractMutation = { __typename?: 'Mutation', createContract: { __typename?: 'CheckResult', success: boolean, errorCode?: string | null | undefined, errorDescription?: string | null | undefined, isErrored: boolean, failed: boolean } };

export type UpdateContractMutationVariables = Exact<{
  input: UpdateContractInput;
}>;


export type UpdateContractMutation = { __typename?: 'Mutation', updateContract: { __typename?: 'CheckResult', success: boolean, errorCode?: string | null | undefined, errorDescription?: string | null | undefined, isErrored: boolean, failed: boolean } };

export type DeleteContractMutationVariables = Exact<{
  input: DeleteContractInput;
}>;


export type DeleteContractMutation = { __typename?: 'Mutation', deleteContract: { __typename?: 'CheckResult', success: boolean, errorCode?: string | null | undefined, errorDescription?: string | null | undefined, isErrored: boolean, failed: boolean } };

export type ContractsAutocompleteQueryVariables = Exact<{
  where?: InputMaybe<ContractViewModelFilterInput>;
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<ContractViewModelSortInput> | ContractViewModelSortInput>;
}>;


export type ContractsAutocompleteQuery = { __typename?: 'Query', contracts?: { __typename?: 'ContractsConnection', edges?: Array<{ __typename?: 'ContractsEdge', cursor: string, node: { __typename?: 'ContractViewModel', contractId: string, contractNumber: string, isActive: boolean, beginDate: string, endDate: string, customer: { __typename?: 'CustomerViewModel', customerId: string, firmName?: any | null | undefined, firstName?: any | null | undefined, lastName?: any | null | undefined, isCompany: boolean } } }> | null | undefined, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null | undefined } } | null | undefined };

export type ContractEffectiveVehiclesQueryVariables = Exact<{
  contractId: Scalars['Ulid']['input'];
}>;


export type ContractEffectiveVehiclesQuery = { __typename?: 'Query', contract?: { __typename?: 'ContractViewModel', contractId: string, includeAllCustomerVehicles: boolean, customerId: string, effectiveVehicles: Array<{ __typename?: 'VehicleViewModel', vehicleId: string, plateNumber?: any | null | undefined, make?: any | null | undefined, model?: any | null | undefined, color?: any | null | undefined, vehicleType: { __typename?: 'VehicleTypeViewModel', name: any } }> } | null | undefined };

export type CustomersQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomersQuery = { __typename?: 'Query', customers?: { __typename?: 'CustomersConnection', nodes?: Array<{ __typename?: 'CustomerViewModel', customerId: string, firmName?: any | null | undefined, email?: any | null | undefined, customerCategory: { __typename?: 'CustomerCategoryViewModel', description?: any | null | undefined, simultaneousVehicleLimit?: any | null | undefined } }> | null | undefined } | null | undefined };

export type VehiclesQueryVariables = Exact<{ [key: string]: never; }>;


export type VehiclesQuery = { __typename?: 'Query', vehicles?: { __typename?: 'VehiclesConnection', nodes?: Array<{ __typename?: 'VehicleViewModel', vehicleId: string, plateNumber?: any | null | undefined, make?: any | null | undefined, model?: any | null | undefined, color?: any | null | undefined }> | null | undefined } | null | undefined };

export type GuaranteeTransactionsByContractCardQueryVariables = Exact<{
  contractCardId: Scalars['Ulid']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GuaranteeTransactionsByContractCardQuery = { __typename?: 'Query', guaranteeTransactionsByContractCard?: { __typename?: 'GuaranteeTransactionsByContractCardConnection', nodes?: Array<{ __typename?: 'GuaranteeTransactionViewModel', guaranteeTransactionId: string, contractCardId: string, facilityId: string, guaranteeTransactionTypeId: any, grossAmount?: any | null | undefined, netAmount?: any | null | undefined, vatAmount?: any | null | undefined, vatPercentage?: any | null | undefined, createdAt: string, notes?: any | null | undefined, reversesTransactionId?: string | null | undefined, replacedCardId?: string | null | undefined, guaranteeTransactionType: { __typename?: 'GuaranteeTransactionTypeViewModel', guaranteeTransactionTypeId: any, name?: any | null | undefined, involvesCashMovement: boolean, isFiscal: boolean }, processedByUser: { __typename?: 'UserViewModel', userId: string, firstName?: any | null | undefined, lastName?: any | null | undefined }, reversedByTransaction?: { __typename?: 'GuaranteeTransactionViewModel', guaranteeTransactionId: string, createdAt: string } | null | undefined }> | null | undefined, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null | undefined } } | null | undefined };

export type GuaranteeTransactionTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GuaranteeTransactionTypesQuery = { __typename?: 'Query', guaranteeTransactionTypes: Array<{ __typename?: 'GuaranteeTransactionTypeViewModel', guaranteeTransactionTypeId: any, name?: any | null | undefined, involvesCashMovement: boolean, isFiscal: boolean }> };

export type CreateGuaranteeTransactionMutationVariables = Exact<{
  input: CreateGuaranteeTransactionInput;
}>;


export type CreateGuaranteeTransactionMutation = { __typename?: 'Mutation', createGuaranteeTransaction: { __typename?: 'CheckResult', success: boolean, errorCode?: string | null | undefined, errorDescription?: string | null | undefined, isErrored: boolean, failed: boolean } };

export type VoidGuaranteeTransactionMutationVariables = Exact<{
  input: VoidGuaranteeTransactionInput;
}>;


export type VoidGuaranteeTransactionMutation = { __typename?: 'Mutation', voidGuaranteeTransaction: { __typename?: 'CheckResult', success: boolean, errorCode?: string | null | undefined, errorDescription?: string | null | undefined, isErrored: boolean, failed: boolean } };

export type LimitPoliciesQueryVariables = Exact<{
  where?: InputMaybe<LimitPolicyViewModelFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type LimitPoliciesQuery = { __typename?: 'Query', limitPolicies?: { __typename?: 'LimitPoliciesConnection', nodes?: Array<{ __typename?: 'LimitPolicyViewModel', limitPolicyId: string, name: any, priority: any, isActive: boolean, activatedAt?: string | null | undefined, tariffId: string, scenario?: { __typename?: 'ScenarioViewModel', scenarioId: string, name: any } | null | undefined, limit: { __typename?: 'LimitViewModel', limitId: string, minAmount?: any | null | undefined, maxAmount?: any | null | undefined, minStayMinutes?: any | null | undefined, maxStayMinutes?: any | null | undefined }, billingCycle: { __typename?: 'BillingCycleViewModel', billingCycleId: any, name: any } }> | null | undefined, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null | undefined } } | null | undefined };

export type LimitPolicyListItemQueryVariables = Exact<{
  id: Scalars['Ulid']['input'];
}>;


export type LimitPolicyListItemQuery = { __typename?: 'Query', limitPolicy?: { __typename?: 'LimitPolicyViewModel', limitPolicyId: string, name: any, priority: any, isActive: boolean, activatedAt?: string | null | undefined, tariffId: string, scenario?: { __typename?: 'ScenarioViewModel', scenarioId: string, name: any } | null | undefined, limit: { __typename?: 'LimitViewModel', limitId: string, minAmount?: any | null | undefined, maxAmount?: any | null | undefined, minStayMinutes?: any | null | undefined, maxStayMinutes?: any | null | undefined }, billingCycle: { __typename?: 'BillingCycleViewModel', billingCycleId: any, name: any } } | null | undefined };

export type LimitPolicyQueryVariables = Exact<{
  id: Scalars['Ulid']['input'];
}>;


export type LimitPolicyQuery = { __typename?: 'Query', limitPolicy?: { __typename?: 'LimitPolicyViewModel', limitPolicyId: string, name: any, priority: any, isActive: boolean, activatedAt?: string | null | undefined, deactivatedAt?: string | null | undefined, tariffId: string, scenario?: { __typename?: 'ScenarioViewModel', scenarioId: string, name: any } | null | undefined, limit: { __typename?: 'LimitViewModel', limitId: string, minAmount?: any | null | undefined, maxAmount?: any | null | undefined, minStayMinutes?: any | null | undefined, maxStayMinutes?: any | null | undefined }, billingCycle: { __typename?: 'BillingCycleViewModel', billingCycleId: any, name: any } } | null | undefined };

export type CreateLimitPolicyMutationVariables = Exact<{
  input: CreateLimitPolicyInput;
}>;


export type CreateLimitPolicyMutation = { __typename?: 'Mutation', createLimitPolicy: { __typename?: 'CheckResult', success: boolean, errorCode?: string | null | undefined, errorDescription?: string | null | undefined, isErrored: boolean, failed: boolean } };

export type UpdateLimitPolicyMutationVariables = Exact<{
  input: UpdateLimitPolicyInput;
}>;


export type UpdateLimitPolicyMutation = { __typename?: 'Mutation', updateLimitPolicy: { __typename?: 'CheckResult', success: boolean, errorCode?: string | null | undefined, errorDescription?: string | null | undefined, isErrored: boolean, failed: boolean } };

export type DeleteLimitPolicyMutationVariables = Exact<{
  input: DeleteLimitPolicyInput;
}>;


export type DeleteLimitPolicyMutation = { __typename?: 'Mutation', deleteLimitPolicy: { __typename?: 'CheckResult', success: boolean, errorCode?: string | null | undefined, errorDescription?: string | null | undefined, isErrored: boolean, failed: boolean } };

export type FacilitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type FacilitiesQuery = { __typename?: 'Query', facilities?: { __typename?: 'FacilitiesConnection', nodes?: Array<{ __typename?: 'FacilityViewModel', facilityId: string, name?: any | null | undefined }> | null | undefined } | null | undefined };

export type BillingCyclesQueryVariables = Exact<{ [key: string]: never; }>;


export type BillingCyclesQuery = { __typename?: 'Query', billingCycles: Array<{ __typename?: 'BillingCycleViewModel', billingCycleId: any, name: any }> };

export type PricingPoliciesQueryVariables = Exact<{
  where?: InputMaybe<PricingPolicyViewModelFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type PricingPoliciesQuery = { __typename?: 'Query', pricingPolicies?: { __typename?: 'PricingPoliciesConnection', nodes?: Array<{ __typename?: 'PricingPolicyViewModel', pricingPolicyId: string, name: any, priority: any, isActive: boolean, tariffId: string, scenario?: { __typename?: 'ScenarioViewModel', scenarioId: string, name: any } | null | undefined, rate: { __typename?: 'RateViewModel', rateId: string, rateTypeEnum: RateTypeEnum, flatRateAmount?: any | null | undefined, rateSteps: Array<{ __typename?: 'RateStepViewModel', rateStepId: string, intervalMinutes: any, intervalCharge: any, maxIntervals?: any | null | undefined }> }, overstayRate?: { __typename?: 'RateViewModel', rateId: string, rateTypeEnum: RateTypeEnum, flatRateAmount?: any | null | undefined, rateSteps: Array<{ __typename?: 'RateStepViewModel', rateStepId: string, intervalMinutes: any, intervalCharge: any, maxIntervals?: any | null | undefined }> } | null | undefined, limit?: { __typename?: 'LimitViewModel', limitId: string, minAmount?: any | null | undefined, maxAmount?: any | null | undefined, minStayMinutes?: any | null | undefined, maxStayMinutes?: any | null | undefined } | null | undefined, billingCycle: { __typename?: 'BillingCycleViewModel', billingCycleId: any, name: any } }> | null | undefined, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null | undefined } } | null | undefined };

export type PricingPolicyQueryVariables = Exact<{
  id: Scalars['Ulid']['input'];
}>;


export type PricingPolicyQuery = { __typename?: 'Query', pricingPolicy?: { __typename?: 'PricingPolicyViewModel', pricingPolicyId: string, name: any, priority: any, isActive: boolean, tariffId: string, activatedAt?: string | null | undefined, deactivatedAt?: string | null | undefined, scenario?: { __typename?: 'ScenarioViewModel', scenarioId: string, name: any } | null | undefined, rate: { __typename?: 'RateViewModel', rateId: string, rateTypeEnum: RateTypeEnum, flatRateAmount?: any | null | undefined, rateSteps: Array<{ __typename?: 'RateStepViewModel', rateStepId: string, stepSequence: any, intervalMinutes: any, intervalCharge: any, maxIntervals?: any | null | undefined }> }, overstayRate?: { __typename?: 'RateViewModel', rateId: string, rateTypeEnum: RateTypeEnum, flatRateAmount?: any | null | undefined, rateSteps: Array<{ __typename?: 'RateStepViewModel', rateStepId: string, stepSequence: any, intervalMinutes: any, intervalCharge: any, maxIntervals?: any | null | undefined }> } | null | undefined, limit?: { __typename?: 'LimitViewModel', limitId: string, minAmount?: any | null | undefined, maxAmount?: any | null | undefined, minStayMinutes?: any | null | undefined, maxStayMinutes?: any | null | undefined } | null | undefined, billingCycle: { __typename?: 'BillingCycleViewModel', billingCycleId: any, name: any } } | null | undefined };

export type DeletePricingPolicyMutationVariables = Exact<{
  input: DeletePricingPolicyInput;
}>;


export type DeletePricingPolicyMutation = { __typename?: 'Mutation', deletePricingPolicy: { __typename?: 'CheckResult', success: boolean, errorCode?: string | null | undefined, errorDescription?: string | null | undefined, isErrored: boolean, failed: boolean } };

export type CreatePricingPolicyMutationVariables = Exact<{
  input: CreatePricingPolicyInput;
}>;


export type CreatePricingPolicyMutation = { __typename?: 'Mutation', createPricingPolicy: { __typename?: 'CheckResult', success: boolean, errorCode?: string | null | undefined, errorDescription?: string | null | undefined, isErrored: boolean, failed: boolean } };

export type UpdatePricingPolicyMutationVariables = Exact<{
  input: UpdatePricingPolicyInput;
}>;


export type UpdatePricingPolicyMutation = { __typename?: 'Mutation', updatePricingPolicy: { __typename?: 'CheckResult', success: boolean, errorCode?: string | null | undefined, errorDescription?: string | null | undefined, isErrored: boolean, failed: boolean } };

export type ReportCatalogQueryVariables = Exact<{ [key: string]: never; }>;


export type ReportCatalogQuery = { __typename?: 'Query', reportCatalog: Array<{ __typename?: 'ReportGroupViewModel', reportGroupId: string, key: string, title: string, icon?: string | null | undefined, sortOrder: number, reports: Array<{ __typename?: 'ReportDefinitionViewModel', reportDefinitionId: string, key: string, title: string, description: string, sortOrder: number }> }> };

export type ReportDefinitionQueryVariables = Exact<{
  reportKey: Scalars['String']['input'];
}>;


export type ReportDefinitionQuery = { __typename?: 'Query', reportDefinition?: { __typename?: 'ReportDefinitionViewModel', reportDefinitionId: string, reportGroupId: string, key: string, title: string, description: string, graphQlQuery?: string | null | undefined, graphQlVariablesJson?: string | null | undefined, resultArrayPath: string, sortOrder: number, isAvailableToAllFacilities: boolean, requiredPermission?: string | null | undefined, exportFormats: Array<string>, columns: Array<{ __typename?: 'ReportColumnViewModel', reportColumnId: string, key: string, label: string, dataType: string, graphQlFieldPath: string, visibleByDefault: boolean, sortable: boolean, filterable: boolean, groupable: boolean, format?: string | null | undefined, aggregationType?: ColumnAggregationType | null | undefined, alignment: ColumnAlignment, width?: string | null | undefined, conditionalFormatJson?: string | null | undefined, sortOrder: number }>, filters: Array<{ __typename?: 'ReportFilterViewModel', reportFilterId: string, key: string, label: string, type: string, required: boolean, defaultValue?: string | null | undefined, operators: Array<string>, dependsOnFilterKey?: string | null | undefined, optionsSourceJson?: string | null | undefined, sortOrder: number, options: Array<{ __typename?: 'ReportFilterOptionViewModel', value: string, label: string }> }>, groupings: Array<{ __typename?: 'ReportGroupingViewModel', reportGroupingId: string, key: string, label: string, columnKeys: Array<string>, sortOrder: number }>, defaultSorts: Array<{ __typename?: 'ReportSortViewModel', reportSortId: string, columnKey: string, direction: string, sortOrder: number }> } | null | undefined };

export type CreateScenarioMutationVariables = Exact<{
  input: CreateScenarioInput;
}>;


export type CreateScenarioMutation = { __typename?: 'Mutation', createScenario: { __typename?: 'CheckResult', success: boolean, errorCode?: string | null | undefined, errorDescription?: string | null | undefined } };

export type ScenariosQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ScenariosQuery = { __typename?: 'Query', scenarios?: { __typename?: 'ScenariosConnection', nodes?: Array<{ __typename?: 'ScenarioViewModel', scenarioId: string, name: any, scenarioConditions: Array<{ __typename?: 'ScenarioConditionViewModel', conditionId: string, condition: { __typename?: 'ConditionViewModel', conditionId: string } }> }> | null | undefined, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null | undefined } } | null | undefined };

export type VehicleTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type VehicleTypesQuery = { __typename?: 'Query', vehicleTypes: Array<{ __typename?: 'VehicleTypeViewModel', vehicleTypeId: any, name: any, rateMultiplier: any }> };

export type CustomerCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerCategoriesQuery = { __typename?: 'Query', customerCategories: Array<{ __typename?: 'CustomerCategoryViewModel', customerCategoryId: string, code?: any | null | undefined, description?: any | null | undefined, simultaneousVehicleLimit?: any | null | undefined }> };

export type WeeklyDateSetsQueryVariables = Exact<{ [key: string]: never; }>;


export type WeeklyDateSetsQuery = { __typename?: 'Query', weeklyDateSets: Array<{ __typename?: 'WeeklyDateSetViewModel', weeklyDateSetId: any, name: any }> };

export type PaymentMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentMethodsQuery = { __typename?: 'Query', paymentMethods: Array<{ __typename?: 'PaymentMethodViewModel', paymentMethodId?: any | null | undefined, name?: any | null | undefined }> };

export type ConditionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ConditionsQuery = { __typename?: 'Query', conditions?: { __typename?: 'ConditionsConnection', nodes?: Array<{ __typename?: 'ConditionViewModel', conditionId: string, startDate?: string | null | undefined, endDate?: string | null | undefined, arrivingSince?: string | null | undefined, arrivingUntil?: string | null | undefined, leavingSince?: string | null | undefined, leavingUntil?: string | null | undefined, weeklyDateSetId: any, appliesOnHolidays: boolean, minStayMinutes?: any | null | undefined, maxStayMinutes?: any | null | undefined, appliesToSpecificVehicleTypes: boolean, appliesToSpecificCustomerCategories: boolean, isOverstay: boolean, isContractOverstay: boolean, appliesToSpecificPaymentMethods: boolean, weeklyDateSet: { __typename?: 'WeeklyDateSetViewModel', weeklyDateSetId: any, name: any }, conditionVehicleTypes: Array<{ __typename?: 'ConditionVehicleTypeViewModel', vehicleTypeId: any, vehicleType: { __typename?: 'VehicleTypeViewModel', vehicleTypeId: any, name: any } }>, conditionCustomerCategories: Array<{ __typename?: 'ConditionCustomerCategoryViewModel', customerCategoryId: string, customerCategory: { __typename?: 'CustomerCategoryViewModel', customerCategoryId: string, description?: any | null | undefined } }>, conditionDayOfWeeks: Array<{ __typename?: 'ConditionDayOfWeekViewModel', dayOfWeekId: any, dayOfWeek: { __typename?: 'DayOfWeekViewModel', dayOfWeekId?: any | null | undefined, name?: any | null | undefined } }>, conditionPaymentMethods: Array<{ __typename?: 'ConditionPaymentMethodViewModel', paymentMethodId: any, paymentMethod: { __typename?: 'PaymentMethodViewModel', paymentMethodId?: any | null | undefined, name?: any | null | undefined } }> }> | null | undefined } | null | undefined };

export type ScenarioListItemQueryVariables = Exact<{
  id: Scalars['Ulid']['input'];
}>;


export type ScenarioListItemQuery = { __typename?: 'Query', scenario?: { __typename?: 'ScenarioViewModel', scenarioId: string, name: any, scenarioConditions: Array<{ __typename?: 'ScenarioConditionViewModel', conditionId: string, condition: { __typename?: 'ConditionViewModel', conditionId: string } }> } | null | undefined };

export type ScenarioQueryVariables = Exact<{
  id: Scalars['Ulid']['input'];
}>;


export type ScenarioQuery = { __typename?: 'Query', scenario?: { __typename?: 'ScenarioViewModel', scenarioId: string, name: any, scenarioConditions: Array<{ __typename?: 'ScenarioConditionViewModel', conditionId: string, condition: { __typename?: 'ConditionViewModel', conditionId: string, startDate?: string | null | undefined, endDate?: string | null | undefined, arrivingSince?: string | null | undefined, arrivingUntil?: string | null | undefined, leavingSince?: string | null | undefined, leavingUntil?: string | null | undefined, weeklyDateSetId: any, appliesOnHolidays: boolean, minStayMinutes?: any | null | undefined, maxStayMinutes?: any | null | undefined, appliesToSpecificVehicleTypes: boolean, appliesToSpecificCustomerCategories: boolean, isOverstay: boolean, isContractOverstay: boolean, appliesToSpecificPaymentMethods: boolean, weeklyDateSet: { __typename?: 'WeeklyDateSetViewModel', name: any }, conditionVehicleTypes: Array<{ __typename?: 'ConditionVehicleTypeViewModel', vehicleTypeId: any, vehicleType: { __typename?: 'VehicleTypeViewModel', name: any } }>, conditionCustomerCategories: Array<{ __typename?: 'ConditionCustomerCategoryViewModel', customerCategoryId: string, customerCategory: { __typename?: 'CustomerCategoryViewModel', description?: any | null | undefined } }>, conditionDayOfWeeks: Array<{ __typename?: 'ConditionDayOfWeekViewModel', dayOfWeekId: any, dayOfWeek: { __typename?: 'DayOfWeekViewModel', name?: any | null | undefined } }>, conditionPaymentMethods: Array<{ __typename?: 'ConditionPaymentMethodViewModel', paymentMethodId: any, paymentMethod: { __typename?: 'PaymentMethodViewModel', paymentMethodId?: any | null | undefined, name?: any | null | undefined } }> } }> } | null | undefined };

export type UpdateScenarioMutationVariables = Exact<{
  input: UpdateScenarioInput;
}>;


export type UpdateScenarioMutation = { __typename?: 'Mutation', updateScenario: { __typename?: 'CheckResult', success: boolean, errorCode?: string | null | undefined, errorDescription?: string | null | undefined, isErrored: boolean, failed: boolean } };

export type DeleteScenarioMutationVariables = Exact<{
  input: DeleteScenarioInput;
}>;


export type DeleteScenarioMutation = { __typename?: 'Mutation', deleteScenario: { __typename?: 'CheckResult', success: boolean, errorCode?: string | null | undefined, errorDescription?: string | null | undefined, isErrored: boolean, failed: boolean } };

export type TariffNameQueryVariables = Exact<{
  id: Scalars['Ulid']['input'];
}>;


export type TariffNameQuery = { __typename?: 'Query', tariff?: { __typename?: 'TariffViewModel', tariffId: string, name: any } | null | undefined };

export type TariffListItemQueryVariables = Exact<{
  id: Scalars['Ulid']['input'];
}>;


export type TariffListItemQuery = { __typename?: 'Query', tariff?: { __typename?: 'TariffViewModel', tariffId: string, name: any, version?: any | null | undefined, description?: any | null | undefined, status: any, needsVerification: boolean, createdAt: string, mainInFacility?: { __typename?: 'FacilityViewModel', facilityId: string } | null | undefined } | null | undefined };

export type TariffsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type TariffsQuery = { __typename?: 'Query', tariffs?: { __typename?: 'TariffsConnection', nodes?: Array<{ __typename?: 'TariffViewModel', tariffId: string, name: any, version?: any | null | undefined, description?: any | null | undefined, status: any, needsVerification: boolean, createdAt: string, mainInFacility?: { __typename?: 'FacilityViewModel', facilityId: string } | null | undefined }> | null | undefined, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null | undefined } } | null | undefined };

export type SetMainTariffMutationVariables = Exact<{
  input: SetMainTariffInput;
}>;


export type SetMainTariffMutation = { __typename?: 'Mutation', setMainTariff: { __typename?: 'CheckResult', success: boolean, errorCode?: string | null | undefined, errorDescription?: string | null | undefined, isErrored: boolean, failed: boolean } };

export type TariffQueryVariables = Exact<{
  id: Scalars['Ulid']['input'];
}>;


export type TariffQuery = { __typename?: 'Query', tariff?: { __typename?: 'TariffViewModel', tariffId: string, name: any, version?: any | null | undefined, description?: any | null | undefined, status: any, sourceTariffId?: string | null | undefined, entryGracePeriodMinutes: any, postPaymentGraceMinutes: any, freeExitMinutes: any, lostTicketFixedCharge?: any | null | undefined, lostTicketRateId?: string | null | undefined, reEntryChargeRateId?: string | null | undefined, needsVerification: boolean, verificationReason?: any | null | undefined, verificationFlaggedAt?: string | null | undefined, createdAt: string, updatedAt: string, activatedAt?: string | null | undefined, deactivatedAt?: string | null | undefined, facility: { __typename?: 'FacilityViewModel', name?: any | null | undefined }, sourceTariff?: { __typename?: 'TariffViewModel', tariffId: string, name: any } | null | undefined, lostTicketRate?: { __typename?: 'RateViewModel', rateId: string, rateTypeEnum: RateTypeEnum, flatRateAmount?: any | null | undefined } | null | undefined, reEntryChargeRate?: { __typename?: 'RateViewModel', rateId: string, rateTypeEnum: RateTypeEnum, flatRateAmount?: any | null | undefined } | null | undefined, createdByUser: { __typename?: 'UserViewModel', userId: string, firstName?: any | null | undefined, lastName?: any | null | undefined }, pricingPolicies: Array<{ __typename?: 'PricingPolicyViewModel', pricingPolicyId: string, name: any }>, limitPolicies: Array<{ __typename?: 'LimitPolicyViewModel', limitPolicyId: string, name: any }>, mainInFacility?: { __typename?: 'FacilityViewModel', facilityId: string } | null | undefined } | null | undefined };

export type CreateTariffMutationVariables = Exact<{
  input: CreateTariffInput;
}>;


export type CreateTariffMutation = { __typename?: 'Mutation', createTariff: { __typename?: 'CheckResult', success: boolean, errorCode?: string | null | undefined, errorDescription?: string | null | undefined, isErrored: boolean, failed: boolean } };

export type UpdateTariffMutationVariables = Exact<{
  input: UpdateTariffInput;
}>;


export type UpdateTariffMutation = { __typename?: 'Mutation', updateTariff: { __typename?: 'CheckResult', success: boolean, errorCode?: string | null | undefined, errorDescription?: string | null | undefined, isErrored: boolean, failed: boolean } };
